/* eslint-disable no-case-declarations */
import json from "../json/data.json";
import utility from "../lib/utility.js";
import { MessageBox } from "element-ui";
import { reportG2 } from "./../services/reportG2.service";
import { Operator_service } from "../services/Operator_service";
import { Typegroup_service } from "../services/Typegroup.service";
import moment from "moment"

const month_th = [
    "มกราคม",
    "กุมภาพันธ์",
    "มีนาคม",
    "เมษายน",
    "พฤษภาคม",
    "มิถุนายน ",
    "กรกฎาคม",
    "สิงหาคม",
    "กันยายน",
    "ตุลาคม",
    "พฤศจิกายน",
    "ธันวาคม"
]
const service_th = {
    Voice : 'บริการประเภทเสียง',
    SMS : 'บริการข้อความ SMS',
    MMS : 'บริการรูปภาพ MMS',
    Internet : 'บริการอินเทอร์เน็ต',
    All : 'บริการประเภทเสียง บริการข้อความ SMS บริการรูปภาพ MMS และบริการอินเทอร์เน็ต'
}
const state = {
    provider_group : [],
    provider_list : [],
    charts : {
        unit : {
            chart: {
                type: 'column'
            },
            title: {
                text: ''
            },
            subtitle: {
                text: ''
            },
            xAxis: {
                categories: ['Jan'],
                crosshair: true
            },
            yAxis: {
                min: 0,
                tickInterval:0.25,
                title: {
                    text: 'อัตราเฉลี่ย'
                }
            },
            tooltip: {
                headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
                pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
                    '<td style="padding:0"><b>{point.y:.3f}</b></td></tr>',
                footerFormat: '</table>',
                shared: true,
                useHTML: true,
                valueDecimals: 2,
            },
            plotOptions: {
                column: {
                    pointPadding: 0.2,
                    borderWidth: 0,
                    allowPointSelect: true,
                    cursor: 'pointer',
                    dataLabels: {
                        enabled: false
                    },
                    showInLegend: true
                }
            },
            series: [{
                name: '',
                data: [],
                shared: true,
            }],
            credits: {
                enabled: false
            }
        },
        voice : {
            chart: {
                id: 'voice',
                type: 'column'
            },
            title: {
                text: ''
            },
            subtitle: {
                text: ''
            },
            xAxis: {
                categories: [""],
                crosshair: true
            },
            yAxis: {
                min: 0,
                tickInterval:0.1,
                title: {
                    text: 'Voice (บาท/นาที)'
                }
            },
            tooltip: {
                headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
                pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
                    '<td style="padding:0"><b>{point.y:.3f}</b></td></tr>',
                footerFormat: '</table>',
                shared: false,
                useHTML: true,
                valueDecimals: 2,
            },
            plotOptions: {
                column: {
                    pointPadding: 0.2,
                    borderWidth: 0,
                    allowPointSelect: true,
                    cursor: 'pointer',
                    dataLabels: {
                        enabled: false
                    },
                    showInLegend: true
                }
            },
            series: [{
                name: '',
                data: [],
                shared: true,
            }],
            credits: {
                enabled: false
            }
        },
        sms : {
            chart: {
                id: 'sms',
                type: 'column'
            },
            title: {
                text: ''
            },
            subtitle: {
                text: ''
            },
            xAxis: {
                categories: [],
                crosshair: true
            },
            yAxis: {
                min: 0,
                tickInterval:0.1,
                title: {
                    text: 'อัตราค่าบริการเฉลี่ยของบริการ SMS '
                }
            },
            tooltip: {
                headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
                pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
                    '<td style="padding:0"><b>{point.y:.3f}</b></td></tr>',
                footerFormat: '</table>',
                shared: true,
                useHTML: true,
                valueDecimals: 2,
            },
            plotOptions: {
                column: {
                    pointPadding: 0.2,
                    borderWidth: 0,
                    allowPointSelect: true,
                    cursor: 'pointer',
                    dataLabels: {
                        enabled: false
                    },
                    showInLegend: true
                }
            },
            series: [{
                name: '',
                data: [],
                shared: true,
            }],
            credits: {
                enabled: false
            }
        },
        mms : {
            chart: {
                id: 'mms',
                type: 'column'
            },
            title: {
                text: ''
            },
            subtitle: {
                text: ''
            },
            xAxis: {
                categories: [],
                crosshair: true
            },
            yAxis: {
                min: 0,
                tickInterval:0.1,
                title: {
                    text: 'อัตราค่าบริการเฉลี่ยของบริการ MMS '
                }
            },
            tooltip: {
                headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
                pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
                    '<td style="padding:0"><b>{point.y:.3f}</b></td></tr>',
                footerFormat: '</table>',
                shared: true,
                useHTML: true,
                valueDecimals: 2,
            },
            plotOptions: {
                column: {
                    pointPadding: 0.2,
                    borderWidth: 0,
                    allowPointSelect: true,
                    cursor: 'pointer',
                    dataLabels: {
                        enabled: false
                    },
                    showInLegend: true
                }
            },
            series: [{
                name: '',
                data: [],
                shared: true,
            }],
            credits: {
                enabled: false
            }
        },
        internet : {
            chart: {
                id: 'internet',
                type: 'column'
            },
            title: {
                text: ''
            },
            subtitle: {
                text: ''
            },
            xAxis: {
                categories: [],
                crosshair: true
            },
            yAxis: {
                min: 0,
                tickInterval:0.05,
                title: {
                    text: 'อัตราค่าบริการเฉลี่ยของบริการ Internet'
                }
            },
            tooltip: {
                headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
                pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
                    '<td style="padding:0"><b>{point.y:.3f}</b></td></tr>',
                footerFormat: '</table>',
                shared: true,
                useHTML: true,
                valueDecimals: 2,
            },
            plotOptions: {
                column: {
                    pointPadding: 0.2,
                    borderWidth: 0,
                    allowPointSelect: true,
                    cursor: 'pointer',
                    dataLabels: {
                        enabled: false
                    },
                    showInLegend: true
                }
            },
            series: [{
                name: '',
                data: [],
                shared: true,
            }],
            credits: {
                enabled: false
            }
        },
    },
    chartResult: true,
    dataTable: [],
    serviceTable: [],
    chartOptions: {
        chart: {
            type: "column"
        },
        title: {
            text: ""
        },
        xAxis: {
            categories: [],
            crosshair: true
        },
        yAxis: {
            plotLines: [
                // {
                //     value: 3,
                //     color: "#ff0000",
                //     width: 2,
                //     zIndex: 4,
                //     dashStyle: "Solid",
                //     label: {
                //         text: "goal"
                //     }
                // },
                // {
                //     value: 2,
                //     color: "#ff0000",
                //     width: 2,
                //     zIndex: 4,
                //     dashStyle: "ShortDash",
                //     label: {
                //         text: "goal"
                //     }
                // }
            ],
            min: 0,
            title: {
                text: "หน่วย (บาท)"
            }
        },
        tooltip: {
            headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
            pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
                '<td style="padding:0"><b>{point.y} mm</b></td></tr>',
            footerFormat: "</table>",
            shared: true,
            useHTML: true
        },
        plotOptions: {
            column: {
                pointPadding: 0.2,
                borderWidth: 0
            }
        },
        series: [
            //     {
            //     color: "black",
            //     name: "Tokyo",
            //     data: [
            //         50,
            //     ]
            // }
        ]
    },
    datasets: [],
    options: {},
    serviceType: {
        all: "",
        voice: "Voice (บาท/นาที)",
        sms: "SMS (บาท/ข้อความ)",
        mms: "MMS (บาท/ข้อความ)",
        data: "Internet (บาท/MB)"
    },
    main_proportion: 0,
    ontop_proportion: 0,
    showDataNotFound: false,
}
const actions = {
    async getGroupCompany({commit},type){
        let obj = { provider_type : type}
        let result = await Typegroup_service.getGroupList(obj)
        if(result.status === 200){
          commit('PROVIDER_GROUP',result.data)
        }else {
          MessageBox.confirm(result.message, 'แจ้งเตือน', {
              confirmButtonText: 'ตกลง',
              showCancelButton: false,
              type: 'warning'
          })
        }
    },
    async getProviderByType({commit},type){
    let result = await Operator_service.getProviderList(type)
    if(result.status === 200){
        commit('PROVIDER_LIST',result.data)
    }else {
        MessageBox.confirm(result.message, 'แจ้งเตือน', {
            confirmButtonText: 'ตกลง',
            showCancelButton: false,
            type: 'warning'
        })
    }
    },
    async setChartData({commit},formdata){
        let result = await reportG2.getReportData(formdata)
        let resultFixed = await reportG2.getMobileAvgFixed(formdata)
        if(result.status === 200 && resultFixed.status === 200){
            if(result.data[0].length == '' && resultFixed.data.length == ''){
                state.chartResult = false
                state.showDataNotFound = true
            }else {
                state.main_proportion = result.data[2][0].proportion_main_promotion
                state.ontop_proportion = result.data[2][0].proportion_ontop_promotion
                state.chartResult = true
                state.showDataNotFound = false
                switch (formdata.type_report){
                    case 'month' :
                        let obj = {
                            forminfo : formdata,
                            qrydata : result.data[0],
                            fixdata: resultFixed.data,
                            serviceRate: result.data[1],
                        }
                        commit('MONTH',obj)
                        break
                    case 'year' :
                        let temp = moment(formdata.type_data.year,'YYYY-MM-DD').add(1,'Y')._d
                        obj = {
                            forminfo : formdata,
                            qrydata : result.data[0],
                            fixdata: resultFixed.data,
                            serviceRate: result.data[1],
                            date : {
                                start : moment(formdata.type_data.year,'YYYY-MM-DD')._d ,
                                end : moment(temp).subtract(1,'seconds')._d
                            }
                        }
                        commit('YEAR',obj)
                        break
                    case 'between_month' :
                        temp = moment(formdata.type_data.monthto).add(1,'M')._d
                        obj = {
                            date : {
                                start : formdata.type_data.monthfrom,
                                end : moment(temp).subtract(1,'seconds')._d
                            },
                            forminfo : formdata,
                            qrydata : result.data[0],
                            fixdata: resultFixed.data,
                            serviceRate: result.data[1],
                        }
                        commit('BETWEEN_MONTH',obj)
                        break
                    case 'between_year' :
                        temp = moment(formdata.type_data.yearto).add(1,'Y')._d
                        obj = {
                            date : {
                                start : formdata.type_data.yearfrom,
                                end : moment(temp).subtract(1,'seconds')._d
                            },
                            forminfo : formdata,
                            qrydata : result.data[0],
                            fixdata: resultFixed.data,
                            serviceRate: result.data[1],
                        }
                        commit('BETWEEN_YEAR',obj)
                        break
                    case 'quarter' :
                        obj = {
                            date : {
                                start : moment(formdata.type_data.quarter_year).add((formdata.type_data.quarter*3)-3,'Month')._d,
                                end : moment(formdata.type_data.quarter_year).add(formdata.type_data.quarter*3,'Month')._d
                            },
                            forminfo : formdata,
                            qrydata : result.data[0],
                            fixdata: resultFixed.data,
                            serviceRate: result.data[1],
                        }
                        commit('QUARTER', obj)
                        break
                    case 'between_quarter' :
                        obj = {
                            date : {
                                start : moment(formdata.type_data.quarter_year_from).add((formdata.type_data.quarterfrom*3)-3,'Month')._d,
                                end : moment(formdata.type_data.quarter_year).add(formdata.type_data.quarterto*3,'Month')._d
                            },
                            forminfo : formdata,
                            qrydata : result.data[0],
                            fixdata: resultFixed.data,
                            serviceRate: result.data[1],
                        }
                        commit('BETWEEN_QUARTER',obj)
                        break
                }
            }
            
        }else {
          state.showDataNotFound = true
        }
    },
    async generate({commit}, formdata){
        let result = await reportG2.getAllReportData(formdata)
        if(result.status === 200){
            let temp = {
                Voice : [],
                SMS : [],
                MMS : [],
                Internet : []
            }
            let daterange = result.data.pop()
            for(let qrydata of result.data){
                if(Object.keys(qrydata) == 'old_data'){
                    let start = daterange[0]
                    let end = daterange[1] < '2018-01-01' ? daterange[1] : '2017-12-01'
                    switch(formdata.type_report){
                        case 'month' :
                        case 'between_month' :
                            if(formdata.distinguish == 2){// NOT CLASSIFY
                                for(let row of qrydata.old_data){
                                    temp[moment(row.monthly_regulate).format('MM/YYYY')] 
                                    ? temp[moment(row.monthly_regulate).format('MM/YYYY')].push(row) 
                                    : temp[moment(row.monthly_regulate).format('MM/YYYY')] = [row]
                                }
                                temp.categories = []
                                for(let i = start,j = end ; moment(i,'YYYY-MM-DD') <= moment(j,'YYYY-MM-DD') ; i = moment(i,'YYYY-MM-DD').add(1,'M').format('YYYY-MM-DD')){
                                    let monthdata = {
                                        Voice : 0,
                                        Voice_count : 0,
                                        SMS : 0,
                                        SMS_count : 0,
                                        MMS : 0,
                                        MMS_count : 0,
                                        Internet :0,
                                        Internet_count : 0
                                    }
                                    for(let item of temp[moment(i,'YYYY-MM-DD').format('MM/YYYY')]){
                                        monthdata[item.service_type] += (item.price_avg ? item.price_avg : 0)
                                        monthdata[item.service_type+'_count'] += (item.price_avg ? 1 : 0)
                                    }
                                    temp.Voice.push(parseFloat((monthdata.Voice/monthdata.Voice_count).toFixed(2)))
                                    temp.SMS.push(parseFloat((monthdata.SMS/monthdata.SMS_count).toFixed(2)))
                                    temp.MMS.push(parseFloat((monthdata.MMS/monthdata.MMS_count).toFixed(2)))
                                    temp.Internet.push(parseFloat((monthdata.Internet/monthdata.Internet_count).toFixed(2)))
                                    temp.categories.push(moment(i,'YYYY-MM-DD').format('MM/YYYY'))
                                }
                            }else{ // CLASSIFY BY PROVIDER
                                for(let item of qrydata.old_data){

                                }
                            }

                            temp.date_text = formdata.type_report == 'month' 
                                            ? ' เดือน'+month_th[moment(start,'YYYY-MM-DD').month()]+' ปี พ.ศ. '+parseInt(0+moment(start,'YYYY-MM-DD').year()+543)
                                            : ' เดือน'+month_th[moment(start,'YYYY-MM-DD').month()]+' ปี พ.ศ. '+parseInt(0+moment(start,'YYYY-MM-DD').year()+543)
                                            + ' ถึงเดือน'+month_th[moment(end,'YYYY-MM-DD').month()]+' ปี พ.ศ. '+parseInt(0+moment(end,'YYYY-MM-DD').year()+543)
                            temp.service_text = formdata.typeService ? service_th[formdata.typeService] : service_th['All']
                            temp.title = "ภาพรวมอัตราค่าบริการเฉลี่ย"+temp.service_text+temp.date_text
                            temp.yAxis = "อัตราค่าบริการเฉลี่ย (บาท)"
                            temp.series = formdata.typeService 
                                        ? [{name : formdata.typeService, data : temp[formdata.typeService]}]
                                        : [{name : 'Voice',data : temp.Voice},{name : 'SMS',data : temp.SMS},{name : 'MMS',data : temp.MMS},{name : 'Internet',data : temp.Internet}]
                            break
                    }
                }else if(Object.keys(qrydata) == 'new_data'){
                    console.log(qrydata)
                }
            }
            console.log(temp)
            commit('SET_NOT_CLASSIFY_CHART',temp)
        }else{
            commit('DATA_NOT_FOUND',true)
        }
    }
}

const mutations = {
  PROVIDER_GROUP(state,data){
    state.provider_group = data
  },
  PROVIDER_LIST(state,data){
    state.provider_list = data
  },
  MONTH(state,obj){
    let date = obj.forminfo.type_data.month
    let month = parseInt(moment(new Date(date)).format("MM"))
    let year = parseInt(moment(new Date(date)).format("YYYY"))+543
    let yearData = parseInt(moment(new Date(date)).format("YYYY"))
    let forminfo = obj.forminfo
    
    // state.charts.unit.xAxis.categories = month
    state.charts.unit.series = []
    state.charts.voice.series = []
    state.charts.sms.series = []
    state.charts.mms.series = []
    state.charts.internet.series = []
    
    state.charts.unit.xAxis.categories = ["เดือน"+month_th[month-1]]
    state.charts.voice.xAxis.categories = [month_th[month-1]]
    state.charts.sms.xAxis.categories = [month_th[month-1]]
    state.charts.mms.xAxis.categories = [month_th[month-1]]
    state.charts.internet.xAxis.categories = [month_th[month-1]]
    let graphLine_text = obj.forminfo.graphLine ? " และเปรียบเทียบกับอัตราอ้างอิงบนคลื่นความถี่ 2.1 GHz" : ""
    let distinguish_text = obj.forminfo.distinguish == 1 ? "จำแนกตาม" : "ของ"
    state.charts.unit.title.text = "ภาพรวมอัตราค่าบริการเฉลี่ยของบริการ ประเภทเสียง บริการ SMS/MMS และ บริการ Internet ของผู้ให้บริการโทรศัพท์เคลื่อนที่เดือน "+month_th[month-1]+" ปี พ.ศ. "+year
    state.charts.voice.title.text = "อัตราค่าบริการเฉลี่ยของบริการประเภทเสียง "+distinguish_text+"ผู้ให้บริการโทรศัพท์เคลื่อนที่เดือน "+month_th[month-1]+" ปี พ.ศ. "+year+graphLine_text
    state.charts.sms.title.text = "อัตราค่าบริการเฉลี่ยของบริการ SMS "+distinguish_text+"ผู้ให้บริการโทรศัพท์เคลื่อนที่เดือน "+month_th[month-1]+" ปี พ.ศ. "+year+graphLine_text
    state.charts.mms.title.text = "อัตราค่าบริการเฉลี่ยของบริการ MMS "+distinguish_text+"ผู้ให้บริการโทรศัพท์เคลื่อนที่เดือน "+month_th[month-1]+" ปี พ.ศ. "+year+graphLine_text
    state.charts.internet.title.text = "อัตราค่าบริการเฉลี่ยของบริการ Internet "+distinguish_text+"ผู้ให้บริการโทรศัพท์เคลื่อนที่เดือน "+month_th[month-1]+" ปี พ.ศ. "+year+graphLine_text
    // state.charts.voice.yAxis.title.text = "Voice (บาท/นาที)"
    // console.log(state.charts.voice.yAxis.title)
    state.charts.unit.yAxis = []
    state.charts.unit.yAxis.push({
        min: 0,
        title: {
            text: 'อัตราเฉลี่ย'
        },
    })
    let item_list = ''
    let provider_list = obj.forminfo.list
    let main = {
        prop_sevice: 0.8,
        amount: 0,
        amount_voice: 0,
        amount_sec: 0,
        amount_sms: 0,
        amount_mms: 0,
        amount_internet: 0,
        voice_m: 0,
        voice_s: 0,
        sms: 0,
        mms: 0,
        internet: 0,
    }
    let ontop = {
        prop_sevice: 0.2,
        amount: 0,
        amount_voice: 0,
        amount_sec: 0,
        amount_sms: 0,
        amount_mms: 0,
        amount_internet: 0,
        voice_m: 0,
        voice_s: 0,
        sms: 0,
        mms: 0,
        internet: 0,
    }
    let total = {
        amount: 0,
        voice_m: 0,
        voice_s: 0,
        sms: 0,
        mms: 0,
        internet: 0,
    }
    let data_in_unit = {
        amount: [],
        voice: [],
        sms: [],
        mms: [],
        internet: [],
        amount_voice: [],
        amount_sec: [],
        amount_sms: [],
        amount_mms: [],
        amount_internet: [],
    }
    let providers = []
    let providers_fix = []
    let provider_name = []
    let provider_color_chart = []
    let provider_in_chart = []
    let provider_group = []
    for(let l = 0 ; l < provider_list.length ; l ++){
        let item = provider_list[l]
        let item_group = obj.forminfo.compare_type == 'group' ? JSON.parse(item.group_company_list) : [item.id]
        let provider_color = obj.forminfo.compare_type == 'group' ? provider_list[l].group_color_code : provider_list[l].provider_color
        let provider_id = obj.forminfo.compare_type == 'group' ? JSON.parse(provider_list[l].group_company_list) : [provider_list[l].id]

        provider_name.push(obj.forminfo.compare_type == 'group' ? item.group_name_th : item.brand_name)
        provider_color_chart.push(provider_color)
        provider_group.push(provider_id)
        provider_in_chart.push(provider_name)
        item_list += `${item_group},`
        // provider_name.push({
        //     name: name,
        //     list: item_group
        // })
    }
    console.log('provider_name',provider_name,'provider_group',provider_group)
    item_list = item_list.slice(0,-1)
    let fixdata = obj.fixdata.filter(item => item_list.includes(item.provider_id))
    let serviceRate = obj.serviceRate
    let avgBar = 0
    // if(rowdata != '') {
        // for(let p of rowdata){
        //     providers.push(p.provider_id)
        // }
        for(let p of fixdata){
            providers_fix.push(p.provider_id)
        }
        // var providerid = providers.filter((item,index) => providers.indexOf(item) === index)
        state.dataTable = []
        let maxvoice = 0
        let maxsms = 0
        let maxmms = 0
        let maxinternet = 0
        if(yearData >= 2013 && yearData < 2018){
            let datafix = obj.fixdata
        let newdata_fix = {
            voice_m: 0,
            voice: 0,
            sms: 0,
            mms: 0,
            internet: 0,
            freq: [],
            name: ''
        }
        
        let provider_voice = []
        let provider_sms = []
        let provider_mms = []
        let provider_internet = []
        let every_data = {
            voice: [],
            sms: [],
            mms: [],
            internet: []
        }
        for(let p = 0 ; p < provider_group.length ; p ++){
            let voice_array = []
            let sms_array = []
            let mms_array = []
            let internet_array = []
            provider_voice[p] = []
            provider_sms[p] = []
            provider_mms[p] = []
            provider_internet[p] = []
            let fix_amount = {
                voice: 0,
                sms: 0,
                mms: 0,
                internet: 0
            }
            // for(let date = obj.date.start;date < obj.date.end ; date = moment(date).add(1,'M')){
            //     let curmonth = moment(date).format('M-YYYY')
                newdata_fix.voice = 0
                newdata_fix.sms = 0
                newdata_fix.mms = 0
                newdata_fix.internet = 0

                let fixa = datafix.filter(item => item.provider_id == provider_group[p])
                // console.log('fixa',fixa)
                if(fixa.length != 0){
                    for(let n=0;n<fixa.length;n++){
                        if(fixa[n].service_type == 'Voice'){
                            newdata_fix.voice += fixa[n].price_avg
                            fix_amount.voice += 1
                        }else if(fixa[n].service_type == 'SMS'){
                            newdata_fix.sms += fixa[n].price_avg
                            fix_amount.sms += 1
                        }else if(fixa[n].service_type == 'MMS'){
                            newdata_fix.mms += fixa[n].price_avg
                            fix_amount.mms += 1
                        }else if(fixa[n].service_type == 'Internet'){
                            newdata_fix.internet += fixa[n].price_avg
                            fix_amount.internet += 1
                        }
                    }

                    voice_array.push(newdata_fix.voice/fix_amount.voice)
                    sms_array.push(newdata_fix.sms/fix_amount.sms)
                    mms_array.push(newdata_fix.mms/fix_amount.mms)
                    internet_array.push(newdata_fix.internet/fix_amount.internet)

                    fix_amount = {
                        voice: 0,
                        sms: 0,
                        mms: 0,
                        internet: 0
                    }
                }
            // }
            provider_voice[p] = voice_array
            provider_sms[p] = sms_array
            provider_mms[p] = mms_array
            provider_internet[p] = internet_array
            every_data.voice.push(...provider_voice[p]) 
            every_data.sms.push(...provider_sms[p]) 
            every_data.mms.push(...provider_mms[p]) 
            every_data.internet.push(...provider_internet[p]) 
        }
        // console.log('provider_color',provider_color_chart)
        state.charts.unit.xAxis.categories = ["Voice (บาท/นาที)","SMS (บาท/ข้อความ)","MMS (บาท/ข้อความ)","Internet (บาท/MB)"]
        state.charts.voice.xAxis.categories = [month_th[month-1]]
        state.charts.sms.xAxis.categories = [month_th[month-1]]
        state.charts.mms.xAxis.categories = [month_th[month-1]]
        state.charts.internet.xAxis.categories = [month_th[month-1]]
        let result_voices = provider_voice.filter(item => item != 0)
        let result_sms = provider_sms.filter(item => item != 0)
        let result_mms = provider_mms.filter(item => item != 0)
        let result_internet = provider_internet.filter(item => item != 0)

        console.log('provider_voice',provider_voice)
        console.log('result_voices',result_voices)
        if(forminfo.distinguish === 1){

                let result_in_unit = []
                state.dataTable = []
                for(let p = 0 ; p < result_voices.length ; p ++){
                    let unit_data = []
                    result_in_unit[p] = []
                    state.serviceTable = []
                    let obj = {}
                    state.charts.voice.series.push({
                        name: provider_in_chart[p],
                        data: result_voices[p],
                        color: provider_color_chart[p]
                    })
                    state.charts.sms.series.push({
                        name: provider_in_chart[p],
                        data: result_sms[p],
                        color: provider_color_chart[p]
                    })
                    state.charts.mms.series.push({
                        name: provider_in_chart[p],
                        data: result_mms[p],
                        color: provider_color_chart[p]
                    })
                    state.charts.internet.series.push({
                        name: provider_in_chart[p],
                        data: result_internet[p],
                        color: provider_color_chart[p]
                    })

                    //get AVG
                    let voice_in_unit = result_voices[p].reduce((acc, item) => acc+item)
                    let sms_in_unit = result_sms[p].reduce((acc, item) => acc+item)
                    let mms_in_unit = result_mms[p].reduce((acc, item) => acc+item)
                    let internet_in_unit = result_internet[p].reduce((acc, item) => acc+item)
                    voice_in_unit /= result_voices[p].length
                    sms_in_unit /= result_sms[p].length
                    mms_in_unit /= result_mms[p].length
                    internet_in_unit /= result_internet[p].length
                    unit_data.push(parseFloat(voice_in_unit.toFixed(2)))
                    unit_data.push(parseFloat(sms_in_unit.toFixed(2)))
                    unit_data.push(parseFloat(mms_in_unit.toFixed(2)))
                    unit_data.push(parseFloat(internet_in_unit.toFixed(2)))
                    result_in_unit[p] = unit_data
                    state.charts.unit.series.push({
                        name: provider_in_chart[p],
                        data: result_in_unit[p],
                        color: provider_color_chart[p]
                    })

                    //get dataTable 
                    if(voice_in_unit) state.serviceTable.push("Voice (บาท/นาที)")
                    if(sms_in_unit) state.serviceTable.push("SMS (บาท/ข้อความ)")
                    if(mms_in_unit) state.serviceTable.push("MMS (บาท/ข้อความ)")
                    if(internet_in_unit) state.serviceTable.push("Internet (บาท/MB)")
                    obj["data"] = result_in_unit[p]
                    obj["providers_name"] = provider_in_chart[p]
                    obj["providers_color"] = provider_color_chart[p]
                    state.dataTable.push(obj)
                }
                
                maxvoice = every_data.voice.reduce((prev, cur) => (prev > cur) ? prev : cur)
                maxsms = every_data.sms.reduce((prev, cur) => (prev > cur) ? prev : cur)
                maxmms = every_data.mms.reduce((prev, cur) => (prev > cur) ? prev : cur)
                maxinternet = every_data.internet.reduce((prev, cur) => (prev > cur) ? prev : cur)
                console.log('every_data.voice',every_data.voice)
                // console.log('state.serviceTable',state.serviceTable)
                
                //show avg
                if(forminfo.barAvg == '1'){
                    let result_voice_avg = result_voices.reduce((prev, cur) => cur.map((val, i) => (prev[i] || 0) + val/result_voices.length), []);
                    let result_sms_avg = result_sms.reduce((prev, cur) => cur.map((val, i) => (prev[i] || 0) + val/result_sms.length), []);
                    let result_mms_avg = result_mms.reduce((prev, cur) => cur.map((val, i) => (prev[i] || 0) + val/result_mms.length), []);
                    let result_internet_avg = result_internet.reduce((prev, cur) => cur.map((val, i) => (prev[i] || 0) + val/result_internet.length), []);
                    state.charts.voice.series.push({
                        name: 'Average',
                        data: result_voice_avg,
                        color: '#42f9ff'
                    })
                    state.charts.sms.series.push({
                        name: 'Average',
                        data: result_sms_avg,
                        color: '#42f9ff'
                    })
                    state.charts.mms.series.push({
                        name: 'Average',
                        data: result_mms_avg,
                        color: '#42f9ff'
                    })
                    state.charts.internet.series.push({
                        name: 'Average',
                        data: result_internet_avg,
                        color: '#42f9ff'
                    })
                }

        }
        //ไม่แยก ผบ
        else{
            //filter item in array not 0
            for(let i=0;i<result_voices.length;i++){
                result_voices[i] = result_voices[i].filter(item => item !== 0)
                result_sms[i] = result_sms[i].filter(item => item !== 0)
                result_mms[i] = result_mms[i].filter(item => item !== 0)
                result_internet[i] = result_internet[i].filter(item => item !== 0)
            }
            console.log('result_voices',result_voices)

            let avg_voice_quarter = result_voices.reduce((preindex, curindex) => curindex.map((val, i) => (((preindex[i] || 0) + val)/result_voices.length), []) )
            let avg_sms_quarter = result_sms.reduce((preindex, curindex) => curindex.map((val, i) => (((preindex[i] || 0) + val)/result_sms.length), []) )
            let avg_mms_quarter = result_mms.reduce((preindex, curindex) => curindex.map((val, i) => (((preindex[i] || 0) + val)/result_mms.length), []) )
            let avg_internet_quarter = result_internet.reduce((preindex, curindex) => curindex.map((val, i) => (((preindex[i] || 0) + val)/result_internet.length), []) )
            console.log('avg_voice_quarter',avg_voice_quarter)
            state.charts.voice.series.push({
                name: 'Voice (บาท/นาที)',
                data: avg_voice_quarter,
                color: "#7bb5eb"
            })
            state.charts.sms.series.push({
                name:  'SMS (บาท/ข้อความ)',
                data: avg_sms_quarter,
                color: "#434348"
            })
            state.charts.mms.series.push({
                name: 'MMS (บาท/ข้อความ)',
                data: avg_mms_quarter,
                color: "#90ed7d"
            })
            state.charts.internet.series.push({
                name: 'Internet (บาท/MB)',
                data: avg_internet_quarter,
                color: "#f7a35c"
            })

            let all_voice = parseFloat((avg_voice_quarter.reduce((prev,cur) => prev+cur,0) / avg_voice_quarter.length).toFixed(2))
            let all_sms = parseFloat((avg_sms_quarter.reduce((prev,cur) => prev+cur,0) / avg_sms_quarter.length).toFixed(2))
            let all_mms = parseFloat((avg_mms_quarter.reduce((prev,cur) => prev+cur,0) / avg_mms_quarter.length).toFixed(2))
            let all_internet = parseFloat((avg_internet_quarter.reduce((prev,cur) => prev+cur,0) / avg_internet_quarter.length).toFixed(2))
            state.charts.unit.series = [
                {
                    name : 'Voice (บาท/นาที)',
                    data : [all_voice],
                    color: "#7bb5eb"
                },
                {
                    name : 'SMS (บาท/ข้อความ)',
                    data : [all_sms],
                    color: "#434348"
                },
                {
                    name : 'MMS (บาท/ข้อความ)',
                    data : [all_mms],
                    color: "#90ed7d"
                },
                {
                    name : 'Internet (บาท/MB)',
                    data : [all_internet],
                    color: "#f7a35c"
                },
            ]

            //dataTable
            state.dataTable = []
            state.serviceTable= ["Voice (บาท/นาที)","SMS (บาท/ข้อความ)","MMS (บาท/ข้อความ)","Internet (บาท/MB)"]
            let res = {}
                res["data"] = [all_voice,all_sms,all_mms,all_internet]
                res["providers_name"] = `ผู้ให้บริการทั้งหมด ปี ${parseInt(year)+543}`
                res["providers_color"] = ''
            state.dataTable.push(res)

            //max value of array
            maxvoice = avg_voice_quarter.reduce((prev, cur) => (prev > cur) ? prev : cur,0)
            maxsms = avg_sms_quarter.reduce((prev, cur) => (prev > cur) ? prev : cur,0)
            maxmms = avg_mms_quarter.reduce((prev, cur) => (prev > cur) ? prev : cur,0)
            maxinternet = avg_internet_quarter.reduce((prev, cur) => (prev > cur) ? prev : cur,0)

        }
        }else if(yearData >= 2013 && yearData >= 2018){
                let data_in_pro = []
                for(let p =0;p<provider_group.length;p++){
                    data_in_pro[p] = []
                    data_in_unit.amount[p] = []
                    data_in_unit.voice[p] = []
                    data_in_unit.sms[p] = []
                    data_in_unit.mms[p] = []
                    data_in_unit.internet[p] = []
                    data_in_unit.amount_voice[p] = []
                    data_in_unit.amount_sec[p] = []
                    data_in_unit.amount_sms[p] = []
                    data_in_unit.amount_mms[p] = []
                    data_in_unit.amount_internet[p] = []

                        let rowdatas = obj.qrydata.filter(item => provider_group[p].includes(item.provider_id))
                        for(let datagroup=0; datagroup<provider_group[p].length; datagroup++){
                            let rowdata = rowdatas.filter(item =>  item.provider_id == provider_group[p][datagroup])
                            console.log('rowdata',rowdata)
                            for(let r=0;r<rowdata.length;r++){
                                // if(rowdata.length !== 0){
                                    if(rowdata[r].promotion_type === 'main'){
                                        main.amount += rowdata[r].amount
                                        main.voice_m += rowdata[r].vpm_avg
                                        main.voice_s += rowdata[r].vps_avg
                                        main.sms += rowdata[r].sms_avg
                                        main.mms += rowdata[r].mms_avg
                                        main.internet += rowdata[r].internet_avg
                                        main.amount_voice += rowdata[r].amount_voice
                                        main.amount_sec += rowdata[r].amount_sec
                                        main.amount_sms += rowdata[r].amount_sms
                                        main.amount_mms += rowdata[r].amount_mms
                                        main.amount_internet += rowdata[r].amount_internet

                                    }else{
                                        ontop.amount += rowdata[r].amount
                                        ontop.voice_m += rowdata[r].vpm_avg
                                        ontop.voice_s += rowdata[r].vps_avg
                                        ontop.sms += rowdata[r].sms_avg
                                        ontop.mms += rowdata[r].mms_avg
                                        ontop.internet += rowdata[r].internet_avg
                                        ontop.amount_voice += rowdata[r].amount_voice
                                        ontop.amount_sec += rowdata[r].amount_sec
                                        ontop.amount_sms += rowdata[r].amount_sms
                                        ontop.amount_mms += rowdata[r].amount_mms
                                        ontop.amount_internet += rowdata[r].amount_internet
                                    }
                                // }
                                
                            }   
                                //check voicepersec is not null
                                if(main.voice_s !== 0 || ontop.voice_s !== 0){
                                    console.log('have second data')
                                    main.voice_m = main.voice_m  + (main.voice_s*60)
                                    ontop.voice_m = ontop.voice_m  + (ontop.voice_s*60)
                                }
                                console.log('m',main,'o',ontop)
                                if(ontop.amount_mms == 0){
                                    state.main_proportion = 100
                                    total.mms = parseFloat((((main.mms/main.amount_mms)*(state.main_proportion/100))).toFixed(3))
                                }else{
                                    state.main_proportion = 80
                                    total.mms = parseFloat((((main.mms/main.amount_mms)*(state.main_proportion/100)) + ((ontop.mms/ontop.amount_mms) *(state.ontop_proportion/100))).toFixed(3))
                                }
                                if(ontop.amount_voice == 0){
                                    state.main_proportion = 100
                                    total.voice_m = parseFloat((((main.voice_m/main.amount_voice)*(state.main_proportion/100))).toFixed(3))

                                }else{
                                    state.main_proportion = 80
                                    total.voice_m = parseFloat((((main.voice_m/main.amount_voice)*(state.main_proportion/100)) + ((ontop.voice_m/ontop.amount_voice) * (state.ontop_proportion/100))).toFixed(3))
                                }
                                if(ontop.amount_sms == 0){
                                    state.main_proportion = 100
                                    total.sms = parseFloat((((main.sms/main.amount_sms)*(state.main_proportion/100))).toFixed(3))

                                }else{
                                    state.main_proportion = 80
                                    total.sms = parseFloat((((main.sms/main.amount_sms)*(state.main_proportion/100)) + ((ontop.sms/ontop.amount_sms) * (state.ontop_proportion/100))).toFixed(3))
                                }
                                if(ontop.amount_internet == 0){
                                    state.main_proportion = 100
                                    total.internet = parseFloat((((main.internet/main.amount_internet)*(state.main_proportion/100))).toFixed(3))

                                }else{
                                    state.main_proportion = 80
                                    total.internet = parseFloat((((main.internet/main.amount_internet)*(state.main_proportion/100)) + ((ontop.internet/ontop.amount_internet) * (state.ontop_proportion/100))).toFixed(3))
                                }
                                console.log(state.main_proportion,state.ontop_proportion)
                                    data_in_unit.amount[p].push(total.amount)
                                    data_in_unit.voice[p].push(total.voice_m)
                                    data_in_unit.sms[p].push(total.sms)
                                    data_in_unit.mms[p].push(total.mms)
                                    data_in_unit.internet[p].push(total.internet)

                                    data_in_unit.amount_voice[p].push(main.amount_voice+ontop.amount_voice)
                                    data_in_unit.amount_sms[p].push(main.amount_sms+ontop.amount_sms)
                                    data_in_unit.amount_mms[p].push(main.amount_mms+ontop.amount_mms)
                                    data_in_unit.amount_internet[p].push(main.amount_internet + ontop.amount_internet)
                                    data_in_pro[p].push({
                                        avg_voice: total.voice_m,
                                        avg_sms: total.sms,
                                        avg_mms: total.mms,
                                        avg_internet: total.internet
                                    })
                            total = {
                                amount: 0,
                                voice_m: 0,
                                voice_s: 0,
                                sms: 0,
                                mms: 0,
                                internet: 0,
                            }
                            main = {
                                amount: 0,
                                voice_m: 0,
                                voice_s: 0,
                                sms: 0,
                                mms: 0,
                                internet: 0,
                                amount_voice: 0,
                                amount_sec: 0,
                                amount_sms: 0,
                                amount_mms: 0,
                                amount_internet: 0,
                            }
                            ontop = {
                                amount: 0,
                                voice_m: 0,
                                voice_s: 0,
                                sms: 0,
                                mms: 0,
                                internet: 0,
                                amount_voice: 0,
                                amount_sec: 0,
                                amount_sms: 0,
                                amount_mms: 0,
                                amount_internet: 0,
                            }
                            
                        }
                    // console.log('---end provider_group--',provider_group[p])
                }
                console.log('data_in_unit',data_in_unit)
                
                //amount data main + ontop of providers in same month 
                let voice_amount_in_month = data_in_unit.amount_voice.reduce((preindex, curindex) => curindex.map((val, i) => (((preindex[i] || 0) + val)), []) )
                let sms_amount_in_month = data_in_unit.amount_sms.reduce((preindex, curindex) => curindex.map((val, i) => (((preindex[i] || 0) + val)), []) )
                let mms_amount_in_month = data_in_unit.amount_mms.reduce((preindex, curindex) => curindex.map((val, i) => (((preindex[i] || 0) + val)), []) )
                let internet_amount_in_month = data_in_unit.amount_internet.reduce((preindex, curindex) => curindex.map((val, i) => (((preindex[i] || 0) + val)), []) )
                console.log('voice_amount_in_month',voice_amount_in_month)

                //เก็บค่าของแต่ละผู้ให้บริการในอารเรย์โดยเรียงลำดับตาม ผบ
                let avg_in_voice = []
                let avg_in_sms = []
                let avg_in_mms = []
                let avg_in_internet = []
                let avg_voice = []
                let avg_sms = []
                let avg_mms = []
                let avg_internet = []
                let result_in_unit = []
                state.dataTable = []
                //ข้อมูลรวมสำหรับไม่จพแนก ผบ
                let sum_voice_providers = 0
                let sum_sms_providers = 0
                let sum_mms_providers = 0
                let sum_internet_providers = 0
                for(let p =0;p<provider_group.length;p++){
                    // console.log('this loop')
                    avg_in_voice[p] = []
                    avg_in_sms[p] = []
                    avg_in_mms[p] = []
                    avg_in_internet[p] = []
                    result_in_unit[p] = []
                    let sum_voice = 0
                    let sum_sms = 0
                    let sum_mms = 0
                    let sum_internet = 0
                    let sum_amount = 0
                    let data_result = {
                        voice: 0,
                        sms: 0,
                        mms: 0,
                        internet: 0
                    }
                        if(forminfo.distinguish === 1){
                            // จำแนกผบ และ ถ่วงน้ำหนัก
                            if(forminfo.weighting == 1){
                                sum_voice = data_in_unit.voice[p] * data_in_unit.amount_voice[p]
                                sum_sms = data_in_unit.sms[p] * data_in_unit.amount_sms[p]
                                sum_mms = data_in_unit.mms[p] * data_in_unit.amount_mms[p]
                                sum_internet = data_in_unit.internet[p] * data_in_unit.amount_internet[p]
                                
                                data_result.voice = sum_voice/voice_amount_in_month
                                data_result.sms = sum_sms/sms_amount_in_month
                                data_result.mms = sum_mms/mms_amount_in_month
                                data_result.internet = sum_internet/internet_amount_in_month
                            }else{
                                sum_voice = data_in_unit.voice[p]
                                sum_sms = data_in_unit.sms[p]
                                sum_mms = data_in_unit.mms[p]
                                sum_internet = data_in_unit.internet[p]
                                
                                data_result.voice = sum_voice/1
                                data_result.sms = sum_sms/1
                                data_result.mms = sum_mms/1
                                data_result.internet = sum_internet/1
                            }
                        }else{
                            if(forminfo.weighting == 1){
                                sum_voice_providers += data_in_unit.voice[p] * data_in_unit.amount_voice[p]
                                sum_sms_providers += data_in_unit.sms[p] * data_in_unit.amount_sms[p]
                                sum_mms_providers += data_in_unit.mms[p] * data_in_unit.amount_mms[p]
                                sum_internet_providers += data_in_unit.internet[p] * data_in_unit.amount_internet[p]
                            }else{
                                sum_voice_providers += data_in_unit.voice[p][0]
                                sum_sms_providers += data_in_unit.sms[p][0]
                                sum_mms_providers += data_in_unit.mms[p][0]
                                sum_internet_providers += data_in_unit.internet[p][0]
                            }
                        }
                        // console.log('data_result.voice',data_result.voice,'=',sum_voice,sum_amount)
                        console.log('avg -> data_result.voice',data_result)
                        isNaN(data_result.voice) ? avg_in_voice[p].push(0) : avg_in_voice[p].push(data_result.voice)
                        isNaN(data_result.sms) ? avg_in_sms[p].push(0) : avg_in_sms[p].push(data_result.sms)
                        isNaN(data_result.mms) ? avg_in_mms[p].push(0) : avg_in_mms[p].push(data_result.mms)
                        isNaN(data_result.internet) ? avg_in_internet[p].push(0) : avg_in_internet[p].push(data_result.internet)

                        state.serviceTable = []
                    // }
                    console.log('aa',avg_in_voice)

                    // array of average each provider
                    avg_voice.push(avg_in_voice[p].reduce((prev, cur) => prev + cur ,0))
                    avg_sms.push(avg_in_sms[p].reduce((prev, cur) => prev + cur ,0))
                    avg_mms.push(avg_in_mms[p].reduce((prev, cur) => prev + cur ,0))
                    avg_internet.push(avg_in_internet[p].reduce((prev, cur) => prev + cur ,0))
                    console.log('avg_voice',avg_voice)

                    //ข้อมูลทั้งหมดในเดือน
                    result_in_unit[p].push(avg_voice[p])
                    result_in_unit[p].push(avg_sms[p])
                    result_in_unit[p].push(avg_mms[p])
                    result_in_unit[p].push(avg_internet[p])

                    
                    // console.log('avg_in_voice',avg_in_voice)
                    if(forminfo.distinguish === 1){
                        //chart
                        state.charts.voice.series.push({
                            name: provider_name[p],
                            data: avg_in_voice[p],
                            color: provider_color_chart[p]
                        })
                        state.charts.sms.series.push({
                            name: provider_name[p],
                            data: avg_in_sms[p],
                            color: provider_color_chart[p]
                        })
                        state.charts.mms.series.push({
                            name: provider_name[p],
                            data: avg_in_mms[p],
                            color: provider_color_chart[p]
                        })
                        state.charts.internet.series.push({
                            name: provider_name[p],
                            data: avg_in_internet[p],
                            color: provider_color_chart[p]
                        })
                        state.charts.unit.series.push({
                            name : provider_name[p],
                            data : result_in_unit[p],
                            color: provider_color_chart[p]
                        })
                        state.charts.unit.xAxis.categories = ["Voice (บาท/นาที)","SMS (บาท/ข้อความ)","MMS (บาท/ข้อความ)","Internet (บาท/MB)"]
                    
                        console.log('result_in_unit',result_in_unit)
                        //get dataTable 
                        let dataTAble = {}
                        if(avg_in_voice) state.serviceTable.push("Voice (บาท/นาที)")
                        if(avg_in_sms) state.serviceTable.push("SMS (บาท/ข้อความ)")
                        if(avg_in_mms) state.serviceTable.push("MMS (บาท/ข้อความ)")
                        if(avg_in_internet) state.serviceTable.push("Internet (บาท/MB)")
                        dataTAble["data"] = result_in_unit[p]
                        dataTAble["providers_name"] = provider_name[p]
                        dataTAble["providers_color"] = provider_color_chart[p]
                        state.dataTable.push(dataTAble)
                    }
                }
                console.log('sum_voice_providers',sum_voice_providers)
                console.log('voice_amount_in_month',voice_amount_in_month[0])

                console.log('avg_in_voice',avg_in_voice)

                //ไม่จำแนกผู้ให้บริการ ค่าเฉลี่ยของผบในแต่ละเดือน
                if(forminfo.distinguish === 2){
                    let voice_result = 0
                    let sms_result = 0
                    let mms_result = 0
                    let internet_result = 0
                    if(forminfo.weighting == 1){
                        voice_result = parseFloat((sum_voice_providers/voice_amount_in_month[0]).toFixed(3))
                        sms_result = parseFloat((sum_sms_providers/sms_amount_in_month[0]).toFixed(3))
                        mms_result = parseFloat((sum_mms_providers/mms_amount_in_month[0]).toFixed(3))
                        internet_result = parseFloat((sum_internet_providers/internet_amount_in_month[0]).toFixed(3))
                    }else{
                        voice_result = parseFloat((sum_voice_providers/provider_group.length).toFixed(3))
                        sms_result = parseFloat((sum_sms_providers/provider_group.length).toFixed(3))
                        mms_result = parseFloat((sum_mms_providers/provider_group.length).toFixed(3))
                        internet_result = parseFloat((sum_internet_providers/provider_group.length).toFixed(3))
                    }
                    //chart
                    // rgb(124, 181, 236) rgb(67, 67, 72) rgb(144, 237, 125) rgb(247, 163, 92)
                    state.charts.voice.series.push({
                        name: "Voice (บาท/นาที)",
                        data: [voice_result],
                        color: 'rgb(124, 181, 236)'
                    })
                    state.charts.sms.series.push({
                        name: "SMS (บาท/ข้อความ)",
                        data: [sms_result],
                        color: 'rgb(67, 67, 72)'
                    })
                    state.charts.mms.series.push({
                        name: "MMS (บาท/ข้อความ)",
                        data: [mms_result],
                        color: 'rgb(144, 237, 125)'
                    })
                    state.charts.internet.series.push({
                        name: "Internet (บาท/MB)",
                        data: [internet_result],
                        color: 'rgb(247, 163, 92)'
                    })
                    state.charts.unit.series = [
                        {
                            name : "Voice (บาท/นาที)",
                            data : [voice_result],
                            color: 'rgb(124, 181, 236)'
                        },
                        {
                            name : "SMS (บาท/ข้อความ)",
                            data : [sms_result],
                            color: 'rgb(67, 67, 72)'
                        },
                        {
                            name : "MMS (บาท/ข้อความ)",
                            data : [mms_result],
                            color: 'rgb(144, 237, 125)'
                        },
                        {
                            name : "Internet (บาท/MB)",
                            data : [internet_result],
                            color: 'rgb(247, 163, 92)'
                        },
                    ]
                    maxvoice = voice_result
                    maxsms = sms_result
                    maxmms = mms_result
                    maxinternet = internet_result

                    //get dataTable
                    state.serviceTable= ["Voice (บาท/นาที)","SMS (บาท/ข้อความ)","MMS (บาท/ข้อความ)","Internet (บาท/MB)"]
                    let dataTable = {}
                        dataTable["data"] = [voice_result,sms_result,mms_result,internet_result]
                        dataTable["providers_name"] = `ผู้ให้บริการทั้งหมด เดือน ${month_th[month-1]}`
                        dataTable["providers_color"] = ''
                    state.dataTable.push(dataTable)
                }
                else{
                    let voice_data_average = avg_voice.reduce((prev, cur) => prev + cur ,0) / avg_voice.length
                    let sms_data_average = avg_sms.reduce((prev, cur) => prev + cur ,0) / avg_sms.length
                    let mms_data_average = avg_mms.reduce((prev, cur) => prev + cur ,0) / avg_mms.length
                    let internet_data_average = avg_internet.reduce((prev, cur) => prev + cur ,0) / avg_internet.length
                    console.log('voice_data_average',voice_data_average)

                    if(forminfo.barAvg == '1'){
                        state.charts.voice.series.push({
                            name: 'Average',
                            data: [voice_data_average],
                            color: '#42f9ff'
                        })
                        state.charts.sms.series.push({
                            name: 'Average',
                            data: [sms_data_average],
                            color: '#42f9ff'
                        })
                        state.charts.mms.series.push({
                            name: 'Average',
                            data: [mms_data_average],
                            color: '#42f9ff'
                        })
                        state.charts.internet.series.push({
                            name: 'Average',
                            data: [internet_data_average],
                            color: '#42f9ff'
                        })
                    }
                    maxvoice = avg_voice.reduce((prev, cur) => (prev > cur) ? prev : cur)
                    maxsms = avg_sms.reduce((prev, cur) => (prev > cur) ? prev : cur)
                    maxmms = avg_mms.reduce((prev, cur) => (prev > cur) ? prev : cur)
                    maxinternet = avg_internet.reduce((prev, cur) => (prev > cur) ? prev : cur)
                }
        }

        //แสดงเพดานกำกับ
        if(forminfo.graphLine == true){
            let graphLine = obj.serviceRate
            let year = moment(forminfo.type_data.month).format('YYYY')
            let start = moment('01-01-'+ year, 'DD-MM-YYYY')
            let end = moment(start).add(1,'Y')
                end = moment(end).subtract(1,'d')
            let voice_service_rate = 0
            let sms_service_rate = 0
            let mms_service_rate = 0
            let internet_service_rate = 0
            let service_name = ""
            for(let i = 0 ; i < graphLine.length ; i++){
                if((moment(graphLine[i].end_date).format('DD-MM-YYYY') >= moment(end).format('DD-MM-YYYY')) && (moment(graphLine[i].start_date).format('DD-MM-YYYY') <= moment(start).format('DD-MM-YYYY'))){
                    voice_service_rate = graphLine[i].voice_service_rate
                    sms_service_rate  = graphLine[i].sms_service_rate
                    mms_service_rate  = graphLine[i].mms_service_rate
                    internet_service_rate  = graphLine[i].internet_service_rate
                    service_name = graphLine[i].service_name
                }
            }
            console.log('max',maxvoice,'voice_service_rate',voice_service_rate)
            state.charts.voice.yAxis = [{
                min: 0,
                title: {
                    text: 'อัตราค่าบริการเฉลี่ย'
                },
                plotLines: [{
                    value: voice_service_rate,
                    color: 'red',
                    dashStyle: 'line',
                    width: 2,
                    label: {
                        text: `${service_name} ${voice_service_rate}`
                    }
                },{
                    value: maxvoice,
                    color: 'red',
                    dashStyle: 'shortdash',
                    width: 2,
                    label: {
                        text: ``
                    }
                }]
            }]
            state.charts.sms.yAxis = [{
                min: 0,
                title: {
                    text: 'อัตราค่าบริการเฉลี่ย'
                },
                plotLines: [{
                    value: sms_service_rate,
                    color: 'red',
                    dashStyle: 'line',
                    width: 2,
                    label: {
                        text: `${service_name} ${sms_service_rate}`
                    }
                },{
                    value: maxsms,
                    color: 'red',
                    dashStyle: 'shortdash',
                    width: 2,
                    label: {
                        text: ``
                    }
                }]
            }]
            state.charts.mms.yAxis =[{
                min: 0,
                title: {
                    text: 'อัตราค่าบริการเฉลี่ย'
                },
                plotLines: [{
                    value: mms_service_rate,
                    color: 'red',
                    dashStyle: 'line',
                    width: 2,
                    label: {
                        text: `${service_name} ${mms_service_rate}`
                    }
                },{
                    value: maxmms,
                    color: 'red',
                    dashStyle: 'shortdash',
                    width: 2,
                    label: {
                        text: ``
                    }
                }]
                
            }]
            state.charts.internet.yAxis =[{
                min: 0,
                title: {
                    text: 'อัตราค่าบริการเฉลี่ย'
                },
                plotLines: [{
                    value: internet_service_rate,
                    color: 'red',
                    dashStyle: 'line',
                    width: 2,
                    label: {
                        text: `${service_name} ${internet_service_rate}`
                    }
                },{
                    value: maxinternet,
                    color: 'red',
                    dashStyle: 'shortdash',
                    width: 2,
                    label: {
                        text: ``
                    }
                }]
            }]
        }else {
            state.charts.voice.yAxis = [{
                min: 0,
                title: {
                    text: 'อัตราค่าบริการเฉลี่ย'
                },
                plotLines: []
            }]
            state.charts.sms.yAxis = [{
                min: 0,
                title: {
                    text: 'อัตราค่าบริการเฉลี่ย'
                },
                plotLines: []
            }]
            state.charts.mms.yAxis = [{
                min: 0,
                title: {
                    text: 'อัตราค่าบริการเฉลี่ย'
                },
                plotLines: []
            }]
            state.charts.internet.yAxis = [{
                min: 0,
                title: {
                    text: 'อัตราค่าบริการเฉลี่ย'
                },
                plotLines: []
            }]
        }
  },
  BETWEEN_MONTH(state,obj){
    let month_yearfrom = moment(obj.forminfo.type_data.monthfrom).format("YYYY")
    let month_yearto = moment(obj.forminfo.type_data.monthto).format("YYYY")
    let title_start = month_th[moment(obj.date.start).format('M')-1]+" ปี พ.ศ. "+moment(obj.date.start).add(543,'y').format('YYYY')
    let title_end = month_th[moment(obj.date.end).format('M')-1]+" ปี พ.ศ. "+moment(obj.date.end).add(543,'y').format('YYYY')

    let graphLine_text = obj.forminfo.graphLine ? " และเปรียบเทียบกับอัตราอ้างอิงบนคลื่นความถี่ 2.1 GHz" : ""
    let distinguish_text = obj.forminfo.distinguish == 1 ? "จำแนกตาม" : "ของ"
    state.charts.unit.title.text = "ภาพรวมอัตราค่าบริการเฉลี่ยของบริการ ประเภทเสียง บริการ SMS/MMS และ บริการ Internet ของผู้ให้บริการ โทรศัพท์เคลื่อนที่เดือน "+title_start+" ถึงเดือน "+title_end
    // if(obj.forminfo.distinguish == 1){
        state.charts.voice.title.text = "อัตราค่าบริการเฉลี่ยของบริการประเภทเสียง "+distinguish_text+"ผู้ให้บริการโทรศัพท์เคลื่อนที่เดือน "+title_start+" ถึงเดือน "+title_end+ graphLine_text
        state.charts.sms.title.text = "อัตราค่าบริการเฉลี่ยของบริการ SMS "+distinguish_text+"ผู้ให้บริการโทรศัพท์เคลื่อนที่เดือน "+title_start+" ถึงเดือน "+title_end+ graphLine_text
        state.charts.mms.title.text = "อัตราค่าบริการเฉลี่ยของบริการ MMS "+distinguish_text+"ผู้ให้บริการโทรศัพท์เคลื่อนที่เดือน "+title_start+" ถึงเดือน "+title_end+ graphLine_text
        state.charts.internet.title.text = "อัตราค่าบริการเฉลี่ยของบริการ Internet "+distinguish_text+"ผู้ให้บริการโทรศัพท์เคลื่อนที่เดือน "+title_start+" ถึงเดือน "+title_end+ graphLine_text
    // }else{
    //     state.charts.voice.title.text = "อัตราค่าบริการเฉลี่ยของบริการประเภทเสียงของผู้ให้บริการโทรศัพท์เคลื่อนที่เดือน "+title_start+" ถึงเดือน "+title_end
    //     state.charts.sms.title.text = "อัตราค่าบริการเฉลี่ยของบริการ SMS ของผู้ให้บริการโทรศัพท์เคลื่อนที่เดือน "+title_start+" ถึงเดือน "+title_end
    //     state.charts.mms.title.text = "อัตราค่าบริการเฉลี่ยของบริการ MMS ของผู้ให้บริการโทรศัพท์เคลื่อนที่เดือน "+title_start+" ถึงเดือน "+title_end
    //     state.charts.internet.title.text = "อัตราค่าบริการเฉลี่ยของบริการ Internet ของผู้ให้บริการโทรศัพท์เคลื่อนที่เดือน "+title_start+" ถึงเดือน "+title_end
    // }

    state.charts.unit.series = []
    state.charts.voice.series = []
    state.charts.sms.series = []
    state.charts.mms.series = []
    state.charts.internet.series = []

    state.charts.unit.xAxis.categories = []
    state.charts.voice.xAxis.categories = []
    state.charts.sms.xAxis.categories = []
    state.charts.mms.xAxis.categories = []
    state.charts.internet.xAxis.categories = []

    let forminfo = obj.forminfo
    // let item_list = ''
    let p_list = []
    let provider_id_list = []
    let provider_in_chart = []
    let provider_color_chart = []
    let provider_list = obj.forminfo.list
    let provider_group = []

    for(let p = 0 ; p < provider_list.length ; p ++){
        let provider_name = obj.forminfo.compare_type == 'group' ? provider_list[p].group_name_th : provider_list[p].brand_name
        let provider_color = obj.forminfo.compare_type == 'group' ? provider_list[p].group_color_code : provider_list[p].provider_color
        let provider_id = obj.forminfo.compare_type == 'group' ? JSON.parse(provider_list[p].group_company_list) : [provider_list[p].id]
        provider_id_list.push(provider_id)

        // item_list += `${item_group},`
        p_list.push(...provider_id)
        provider_in_chart.push(provider_name)
        provider_color_chart.push(provider_color)
    }
    console.log('p_list',p_list)
        console.log('provider_id_list',provider_id_list)
    // console.log('provider_in_chart',provider_in_chart)
    // console.log('provider_color_chart',provider_color_chart)
    let maxvoice = 0
    let maxsms = 0
    let maxmms = 0
    let maxinternet = 0
    let datafix = obj.fixdata
    let newdata_fix = {
        voice_m: 0,
        voice: 0,
        sms: 0,
        mms: 0,
        internet: 0,
        freq: [],
        name: ''
    }
    let FIX_provider_voice = []
    let FIX_provider_sms = []
    let FIX_provider_mms = []
    let FIX_provider_internet = []
    let avg_in_voice = []
    let avg_in_sms = []
    let avg_in_mms = []
    let avg_in_internet = []

    if(obj.fixdata){
        for(let p = 0 ; p < p_list.length ; p ++){
            let voice_array = []
            let sms_array = []
            let mms_array = []
            let internet_array = []
            FIX_provider_voice[p] = []
            FIX_provider_sms[p] = []
            FIX_provider_mms[p] = []
            FIX_provider_internet[p] = []
            avg_in_voice[p] = []
            avg_in_sms[p] = []
            avg_in_mms[p] = []
            avg_in_internet[p] = []
            var quarter_th = []

            let fix_amount = {
                voice: 0,
                sms: 0,
                mms: 0,
                internet: 0
            }
            for(let date = obj.date.start;date < obj.date.end ; date = moment(date).add(1,'M')){
                let yearDate = moment(date).add(543,'y').format('YYYY')
                // let quarterDate = (moment(date).format('MM'))/3
                let monthDate = month_th[moment(date).format('M')-1]
                // let quarter_year_data = quarterDate+'Q'+yearDate
                let curmonth = moment(date).format('M-YYYY')

                let fixa = datafix.filter(item => item.monthly == curmonth && item.provider_id == p_list[p])
                if(fixa.length != 0){
                    for(let n=0;n<fixa.length;n++){
                        if(fixa[n].service_type == 'Voice'){
                            newdata_fix.voice += fixa[n].price_avg
                            fix_amount.voice += 1
                        }else if(fixa[n].service_type == 'SMS'){
                            newdata_fix.sms += fixa[n].price_avg
                            fix_amount.sms += 1
                        }else if(fixa[n].service_type == 'MMS'){
                            newdata_fix.mms += fixa[n].price_avg
                            fix_amount.mms += 1
                        }else if(fixa[n].service_type == 'Internet'){
                            newdata_fix.internet += fixa[n].price_avg
                            fix_amount.internet += 1
                        }
                        
                    }

                    // console.log('count_quarter here',count_quarter)
                    //sum a quarter 
                        voice_array.push(newdata_fix.voice/fix_amount.voice)
                        sms_array.push(newdata_fix.sms/fix_amount.sms)
                        mms_array.push(newdata_fix.mms/fix_amount.mms)
                        internet_array.push(newdata_fix.internet/fix_amount.internet)
                        //reset value after quarter
                        newdata_fix.voice = 0
                        newdata_fix.sms = 0
                        newdata_fix.mms = 0
                        newdata_fix.internet = 0
                        fix_amount = {
                            voice: 0,
                            sms: 0,
                            mms: 0,
                            internet: 0
                        }
                        quarter_th.push(monthDate)
                }
            }
            FIX_provider_voice[p] = voice_array
            FIX_provider_sms[p] = sms_array
            FIX_provider_mms[p] = mms_array
            FIX_provider_internet[p] = internet_array
            avg_in_voice[p].push(...voice_array)
            avg_in_sms[p].push(...sms_array)
            avg_in_mms[p].push(...mms_array)
            avg_in_internet[p].push(...internet_array)
        }
        console.log('quarter_th',quarter_th)
        var FIX_result_voices = FIX_provider_voice.filter(item => item != 0)
        var FIX_result_sms = FIX_provider_sms.filter(item => item != 0)
        var FIX_result_mms = FIX_provider_mms.filter(item => item != 0)
        var FIX_result_internet = FIX_provider_internet.filter(item => item != 0)
        
        state.charts.voice.xAxis.categories = quarter_th
        state.charts.sms.xAxis.categories = quarter_th
        state.charts.mms.xAxis.categories = quarter_th
        state.charts.internet.xAxis.categories = quarter_th
        console.log('FIXresult_voices',FIX_result_voices)
        console.log('avg_in_voice from fix',avg_in_voice)
    }
    if(month_yearfrom >= 2013 && month_yearto <= 2017){
        // console.log('use fix data')
        //แยก ผบ
        if(forminfo.distinguish === 1){
            state.charts.unit.xAxis.categories = ["Voice (บาท/นาที)","SMS (บาท/ข้อความ)","MMS (บาท/ข้อความ)","Internet (บาท/MB)"]
            let every_data = {
                voice: [],
                sms: [],
                mms: [],
                internet: []
            }
            let result_in_unit = []
            state.dataTable = []
            let dataTabe_result = []
            for(let p = 0 ; p < FIX_result_voices.length ; p ++){
                let unit_data = []
                result_in_unit[p] = []
                dataTabe_result[p] = []
                state.serviceTable = []
                state.charts.voice.series.push({
                    name: provider_in_chart[p],
                    data: FIX_result_voices[p],
                    color: provider_color_chart[p]
                })
                state.charts.sms.series.push({
                    name: provider_in_chart[p],
                    data: FIX_result_sms[p],
                    color: provider_color_chart[p]
                })
                state.charts.mms.series.push({
                    name: provider_in_chart[p],
                    data: FIX_result_mms[p],
                    color: provider_color_chart[p]
                })
                state.charts.internet.series.push({
                    name: provider_in_chart[p],
                    data: FIX_result_internet[p],
                    color: provider_color_chart[p]
                })

                //get AVG
                let voice_in_unit = FIX_result_voices[p].reduce((acc, item) => acc+item)
                let sms_in_unit = FIX_result_sms[p].reduce((acc, item) => acc+item)
                let mms_in_unit = FIX_result_mms[p].reduce((acc, item) => acc+item)
                let internet_in_unit = FIX_result_internet[p].reduce((acc, item) => acc+item)
                voice_in_unit /= FIX_result_voices[p].length
                sms_in_unit /= FIX_result_sms[p].length
                mms_in_unit /= FIX_result_mms[p].length
                internet_in_unit /= FIX_result_internet[p].length
                unit_data.push(parseFloat(voice_in_unit.toFixed(2)))
                unit_data.push(parseFloat(sms_in_unit.toFixed(2)))
                unit_data.push(parseFloat(mms_in_unit.toFixed(2)))
                unit_data.push(parseFloat(internet_in_unit.toFixed(2)))
                result_in_unit[p] = unit_data
                state.charts.unit.series.push({
                    name: provider_in_chart[p],
                    data: result_in_unit[p],
                    color: provider_color_chart[p]
                })

                //dataTable
                dataTabe_result[p].push(FIX_result_voices[p])
                dataTabe_result[p].push(FIX_result_sms[p])
                dataTabe_result[p].push(FIX_result_mms[p])
                dataTabe_result[p].push(FIX_result_internet[p])
                console.log('ds',dataTabe_result)
                let datarow = ["Voice (บาท/นาที)","SMS (บาท/ข้อความ)","MMS (บาท/ข้อความ)","Internet (บาท/MB)"]
                // state.dataTable = []
                for(let m=0;m<quarter_th.length;m++){
                    state.serviceTable.push(quarter_th[m])
                }
                for(let dt=0;dt<4;dt++){
                let res = {
                    data: [],
                    providers_name: [],
                    providers_color: []
                }
                    // res.providers_name = provider_in_chart[p]
                    res.providers_name = datarow[dt]
                    res.providers_color = provider_color_chart[p]
                    res.data = dataTabe_result[p][dt]
                    state.dataTable.push(res)
                }
                console.log(state.dataTable)

                //get all value to find max
                every_data.voice.push(...FIX_result_voices[p]) 
                every_data.sms.push(...FIX_result_sms[p]) 
                every_data.mms.push(...FIX_result_mms[p]) 
                every_data.internet.push(...FIX_result_internet[p]) 
            }

            maxvoice = every_data.voice.reduce((prev, cur) => (prev > cur) ? prev : cur,0)
            maxsms = every_data.sms.reduce((prev, cur) => (prev > cur) ? prev : cur,0)
            maxmms = every_data.mms.reduce((prev, cur) => (prev > cur) ? prev : cur,0)
            maxinternet = every_data.internet.reduce((prev, cur) => (prev > cur) ? prev : cur,0)

            //show avg
            if(forminfo.barAvg == '1'){
                let result_voice_avg = FIX_result_voices.reduce((prev, cur) => cur.map((val, i) => (prev[i] || 0) + val/FIX_result_voices.length), []);
                let result_sms_avg = FIX_result_sms.reduce((prev, cur) => cur.map((val, i) => (prev[i] || 0) + val/FIX_result_sms.length), []);
                let result_mms_avg = FIX_result_mms.reduce((prev, cur) => cur.map((val, i) => (prev[i] || 0) + val/FIX_result_mms.length), []);
                let result_internet_avg = FIX_result_internet.reduce((prev, cur) => cur.map((val, i) => (prev[i] || 0) + val/FIX_result_internet.length), []);
                state.charts.voice.series.push({
                    name: 'Average',
                    data: result_voice_avg,
                    color: '#42f9ff'
                })
                state.charts.sms.series.push({
                    name: 'Average',
                    data: result_sms_avg,
                    color: '#42f9ff'
                })
                state.charts.mms.series.push({
                    name: 'Average',
                    data: result_mms_avg,
                    color: '#42f9ff'
                })
                state.charts.internet.series.push({
                    name: 'Average',
                    data: result_internet_avg,
                    color: '#42f9ff'
                })
            }

        }
        else{
            //filter item in array not 0
            for(let i=0;i<FIX_result_voices.length;i++){
                FIX_result_voices[i] = FIX_result_voices[i].filter(item => item !== 0)
                FIX_result_sms[i] = FIX_result_sms[i].filter(item => item !== 0)
                FIX_result_mms[i] = FIX_result_mms[i].filter(item => item !== 0)
                FIX_result_internet[i] = FIX_result_internet[i].filter(item => item !== 0)
            }
            console.log('FIX_result_voices',FIX_result_voices)

            let FIX_avg_voice_month = FIX_result_voices.reduce((preindex, curindex) => curindex.map((val, i) => (((preindex[i] || 0) + val)/FIX_result_voices.length), []) )
            let FIX_avg_sms_month = FIX_result_sms.reduce((preindex, curindex) => curindex.map((val, i) => (((preindex[i] || 0) + val)/FIX_result_sms.length), []) )
            let FIX_avg_mms_month = FIX_result_mms.reduce((preindex, curindex) => curindex.map((val, i) => (((preindex[i] || 0) + val)/FIX_result_mms.length), []) )
            let FIX_avg_internet_month = FIX_result_internet.reduce((preindex, curindex) => curindex.map((val, i) => (((preindex[i] || 0) + val)/FIX_result_internet.length), []) )
            console.log('FIX_avg_voice_month',FIX_avg_voice_month)
            state.charts.voice.series.push({
                name: 'Voice (บาท/นาที)',
                data: FIX_avg_voice_month,
                color: "#7bb5eb"
            })
            state.charts.sms.series.push({
                name:  'SMS (บาท/ข้อความ)',
                data: FIX_avg_sms_month,
                color: "#434348"
            })
            state.charts.mms.series.push({
                name: 'MMS (บาท/ข้อความ)',
                data: FIX_avg_mms_month,
                color: "#90ed7d"
            })
            state.charts.internet.series.push({
                name: 'Internet (บาท/MB)',
                data: FIX_avg_internet_month,
                color: "#f7a35c"
            })

            let all_voice = parseFloat((FIX_avg_voice_month.reduce((prev,cur) => prev+cur,0) / FIX_avg_voice_month.length).toFixed(3))
            let all_sms = parseFloat((FIX_avg_sms_month.reduce((prev,cur) => prev+cur,0) / FIX_avg_sms_month.length).toFixed(3))
            let all_mms = parseFloat((FIX_avg_mms_month.reduce((prev,cur) => prev+cur,0) / FIX_avg_mms_month.length).toFixed(3))
            let all_internet = parseFloat((FIX_avg_internet_month.reduce((prev,cur) => prev+cur,0) / FIX_avg_internet_month.length).toFixed(3))
            state.charts.unit.series = [
                {
                    name : 'Voice (บาท/นาที)',
                    data : [all_voice],
                    color: "#7bb5eb"
                },
                {
                    name : 'SMS (บาท/ข้อความ)',
                    data : [all_sms],
                    color: "#434348"
                },
                {
                    name : 'MMS (บาท/ข้อความ)',
                    data : [all_mms],
                    color: "#90ed7d"
                },
                {
                    name : 'Internet (บาท/MB)',
                    data : [all_internet],
                    color: "#f7a35c"
                },
            ]

            //dataTable
            let dataTabe_result = []
            dataTabe_result.push(FIX_avg_voice_month)
            dataTabe_result.push(FIX_avg_sms_month)
            dataTabe_result.push(FIX_avg_mms_month)
            dataTabe_result.push(FIX_avg_internet_month)
            // console.log('ds',dataTabe_result)
            let datarow = ["Voice (บาท/นาที)","SMS (บาท/ข้อความ)","MMS (บาท/ข้อความ)","Internet (บาท/MB)"]
            state.dataTable = []
            for(let m=0;m<quarter_th.length;m++){
                state.serviceTable.push(quarter_th[m])
            }
            for(let dt=0;dt<4;dt++){
            let res = {
                data: [],
                providers_name: [],
                providers_color: []
            }
                res.providers_name = datarow[dt]
                res.data = dataTabe_result[dt]
                state.dataTable.push(res)
            }
            // console.log(state.dataTable)

            maxvoice = FIX_avg_voice_month.reduce((prev, cur) => (prev > cur) ? prev : cur,0)
            maxsms = FIX_avg_sms_month.reduce((prev, cur) => (prev > cur) ? prev : cur,0)
            maxmms = FIX_avg_mms_month.reduce((prev, cur) => (prev > cur) ? prev : cur,0)
            maxinternet = FIX_avg_internet_month.reduce((prev, cur) => (prev > cur) ? prev : cur,0)
        }
        
    }else if( month_yearfrom >= 2013 && month_yearto >= 2018){
        let main = {
            prop_sevice: 0.8,
            amount: 0,
            voice_m: 0,
            voice_s: 0,
            sms: 0,
            mms: 0,
            internet: 0,
        }
        let ontop = {
            prop_sevice: 0.2,
            amount: 0,
            voice_m: 0,
            voice_s: 0,
            sms: 0,
            mms: 0,
            internet: 0,
        }
        let total = {
            amount: 0,
            voice_m: 0,
            voice_s: 0,
            sms: 0,
            mms: 0,
            internet: 0,
        }
        let data_in_unit = {
            amount: [],
            voice: [],
            sms: [],
            mms: [],
            internet: []
        }
        //use normaldata
        
        if(state.ontop_proportion == 0) state.main_proportion == 100
                    // console.log('state.main_proportion',state.main_proportion,state.ontop_proportion)
                    let data_in_pro = []
                    let fix_provider_voice = []
                    let fix_provider_sms= []
                    let fix_provider_mms = []
                    let fix_provider_internet = []
                    for(let p =0;p<provider_id_list.length;p++){
                        fix_provider_voice[p] = []
                        fix_provider_sms[p] = []
                        fix_provider_mms[p] = []
                        fix_provider_internet[p] = []
                        data_in_pro[p] = []
                        data_in_unit.amount[p] = []
                        data_in_unit.voice[p] = []
                        data_in_unit.sms[p] = []
                        data_in_unit.mms[p] = []
                        data_in_unit.internet[p] = []
                        var month_TH = []

                        for(let date = obj.date.start;date < obj.date.end ; date = moment(date).add(1,'M')){
                            
                            let yearDate = moment(date).add(543,'y').format('YY')
                            let monthDate = month_th[moment(date).format('M')-1]
                            let curmonth = moment(date).format('M-YYYY')
                            month_TH.push(monthDate+' '+yearDate)
                            let rowdatas = obj.qrydata.filter(item => item.monthly == curmonth && provider_id_list[p].includes(item.provider_id))
                            for(let datagroup=0; datagroup<provider_id_list[p].length; datagroup++){
                                let rowdata = rowdatas.filter(item =>  item.provider_id == provider_id_list[p][datagroup])
                                
                                for(let r=0;r<rowdata.length;r++){
                                    if(rowdata.length !== 0){
                                        // console.log('curmonth',curmonth,'row',rowdata[r])
                                        if(rowdata[r].promotion_type === 'main'){
                                            main.amount += rowdata[r].amount
                                            main.voice_m += rowdata[r].vpm_avg
                                            main.voice_s += rowdata[r].vps_avg
                                            main.sms += rowdata[r].sms_avg
                                            main.mms += rowdata[r].mms_avg
                                            main.internet += rowdata[r].internet_avg
                                        }else{
                                            ontop.amount += rowdata[r].amount
                                            ontop.voice_m += rowdata[r].vpm_avg
                                            ontop.voice_s += rowdata[r].vps_avg
                                            ontop.sms += rowdata[r].sms_avg
                                            ontop.mms += rowdata[r].mms_avg
                                            ontop.internet += rowdata[r].internet_avg
                                        }
                                    }
                                    
                                }
                                // console.log('main.amount',main.amount,'ontop.amount',ontop.amount)
                                    //หาอัตราค่าบริการเฉลี่ย x
                                    main.voice_m = main.voice_m + main.voice_s
                                    ontop.voice_m = ontop.voice_m + ontop.voice_s
                                    total.voice_m = parseFloat((((main.voice_m/main.amount)*(state.main_proportion/100)) + ((ontop.voice_m/ontop.amount) *(state.ontop_proportion/100))).toFixed(3))
                                    total.sms = parseFloat((((main.sms/main.amount)*(state.main_proportion/100)) + ((ontop.sms/ontop.amount) *(state.ontop_proportion/100))).toFixed(3))
                                    total.mms = parseFloat((((main.mms/main.amount)*(state.main_proportion/100)) + ((ontop.mms/ontop.amount) *(state.ontop_proportion/100))).toFixed(3))
                                    total.internet = parseFloat((((main.internet/main.amount)*(state.main_proportion/100)) + ((ontop.internet/ontop.amount) *(state.ontop_proportion/100))).toFixed(3))
                                    total.amount = main.amount + ontop.amount
                                    if(total.amount !== 0){
                                        data_in_unit.amount[p].push(total.amount)
                                        data_in_unit.voice[p].push(total.voice_m)
                                        data_in_unit.sms[p].push(total.sms)
                                        data_in_unit.mms[p].push(total.mms)
                                        data_in_unit.internet[p].push(total.internet)
                                        data_in_pro[p].push({
                                            avg_voice: total.voice_m,
                                            avg_sms: total.sms,
                                            avg_mms: total.mms,
                                            avg_internet: total.internet
                                        })
                                    }
                                // console.log('total.amount',total.amount)
                                total = {
                                    amount: 0,
                                    voice_m: 0,
                                    voice_s: 0,
                                    sms: 0,
                                    mms: 0,
                                    internet: 0,
                                }
                                main = {
                                    amount: 0,
                                    voice_m: 0,
                                    voice_s: 0,
                                    sms: 0,
                                    mms: 0,
                                    internet: 0,
                                }
                                ontop = {
                                    amount: 0,
                                    voice_m: 0,
                                    voice_s: 0,
                                    sms: 0,
                                    mms: 0,
                                    internet: 0,
                                }

                                // console.log('new_datafix.voice',newdata_fix.voice)
                                
                            }
                        // console.log('---end provider_id_list--',provider_id_list[p])
                        }
                        
                        // console.log('----endmonth----')

                    }
                    let avg_voice = []
                    let avg_sms = []
                    let avg_mms = []
                    let avg_internet = []
                    let result_in_unit = []
                    let every_data = {
                        voice: [],
                        sms: [],
                        mms: [],
                        internet: []
                    }
                    let filter_avg_voice = []
                    let filter_avg_sms = []
                    let filter_avg_mms = []
                    let filter_avg_internet = []
                    let dataTabe_result = []
                    state.dataTable = []
                    console.log('-----')
                    let data_amount_in_month = data_in_unit.amount.reduce((preindex, curindex) => curindex.map((val, i) => (((preindex[i] || 0) + val)), []) )
                    console.log(data_amount_in_month)
                    console.log('data_in_unit',data_in_unit)
                        for(let p =0;p<provider_id_list.length;p++){
                            dataTabe_result[p] = []
                            result_in_unit[p] = []
                            filter_avg_voice[p] = []
                            filter_avg_sms[p] = []
                            filter_avg_mms[p] = []
                            filter_avg_internet[p] = []
                            let sum_voice = 0
                            let sum_sms = 0
                            let sum_mms = 0
                            let sum_internet = 0
                            let sum_amount = 0
                            let data_result = {
                                voice: 0,
                                sms: 0,
                                mms: 0,
                                internet: 0
                            }
                            let count_month = 0
                            for(let date = obj.date.start;date < obj.date.end ; date = moment(date).add(1,'M')){
                                let curmonth = moment(date).format('M-YYYY')
                                // console.log(data_in_unit.voice[p])
                                        if(forminfo.weighting == 1){
                                            //ถ่วงนน
                                            console.log('data_in_unit.voice[p][count_month] * data_in_unit.amount[p][count_month]',p,count_month,'--',data_in_unit.voice[p][count_month],data_in_unit.amount[p][count_month])

                                            sum_voice = data_in_unit.voice[p][count_month] * data_in_unit.amount[p][count_month]
                                            sum_sms = data_in_unit.sms[p][count_month] * data_in_unit.amount[p][count_month]
                                            sum_mms = data_in_unit.mms[p][count_month] * data_in_unit.amount[p][count_month]
                                            sum_internet = data_in_unit.internet[p][count_month] * data_in_unit.amount[p][count_month]
                                            sum_amount = data_amount_in_month[count_month]
                                        }else{
                                            //ไม่ถ่วง
                                            sum_voice = data_in_unit.voice[p][count_month]
                                            sum_sms = data_in_unit.sms[p][count_month]
                                            sum_mms = data_in_unit.mms[p][count_month]
                                            sum_internet = data_in_unit.internet[p][count_month]
                                            // sum_amount = data_amount_in_month.length
                                        }

                                console.log('data_amount_in_month',data_amount_in_month)
                                console.log('insss sum_amount',sum_amount)
                                
                                if(forminfo.weighting == 1){
                                    data_result.voice = sum_voice/sum_amount
                                    data_result.sms = sum_sms/sum_amount
                                    data_result.mms = sum_mms/sum_amount
                                    data_result.internet = sum_internet/sum_amount
                                }else{
                                    //ไม่ถ่วง
                                    console.log('data_in_unit.amount[p]',data_in_unit.amount.length)
                                    data_result.voice = sum_voice/data_in_unit.amount.length
                                    data_result.sms = sum_sms/data_in_unit.amount.length
                                    data_result.mms= sum_mms/data_in_unit.amount.length
                                    data_result.internet = sum_internet/data_in_unit.amount.length
                                }
                                console.log('data_result.voice',data_result.voice,'=',sum_voice,sum_amount)
                                console.log('pro-',p,'---end month ',curmonth)
                                isNaN(data_result.voice) ? avg_in_voice[p].push(0) : avg_in_voice[p].push(data_result.voice)
                                isNaN(data_result.sms) ? avg_in_sms[p].push(0) : avg_in_sms[p].push(data_result.sms)
                                isNaN(data_result.mms) ? avg_in_mms[p].push(0) : avg_in_mms[p].push(data_result.mms)
                                isNaN(data_result.internet) ? avg_in_internet[p].push(0) : avg_in_internet[p].push(data_result.internet)
                                sum_voice = 0
                                sum_sms = 0
                                sum_mms = 0
                                sum_internet = 0
                                // sum_amount = 0
                                data_result = {
                                    voice: 0,
                                    sms: 0,
                                    mms: 0,
                                    internet: 0
                                }
                                count_month += 1
                            }
                            
                            filter_avg_voice[p] = avg_in_voice[p]
                            filter_avg_sms[p] = avg_in_sms[p]
                            filter_avg_mms[p] = avg_in_mms[p]
                            filter_avg_internet[p] = avg_in_internet[p]
                            filter_avg_voice[p] = filter_avg_voice[p].filter(item => item !== 0)
                            filter_avg_sms[p] = filter_avg_sms[p].filter(item => item !== 0)
                            filter_avg_mms[p] = filter_avg_mms[p].filter(item => item !== 0)
                            filter_avg_internet[p] = filter_avg_internet[p].filter(item => item !== 0)
                            console.log('filter_avg',filter_avg_voice[p])
                            // let ll = filter_avg_voice[p].length
                            // console.log('count_item',count_item)
                            // array of average each provider
                            avg_voice.push(avg_in_voice[p].reduce((prev, cur) => prev + cur ,0) / filter_avg_voice[p].length)
                            avg_sms.push(avg_in_sms[p].reduce((prev, cur) => prev + cur ,0) / filter_avg_sms[p].length)
                            avg_mms.push(avg_in_mms[p].reduce((prev, cur) => prev + cur ,0) / filter_avg_mms[p].length)
                            avg_internet.push(avg_in_internet[p].reduce((prev, cur) => prev + cur ,0) / filter_avg_internet[p].length)
                            console.log('avg_voice',avg_voice)

                            //array order by voice,sms,mms,int of month 
                            result_in_unit[p].push(avg_voice[p])
                            result_in_unit[p].push(avg_sms[p])
                            result_in_unit[p].push(avg_mms[p])
                            result_in_unit[p].push(avg_internet[p])
                            console.log('result_unit',result_in_unit)
                            if(forminfo.distinguish === 1){
                                //chart
                                state.charts.voice.series.push({
                                    name: provider_in_chart[p],
                                    data: avg_in_voice[p],
                                    color: provider_color_chart[p]
                                })
                                state.charts.sms.series.push({
                                    name: provider_in_chart[p],
                                    data: avg_in_sms[p],
                                    color: provider_color_chart[p]
                                })
                                state.charts.mms.series.push({
                                    name: provider_in_chart[p],
                                    data: avg_in_mms[p],
                                    color: provider_color_chart[p]
                                })
                                state.charts.internet.series.push({
                                    name: provider_in_chart[p],
                                    data: avg_in_internet[p],
                                    color: provider_color_chart[p]
                                })
                                state.charts.unit.series.push({
                                    name : provider_in_chart[p],
                                    data : result_in_unit[p],
                                    color: provider_color_chart[p]
                                })
                                state.charts.unit.xAxis.categories = ["Voice (บาท/นาที)","SMS (บาท/ข้อความ)","MMS (บาท/ข้อความ)","Internet (บาท/MB)"]

                                if(forminfo.forecast){
                                    console.log('forecast')
                                    filter_avg_voice[p].push(avg_voice[p])
                                    filter_avg_sms[p].push(avg_sms[p])
                                    filter_avg_mms[p].push(avg_mms[p])
                                    filter_avg_internet[p].push(avg_internet[p])
                                }

                                //dataTable
                                dataTabe_result[p].push(avg_in_voice[p])
                                dataTabe_result[p].push(avg_in_sms[p])
                                dataTabe_result[p].push(avg_in_mms[p])
                                dataTabe_result[p].push(avg_in_internet[p])
                                console.log('ds',dataTabe_result)
                                let datarow = ["Voice (บาท/นาที)","SMS (บาท/ข้อความ)","MMS (บาท/ข้อความ)","Internet (บาท/MB)"]
                                state.serviceTable = []
                                for(let m=0;m<month_TH.length;m++){
                                    state.serviceTable.push(month_TH[m])
                                }
                                for(let dt=0;dt<4;dt++){
                                let res = {
                                    data: [],
                                    providers_name: [],
                                    providers_color: []
                                }
                                    // res.providers_name = provider_in_chart[p]
                                    res.providers_name = datarow[dt]
                                    res.providers_color = provider_color_chart[p]
                                    res.data = dataTabe_result[p][dt]
                                    state.dataTable.push(res)
                                }
                                console.log(state.dataTable)
                            }
                    
                            //get all value to find max
                            every_data.voice.push(...avg_in_voice[p]) 
                            every_data.sms.push(...avg_in_sms[p]) 
                            every_data.mms.push(...avg_in_mms[p]) 
                            every_data.internet.push(...avg_in_internet[p]) 
                            

                        }
                        // console.log('avg_in_voice',avg_in_voice)
                    //avg of each provider in same month to one array
                    let avg_voice_months = avg_in_voice.reduce((preindex, curindex) => curindex.map((val, i) => (((preindex[i] || 0) + val)/avg_in_voice.length), []) )
                    let avg_sms_months = avg_in_sms.reduce((preindex, curindex) => curindex.map((val, i) => (((preindex[i] || 0) + val)/avg_in_sms.length), []) )
                    let avg_mms_months = avg_in_mms.reduce((preindex, curindex) => curindex.map((val, i) => (((preindex[i] || 0) + val)/avg_in_mms.length), []) )
                    let avg_internet_months = avg_in_internet.reduce((preindex, curindex) => curindex.map((val, i) => (((preindex[i] || 0) + val)/avg_in_internet.length), []) )
                    let fil_avg_voice_months = avg_voice_months.filter(item => item !== null)
                    let fil_avg_sms_months = avg_sms_months.filter(item => item !== null)
                    let fil_avg_mms_months = avg_mms_months.filter(item => item !== null)
                    let fil_avg_internet_months = avg_internet_months.filter(item => item !== null)
                    // console.log('avg_voice_months',avg_voice_months)
                    
                    //ไม่จำแนกผู้ให้บริการ ค่าเฉลี่ยของผบในแต่ละเดือน
                    if(forminfo.distinguish === 2){
                        //chart
                        state.charts.voice.series.push({
                            name: "Voice (บาท/นาที)",
                            data: fil_avg_voice_months,
                            color: ''
                        })
                        state.charts.sms.series.push({
                            name: "SMS (บาท/ข้อความ)",
                            data: fil_avg_sms_months,
                            color: ''
                        })
                        state.charts.mms.series.push({
                            name: "MMS (บาท/ข้อความ)",
                            data: fil_avg_mms_months,
                            color: ''
                        })
                        state.charts.internet.series.push({
                            name: "Internet (บาท/MB)",
                            data: fil_avg_internet_months,
                            color: ''
                        })

                        //all data every month in arr to one avg show in unit chart
                        var all_avg_voice = avg_voice.reduce((prev,cur) => prev + cur ,0) / avg_voice.length
                        var all_avg_sms = avg_sms.reduce((prev,cur) => prev + cur ,0) / avg_sms.length
                        var all_avg_mms = avg_mms.reduce((prev,cur) => prev + cur ,0) / avg_mms.length
                        var all_avg_internet = avg_internet.reduce((prev,cur) => prev + cur ,0) / avg_internet.length

                        state.charts.unit.series = [
                            {
                                name : "Voice (บาท/นาที)",
                                data : [all_avg_voice],
                            },
                            {
                                name : "SMS (บาท/ข้อความ)",
                                data : [all_avg_sms],
                            },
                            {
                                name : "MMS (บาท/ข้อความ)",
                                data : [all_avg_mms],
                            },
                            {
                                name : "Internet (บาท/MB)",
                                data : [all_avg_internet],
                            },
                        ]
                        state.charts.unit.xAxis.categories = ["อัตราค่าบริการเฉลี่ย"]
                        
                        //dataTable
                        let dataTabe_result = []
                        dataTabe_result.push(fil_avg_voice_months)
                        dataTabe_result.push(fil_avg_sms_months)
                        dataTabe_result.push(fil_avg_mms_months)
                        dataTabe_result.push(fil_avg_internet_months)
                        // console.log('ds',dataTabe_result)
                        let datarow = ["Voice (บาท/นาที)","SMS (บาท/ข้อความ)","MMS (บาท/ข้อความ)","Internet (บาท/MB)"]
                        state.dataTable = []
                        state.serviceTable = []
                        for(let m=0;m<month_TH.length;m++){
                            state.serviceTable.push(month_TH[m])
                        }
                        for(let dt=0;dt<4;dt++){
                        let res = {
                            data: [],
                            providers_name: [],
                            providers_color: []
                        }
                            res.providers_name = datarow[dt]
                            res.data = dataTabe_result[dt]
                            state.dataTable.push(res)
                        }
                    }
                    console.log('a in v',avg_in_voice)
                    if(forminfo.forecast){
                        console.log('forecast')
                        if(forminfo.distinguish === 2){
                            fil_avg_voice_months.push(all_avg_voice)
                            fil_avg_sms_months.push(all_avg_sms)
                            fil_avg_mms_months.push(all_avg_mms)
                            fil_avg_internet_months.push(all_avg_internet)
                        }
                        month_TH.push('Forecast')
                    }
                    console.log('ss',month_TH)
                    // state.charts.unit.xAxis.categories = ""
                    state.charts.voice.xAxis.categories = month_TH
                    state.charts.sms.xAxis.categories = month_TH
                    state.charts.mms.xAxis.categories = month_TH
                    state.charts.internet.xAxis.categories = month_TH
                    
                    maxvoice = every_data.voice.reduce((prev, cur) => (prev > cur) ? prev : cur)
                    maxsms = every_data.sms.reduce((prev, cur) => (prev > cur) ? prev : cur)
                    maxmms = every_data.mms.reduce((prev, cur) => (prev > cur) ? prev : cur)
                    maxinternet = every_data.internet.reduce((prev, cur) => (prev > cur) ? prev : cur)
                    console.log('avg_voice_months',avg_voice_months)
                    if(forminfo.barAvg == '1'){
                        state.charts.voice.series.push({
                            name: 'Average',
                            data: avg_voice_months,
                            color: '#42f9ff'
                        })
                        state.charts.sms.series.push({
                            name: 'Average',
                            data: avg_sms_months,
                            color: '#42f9ff'
                        })
                        state.charts.mms.series.push({
                            name: 'Average',
                            data: avg_mms_months,
                            color: '#42f9ff'
                        })
                        state.charts.internet.series.push({
                            name: 'Average',
                            data: avg_internet_months,
                            color: '#42f9ff'
                        })
                    }
                // }
    }

    //แสดงเพดานกำกับ
    if(forminfo.graphLine == true){
        let graphLine = obj.serviceRate
        let year = moment(forminfo.type_data.month).format('YYYY')
        let start = moment('01-01-'+ year, 'DD-MM-YYYY')
        let end = moment(start).add(1,'Y')
            end = moment(end).subtract(1,'d')
        let voice_service_rate = 0
        let sms_service_rate = 0
        let mms_service_rate = 0
        let internet_service_rate = 0
        let service_name = ""
        for(let i = 0 ; i < graphLine.length ; i++){
            if((moment(graphLine[i].end_date).format('DD-MM-YYYY') >= moment(end).format('DD-MM-YYYY')) && (moment(graphLine[i].start_date).format('DD-MM-YYYY') <= moment(start).format('DD-MM-YYYY'))){
                voice_service_rate = graphLine[i].voice_service_rate
                sms_service_rate  = graphLine[i].sms_service_rate
                mms_service_rate  = graphLine[i].mms_service_rate
                internet_service_rate  = graphLine[i].internet_service_rate
                service_name = graphLine[i].service_name
            }
        }
        console.log('max',maxvoice,'voice_service_rate',voice_service_rate)
        state.charts.voice.yAxis = [{
            min: 0,
            title: {
                text: 'อัตราค่าบริการเฉลี่ย'
            },
            plotLines: [{
                value: voice_service_rate,
                color: 'red',
                dashStyle: 'line',
                width: 2,
                label: {
                    text: `${service_name} ${voice_service_rate}`
                }
            },{
                value: maxvoice,
                color: 'red',
                dashStyle: 'shortdash',
                width: 2,
                label: {
                    text: ``
                }
            }]
        }]
        state.charts.sms.yAxis = [{
            min: 0,
            title: {
                text: 'อัตราค่าบริการเฉลี่ย'
            },
            plotLines: [{
                value: sms_service_rate,
                color: 'red',
                dashStyle: 'line',
                width: 2,
                label: {
                    text: `${service_name} ${sms_service_rate}`
                }
            },{
                value: maxsms,
                color: 'red',
                dashStyle: 'shortdash',
                width: 2,
                label: {
                    text: ``
                }
            }]
        }]
        state.charts.mms.yAxis =[{
            min: 0,
            title: {
                text: 'อัตราค่าบริการเฉลี่ย'
            },
            plotLines: [{
                value: mms_service_rate,
                color: 'red',
                dashStyle: 'line',
                width: 2,
                label: {
                    text: `${service_name} ${mms_service_rate}`
                }
            },{
                value: maxmms,
                color: 'red',
                dashStyle: 'shortdash',
                width: 2,
                label: {
                    text: ``
                }
            }]
            
        }]
        state.charts.internet.yAxis =[{
            min: 0,
            title: {
                text: 'อัตราค่าบริการเฉลี่ย'
            },
            plotLines: [{
                value: internet_service_rate,
                color: 'red',
                dashStyle: 'line',
                width: 2,
                label: {
                    text: `${service_name} ${internet_service_rate}`
                }
            },{
                value: maxinternet,
                color: 'red',
                dashStyle: 'shortdash',
                width: 2,
                label: {
                    text: ``
                }
            }]
        }]
    }else {
        state.charts.voice.yAxis = [{
            min: 0,
            title: {
                text: 'อัตราค่าบริการเฉลี่ย'
            },
            plotLines: []
        }]
        state.charts.sms.yAxis = [{
            min: 0,
            title: {
                text: 'อัตราค่าบริการเฉลี่ย'
            },
            plotLines: []
        }]
        state.charts.mms.yAxis = [{
            min: 0,
            title: {
                text: 'อัตราค่าบริการเฉลี่ย'
            },
            plotLines: []
        }]
        state.charts.internet.yAxis = [{
            min: 0,
            title: {
                text: 'อัตราค่าบริการเฉลี่ย'
            },
            plotLines: []
        }]
    }

  },
  YEAR(state,obj){
    let year = moment(obj.date.end).format('YYYY')
    let yearTH = moment(obj.date.end).add(543,'y').format('YYYY')

    let graphLine_text = obj.forminfo.graphLine ? " และเปรียบเทียบกับอัตราอ้างอิงบนคลื่นความถี่ 2.1 GHz" : ""
    let distinguish_text = obj.forminfo.distinguish == 1 ? "จำแนกตาม" : "ของ"
    state.charts.unit.title.text = "ภาพรวมอัตราค่าบริการเฉลี่ยของบริการ ประเภทเสียง บริการ SMS/MMS และ บริการ Internet ของผู้ให้บริการ โทรศัพท์เคลื่อนที่ปี พ.ศ. "+yearTH

    state.charts.voice.title.text = "อัตราค่าบริการเฉลี่ยของบริการประเภทเสียง "+distinguish_text+"ผู้ให้บริการโทรศัพท์เคลื่อนที่ปี พ.ศ. "+yearTH+ graphLine_text
    state.charts.sms.title.text = "อัตราค่าบริการเฉลี่ยของบริการ SMS "+distinguish_text+"ผู้ให้บริการโทรศัพท์เคลื่อนที่ปี พ.ศ. "+yearTH+ graphLine_text
    state.charts.mms.title.text = "อัตราค่าบริการเฉลี่ยของบริการ MMS "+distinguish_text+"ผู้ให้บริการโทรศัพท์เคลื่อนที่ปี พ.ศ. "+yearTH+ graphLine_text
    state.charts.internet.title.text = "อัตราค่าบริการเฉลี่ยของบริการ Internet "+distinguish_text+"ผู้ให้บริการโทรศัพท์เคลื่อนที่ปี พ.ศ. "+yearTH+ graphLine_text
    
    state.charts.unit.series = []
    state.charts.voice.series = []
    state.charts.sms.series = []
    state.charts.mms.series = []
    state.charts.internet.series = []

    state.charts.unit.xAxis.categories = [""]
    state.charts.voice.xAxis.categories = [""]
    state.charts.sms.xAxis.categories = [""]
    state.charts.mms.xAxis.categories = [""]
    state.charts.internet.xAxis.categories = [""]

    let main = {
        prop_sevice: 0.8,
        amount: 0,
        voice_m: 0,
        voice_s: 0,
        sms: 0,
        mms: 0,
        internet: 0,
    }
    let ontop = {
        prop_sevice: 0.2,
        amount: 0,
        voice_m: 0,
        voice_s: 0,
        sms: 0,
        mms: 0,
        internet: 0,
    }
    let total = {
        amount: 0,
        voice_m: 0,
        voice_s: 0,
        sms: 0,
        mms: 0,
        internet: 0,
    }
    let providers = []
    let forminfo = obj.forminfo
    let item_list = ''
    let p_list = []
    let provider_in_chart = []
    let provider_color_chart = []
    let provider_id_list = []
    let provider_list = obj.forminfo.list
    for(let p = 0 ; p < provider_list.length ; p ++){
        let item = provider_list[p]
        let provider_name = obj.forminfo.compare_type == 'group' ? provider_list[p].group_name_th : provider_list[p].brand_name
        let provider_color = obj.forminfo.compare_type == 'group' ? provider_list[p].group_color_code : provider_list[p].provider_color
        let provider_id = obj.forminfo.compare_type == 'group' ? JSON.parse(provider_list[p].group_company_list) : [provider_list[p].id]
        let item_group = obj.forminfo.compare_type == 'group' ? JSON.parse(item.group_company_list) : [item.id]
        item_list += `${item_group},`
        // p_list.push(...item_group)
        p_list.push(provider_id)
        provider_id_list.push(provider_id)
        provider_in_chart.push(provider_name)
        provider_color_chart.push(provider_color)
    }
    console.log('plinst',p_list)
    item_list = item_list.slice(0,-1)
    // let rowdata = obj.qrydata.filter(item => item_list.includes(item.provider_id))
    // let fixdata = obj.fixdata.filter(item => item_list.includes(item.provider_id))

        // for(let p of rowdata){
        //     providers.push(p.provider_id)
        // }
        let maxvoice = 0
        let maxsms = 0
        let maxmms = 0
        let maxinternet = 0
        //use fixdata
        if(year >= 2013 && year < 2018){
                let newdata_fix = {
                    voice_m: 0,
                    voice: 0,
                    sms: 0,
                    mms: 0,
                    internet: 0,
                    freq: [],
                    name: ''
                }
                
                let provider_voice = []
                let provider_sms = []
                let provider_mms = []
                let provider_internet = []
                
                for(let p = 0 ; p < p_list.length ; p ++){
                    let voice_array = []
                    let sms_array = []
                    let mms_array = []
                    let internet_array = []
                    provider_voice[p] = []
                    provider_sms[p] = []
                    provider_mms[p] = []
                    provider_internet[p] = []
                    let fix_amount = {
                        voice: 0,
                        sms: 0,
                        mms: 0,
                        internet: 0
                    }
                    for(let date = obj.date.start;date < obj.date.end ; date = moment(date).add(1,'M')){
                        let curmonth = moment(date).format('M-YYYY')
                        newdata_fix.voice = 0
                        newdata_fix.sms = 0
                        newdata_fix.mms = 0
                        newdata_fix.internet = 0
                        // let count_row_month = 0
                        let rowdatas = obj.fixdata.filter(item => item.monthly == curmonth && p_list[p].includes(item.provider_id))
                        for(let datagroup=0; datagroup<p_list[p].length; datagroup++){
                            var fixa = rowdatas.filter(item => item.monthly == curmonth && item.provider_id == p_list[p][datagroup])
                            if(fixa.length != 0){
                                // console.log('fixa',fixa)
                                for(let n=0;n<fixa.length;n++){
                                    if(fixa[n].service_type == 'Voice'){
                                        newdata_fix.voice += fixa[n].price_avg
                                        fix_amount.voice += 1
                                    }else if(fixa[n].service_type == 'SMS'){
                                        newdata_fix.sms += fixa[n].price_avg
                                        fix_amount.sms += 1
                                    }else if(fixa[n].service_type == 'MMS'){
                                        newdata_fix.mms += fixa[n].price_avg
                                        fix_amount.mms += 1
                                    }else if(fixa[n].service_type == 'Internet'){
                                        newdata_fix.internet += fixa[n].price_avg
                                        fix_amount.internet += 1
                                    }
                                    
                                }
                                // count_row_month += 1
                            }
                        }
                        // let getFrequencylength = fixa.length/4
                        voice_array.push(newdata_fix.voice/fix_amount.voice)
                        sms_array.push(newdata_fix.sms/fix_amount.sms)
                        mms_array.push(newdata_fix.mms/fix_amount.mms)
                        internet_array.push(newdata_fix.internet/fix_amount.internet)
                        // console.log('newdata_fix.voice',newdata_fix.voice)
                        //reset value get value in months
                        newdata_fix.voice = 0
                        newdata_fix.sms = 0
                        newdata_fix.mms = 0
                        newdata_fix.internet = 0
                        fix_amount = {
                            voice: 0,
                            sms: 0,
                            mms: 0,
                            internet: 0
                        }
                    }

                    provider_voice[p] = voice_array
                    provider_sms[p] = sms_array
                    provider_mms[p] = mms_array
                    provider_internet[p] = internet_array
                }
                // console.log('provider_color',provider_color_chart)
                state.charts.unit.xAxis.categories = ["Voice (บาท/นาที)","SMS (บาท/ข้อความ)","MMS (บาท/ข้อความ)","Internet (บาท/MB)"]
                state.charts.voice.xAxis.categories = month_th
                state.charts.sms.xAxis.categories = month_th
                state.charts.mms.xAxis.categories = month_th
                state.charts.internet.xAxis.categories = month_th
                let result_voices = provider_voice.filter(item => item != 0)
                let result_sms = provider_sms.filter(item => item != 0)
                let result_mms = provider_mms.filter(item => item != 0)
                let result_internet = provider_internet.filter(item => item != 0)

                console.log('result_voices',result_voices)
                console.log('provider_voice',provider_voice)
            if(forminfo.distinguish === 1){

                let result_in_unit = []
                state.dataTable = []
                for(let p = 0 ; p < result_voices.length ; p ++){
                    let unit_data = []
                    result_in_unit[p] = []
                    state.serviceTable = []
                    let obj = {}
                    state.charts.voice.series.push({
                        name: provider_in_chart[p],
                        data: result_voices[p],
                        color: provider_color_chart[p]
                    })
                    state.charts.sms.series.push({
                        name: provider_in_chart[p],
                        data: result_sms[p],
                        color: provider_color_chart[p]
                    })
                    state.charts.mms.series.push({
                        name: provider_in_chart[p],
                        data: result_mms[p],
                        color: provider_color_chart[p]
                    })
                    state.charts.internet.series.push({
                        name: provider_in_chart[p],
                        data: result_internet[p],
                        color: provider_color_chart[p]
                    })

                    //get AVG
                    let voice_in_unit = result_voices[p].reduce((acc, item) => acc+item)
                    let sms_in_unit = result_sms[p].reduce((acc, item) => acc+item)
                    let mms_in_unit = result_mms[p].reduce((acc, item) => acc+item)
                    let internet_in_unit = result_internet[p].reduce((acc, item) => acc+item)
                    voice_in_unit /= result_voices[p].length
                    sms_in_unit /= result_sms[p].length
                    mms_in_unit /= result_mms[p].length
                    internet_in_unit /= result_internet[p].length
                    unit_data.push(parseFloat(voice_in_unit.toFixed(2)))
                    unit_data.push(parseFloat(sms_in_unit.toFixed(2)))
                    unit_data.push(parseFloat(mms_in_unit.toFixed(2)))
                    unit_data.push(parseFloat(internet_in_unit.toFixed(2)))
                    result_in_unit[p] = unit_data
                    console.log('result_in_unit',result_in_unit)
                    state.charts.unit.series.push({
                        name: provider_in_chart[p],
                        data: result_in_unit[p],
                        color: provider_color_chart[p]
                    })

                    //get dataTable 
                    if(voice_in_unit) state.serviceTable.push("Voice (บาท/นาที)")
                    if(sms_in_unit) state.serviceTable.push("SMS (บาท/ข้อความ)")
                    if(mms_in_unit) state.serviceTable.push("MMS (บาท/ข้อความ)")
                    if(internet_in_unit) state.serviceTable.push("Internet (บาท/MB)")
                    obj["data"] = result_in_unit[p]
                    obj["providers_name"] = provider_in_chart[p]
                    obj["providers_color"] = provider_color_chart[p]
                    state.dataTable.push(obj)
                }
                
                // console.log('state.dataTable',state.dataTable)
                // console.log('state.serviceTable',state.serviceTable)

                //show avg
                if(forminfo.barAvg == '1'){
                    let result_voice_avg = result_voices.reduce((prev, cur) => cur.map((val, i) => (prev[i] || 0) + val/result_voices.length), []);
                    let result_sms_avg = result_sms.reduce((prev, cur) => cur.map((val, i) => (prev[i] || 0) + val/result_sms.length), []);
                    let result_mms_avg = result_mms.reduce((prev, cur) => cur.map((val, i) => (prev[i] || 0) + val/result_mms.length), []);
                    let result_internet_avg = result_internet.reduce((prev, cur) => cur.map((val, i) => (prev[i] || 0) + val/result_internet.length), []);
                    state.charts.voice.series.push({
                        name: 'Average',
                        data: result_voice_avg,
                        color: '#000000'
                    })
                    state.charts.sms.series.push({
                        name: 'Average',
                        data: result_sms_avg,
                        color: '#000000'
                    })
                    state.charts.mms.series.push({
                        name: 'Average',
                        data: result_mms_avg,
                        color: '#000000'
                    })
                    state.charts.internet.series.push({
                        name: 'Average',
                        data: result_internet_avg,
                        color: '#000000'
                    })
                    console.log('result_voice_avg',result_voice_avg)
                }

            }
            //ไม่แยก ผบ
            else{
                //filter item in array not 0
                for(let i=0;i<result_voices.length;i++){
                    result_voices[i] = result_voices[i].filter(item => item !== 0)
                    result_sms[i] = result_sms[i].filter(item => item !== 0)
                    result_mms[i] = result_mms[i].filter(item => item !== 0)
                    result_internet[i] = result_internet[i].filter(item => item !== 0)
                }
                console.log('result_voices',result_voices)

                let avg_voice_year = result_voices.reduce((preindex, curindex) => curindex.map((val, i) => (((preindex[i] || 0) + val)/result_voices.length), []) )
                let avg_sms_year = result_sms.reduce((preindex, curindex) => curindex.map((val, i) => (((preindex[i] || 0) + val)/result_sms.length), []) )
                let avg_mms_year = result_mms.reduce((preindex, curindex) => curindex.map((val, i) => (((preindex[i] || 0) + val)/result_mms.length), []) )
                let avg_internet_year = result_internet.reduce((preindex, curindex) => curindex.map((val, i) => (((preindex[i] || 0) + val)/result_internet.length), []) )
                console.log('avg_voice_year',avg_voice_year)
                state.charts.voice.series.push({
                    name: 'Voice (บาท/นาที)',
                    data: avg_voice_year,
                    color: "#7bb5eb"
                })
                state.charts.sms.series.push({
                    name:  'SMS (บาท/ข้อความ)',
                    data: avg_sms_year,
                    color: "#434348"
                })
                state.charts.mms.series.push({
                    name: 'MMS (บาท/ข้อความ)',
                    data: avg_mms_year,
                    color: "#90ed7d"
                })
                state.charts.internet.series.push({
                    name: 'Internet (บาท/MB)',
                    data: avg_internet_year,
                    color: "#f7a35c"
                })

                let all_voice = parseFloat((avg_voice_year.reduce((prev,cur) => prev+cur,0) / avg_voice_year.length).toFixed(2))
                let all_sms = parseFloat((avg_sms_year.reduce((prev,cur) => prev+cur,0) / avg_sms_year.length).toFixed(2))
                let all_mms = parseFloat((avg_mms_year.reduce((prev,cur) => prev+cur,0) / avg_mms_year.length).toFixed(2))
                let all_internet = parseFloat((avg_internet_year.reduce((prev,cur) => prev+cur,0) / avg_internet_year.length).toFixed(2))
                
                state.charts.unit.series = [
                    {
                        name : 'Voice (บาท/นาที)',
                        data : [all_voice],
                        color: "#7bb5eb"
                    },
                    {
                        name : 'SMS (บาท/ข้อความ)',
                        data : [all_sms],
                        color: "#434348"
                    },
                    {
                        name : 'MMS (บาท/ข้อความ)',
                        data : [all_mms],
                        color: "#90ed7d"
                    },
                    {
                        name : 'Internet (บาท/MB)',
                        data : [all_internet],
                        color: "#f7a35c"
                    },
                ]

                //dataTable
                state.dataTable = []
                state.serviceTable= ["Voice (บาท/นาที)","SMS (บาท/ข้อความ)","MMS (บาท/ข้อความ)","Internet (บาท/MB)"]
                let res = {}
                    res["data"] = [all_voice,all_sms,all_mms,all_internet]
                    res["providers_name"] = `ผู้ให้บริการทั้งหมด ปี ${parseInt(year)+543}`
                    res["providers_color"] = ''
                console.log('res',res)
                state.dataTable.push(res)
        
                
            }
            
        } 
        else if( year >= 2018){
                let main = {
                    // prop_sevice: 0.8,
                    amount: 0,
                    voice_m: 0,
                    voice_s: 0,
                    sms: 0,
                    mms: 0,
                    internet: 0,
                    amount_voice: 0,
                    amount_sec: 0,
                    amount_sms: 0,
                    amount_mms: 0,
                    amount_internet: 0,
                }
                let ontop = {
                    // prop_sevice: 0.2,
                    amount: 0,
                    voice_m: 0,
                    voice_s: 0,
                    sms: 0,
                    mms: 0,
                    internet: 0,
                    amount_voice: 0,
                    amount_sec: 0,
                    amount_sms: 0,
                    amount_mms: 0,
                    amount_internet: 0,
                }
                let total = {
                    amount: 0,
                    voice_m: 0,
                    voice_s: 0,
                    sms: 0,
                    mms: 0,
                    internet: 0,
                }
                let data_in_unit = {
                    amount: [],
                    voice: [],
                    sms: [],
                    mms: [],
                    internet: [],
                    amount_voice: [],
                    amount_sec: [],
                    amount_sms: [],
                    amount_mms: [],
                    amount_internet: [],
                }
                //use normaldata
                if(state.ontop_proportion == 0) state.main_proportion == 100
                            // console.log('state.main_proportion',state.main_proportion,state.ontop_proportion)
                            let data_in_pro = []
                            
                            for(let p =0;p<provider_id_list.length;p++){
                                data_in_pro[p] = []
                                data_in_unit.amount[p] = []
                                data_in_unit.voice[p] = []
                                data_in_unit.sms[p] = []
                                data_in_unit.mms[p] = []
                                data_in_unit.internet[p] = []
                                data_in_unit.amount_voice[p] = []
                                data_in_unit.amount_sec[p] = []
                                data_in_unit.amount_sms[p] = []
                                data_in_unit.amount_mms[p] = []
                                data_in_unit.amount_internet[p] = []
                                var month_TH = []
                                let count_mount = 0
                                for(let date = obj.date.start;date < obj.date.end ; date = moment(date).add(1,'M')){
                                    
                                    let yearDate = moment(date).add(543,'y').format('YYYY')
                                    let monthDate = month_th[moment(date).format('M')-1]
                                    let curmonth = moment(date).format('M-YYYY')
                                    month_TH.push(monthDate)
                                    
                                    let rowdatas = obj.qrydata.filter(item => item.monthly == curmonth && provider_id_list[p].includes(item.provider_id))
                                    for(let datagroup=0; datagroup<provider_id_list[p].length; datagroup++){
                                        let rowdata = rowdatas.filter(item =>  item.provider_id == provider_id_list[p][datagroup])
                                        // console.log('curmonth',curmonth,'rowdata',rowdata)
                                        for(let r=0;r<rowdata.length;r++){
                                            if(rowdata.length !== 0){
                                                // console.log('curmonth',curmonth,'row',rowdata[r])
                                                if(rowdata[r].promotion_type === 'main'){
                                                    main.amount += rowdata[r].amount
                                                    main.voice_m += rowdata[r].vpm_avg
                                                    main.voice_s += rowdata[r].vps_avg
                                                    main.sms += rowdata[r].sms_avg
                                                    main.mms += rowdata[r].mms_avg
                                                    main.internet += rowdata[r].internet_avg
                                                    main.amount_voice += rowdata[r].amount_voice
                                                    main.amount_sec += rowdata[r].amount_sec
                                                    main.amount_sms += rowdata[r].amount_sms
                                                    main.amount_mms += rowdata[r].amount_mms
                                                    main.amount_internet += rowdata[r].amount_internet
                                                }else{
                                                    ontop.amount += rowdata[r].amount
                                                    ontop.voice_m += rowdata[r].vpm_avg
                                                    ontop.voice_s += rowdata[r].vps_avg
                                                    ontop.sms += rowdata[r].sms_avg
                                                    ontop.mms += rowdata[r].mms_avg
                                                    ontop.internet += rowdata[r].internet_avg
                                                    ontop.amount_voice += rowdata[r].amount_voice
                                                    ontop.amount_sec += rowdata[r].amount_sec
                                                    ontop.amount_sms += rowdata[r].amount_sms
                                                    ontop.amount_mms += rowdata[r].amount_mms
                                                    ontop.amount_internet += rowdata[r].amount_internet
                                                }
                                            }
                                            
                                        }

                                        //check voicepersec is not null
                                        if(main.voice_s !== 0 || ontop.voice_s !== 0){
                                            console.log('have second data')
                                            main.voice_m = main.voice_m  + (main.voice_s*60)
                                            ontop.voice_m = ontop.voice_m  + (ontop.voice_s*60)
                                        }
                                        console.log('m',main,'o',ontop)
                                        if(ontop.amount_mms == 0){
                                            state.main_proportion = 100
                                            total.mms = parseFloat((((main.mms/main.amount_mms)*(state.main_proportion/100))).toFixed(3))
                                        }else{
                                            state.main_proportion = 80
                                            total.mms = parseFloat((((main.mms/main.amount_mms)*(state.main_proportion/100)) + ((ontop.mms/ontop.amount_mms) *(state.ontop_proportion/100))).toFixed(3))
                                        }
                                        if(ontop.amount_voice == 0){
                                            state.main_proportion = 100
                                            total.voice_m = parseFloat((((main.voice_m/main.amount_voice)*(state.main_proportion/100))).toFixed(3))

                                        }else{
                                            state.main_proportion = 80
                                            total.voice_m = parseFloat((((main.voice_m/main.amount_voice)*(state.main_proportion/100)) + ((ontop.voice_m/ontop.amount_voice) * (state.ontop_proportion/100))).toFixed(3))
                                        }
                                        if(ontop.amount_sms == 0){
                                            state.main_proportion = 100
                                            total.sms = parseFloat((((main.sms/main.amount_sms)*(state.main_proportion/100))).toFixed(3))
        
                                        }else{
                                            state.main_proportion = 80
                                            total.sms = parseFloat((((main.sms/main.amount_sms)*(state.main_proportion/100)) + ((ontop.sms/ontop.amount_sms) * (state.ontop_proportion/100))).toFixed(3))
                                        }
                                        if(ontop.amount_internet == 0){
                                            state.main_proportion = 100
                                            total.internet = parseFloat((((main.internet/main.amount_internet)*(state.main_proportion/100))).toFixed(3))
        
                                        }else{
                                            state.main_proportion = 80
                                            total.internet = parseFloat((((main.internet/main.amount_internet)*(state.main_proportion/100)) + ((ontop.internet/ontop.amount_internet) * (state.ontop_proportion/100))).toFixed(3))
                                        }


                                            // total.voice_m = parseFloat((((main.voice_m/main.amount)*(state.main_proportion/100)) + ((ontop.voice_m/ontop.amount) *(state.ontop_proportion/100))).toFixed(3))
                                            // total.sms = parseFloat((((main.sms/main.amount)*(state.main_proportion/100)) + ((ontop.sms/ontop.amount) *(state.ontop_proportion/100))).toFixed(3))
                                            // total.mms = parseFloat((((main.mms/main.amount)*(state.main_proportion/100)) + ((ontop.mms/ontop.amount) *(state.ontop_proportion/100))).toFixed(3))
                                            // total.internet = parseFloat((((main.internet/main.amount)*(state.main_proportion/100)) + ((ontop.internet/ontop.amount) *(state.ontop_proportion/100))).toFixed(3))
                                            // total.amount = main.amount + ontop.amount
                                            // if(total.amount !== 0){
                                                data_in_unit.amount[p].push(total.amount)
                                                data_in_unit.voice[p].push(total.voice_m)
                                                data_in_unit.sms[p].push(total.sms)
                                                data_in_unit.mms[p].push(total.mms)
                                                data_in_unit.internet[p].push(total.internet)
                                                data_in_unit.amount_voice[p].push(main.amount_voice+ontop.amount_voice)
                                                data_in_unit.amount_sms[p].push(main.amount_sms+ontop.amount_sms)
                                                data_in_unit.amount_mms[p].push(main.amount_mms+ontop.amount_mms)
                                                data_in_unit.amount_internet[p].push(main.amount_internet + ontop.amount_internet)
                                                data_in_pro[p].push({
                                                    avg_voice: total.voice_m,
                                                    avg_sms: total.sms,
                                                    avg_mms: total.mms,
                                                    avg_internet: total.internet
                                                })
                                            // }
                                        // console.log('total.amount',total.amount)
                                        total = {
                                            amount: 0,
                                            voice_m: 0,
                                            voice_s: 0,
                                            sms: 0,
                                            mms: 0,
                                            internet: 0,
                                        }
                                        main = {
                                            amount: 0,
                                            voice_m: 0,
                                            voice_s: 0,
                                            sms: 0,
                                            mms: 0,
                                            internet: 0,
                                            amount_voice: 0,
                                            amount_sec: 0,
                                            amount_sms: 0,
                                            amount_mms: 0,
                                            amount_internet: 0,
                                        }
                                        ontop = {
                                            amount: 0,
                                            voice_m: 0,
                                            voice_s: 0,
                                            sms: 0,
                                            mms: 0,
                                            internet: 0,
                                            amount_voice: 0,
                                            amount_sec: 0,
                                            amount_sms: 0,
                                            amount_mms: 0,
                                            amount_internet: 0,
                                        }
                                        
                                    }
                                // console.log('---end provider_id_list--',provider_id_list[p])
                                count_mount += 1
                                }
                                // console.log('----endmonth----')
                            }
                            console.log('data_in_unit',data_in_unit)
                            
                            //amount data main + ontop of providers in same month 
                            let data_amount_in_month = data_in_unit.amount.reduce((preindex, curindex) => curindex.map((val, i) => (((preindex[i] || 0) + val)), []) )
                            let voice_amount_in_month = data_in_unit.amount_voice.reduce((preindex, curindex) => curindex.map((val, i) => (((preindex[i] || 0) + val)), []) )
                            let sms_amount_in_month = data_in_unit.amount_sms.reduce((preindex, curindex) => curindex.map((val, i) => (((preindex[i] || 0) + val)), []) )
                            let mms_amount_in_month = data_in_unit.amount_mms.reduce((preindex, curindex) => curindex.map((val, i) => (((preindex[i] || 0) + val)), []) )
                            let internet_amount_in_month = data_in_unit.amount_internet.reduce((preindex, curindex) => curindex.map((val, i) => (((preindex[i] || 0) + val)), []) )
                            console.log('voice_amount_in_month',voice_amount_in_month)

                            //เก็บค่าของแต่ละผู้ให้บริการในอารเรย์โดยเรียงลำดับตาม ผบ
                            let avg_in_voice = []
                            let avg_in_sms = []
                            let avg_in_mms = []
                            let avg_in_internet = []
                            let avg_voice = []
                            let avg_sms = []
                            let avg_mms = []
                            let avg_internet = []
                            let result_in_unit = []
                            let filter_avg_voice = []
                            let filter_avg_sms = []
                            let filter_avg_mms = []
                            let filter_avg_internet = []
                            let every_data = {
                                voice: [],
                                sms: [],
                                mms: [],
                                internet: []
                            }

                            state.dataTable = []
                                for(let p =0;p<provider_id_list.length;p++){
                                    // console.log('this loop')
                                    avg_in_voice[p] = []
                                    avg_in_sms[p] = []
                                    avg_in_mms[p] = []
                                    avg_in_internet[p] = []
                                    result_in_unit[p] = []
                                    filter_avg_voice[p] = []
                                    filter_avg_sms[p] = []
                                    filter_avg_mms[p] = []
                                    filter_avg_internet[p] = []
                                    let sum_voice = 0
                                    let sum_sms = 0
                                    let sum_mms = 0
                                    let sum_internet = 0
                                    let sum_amount = 0
                                    let data_result = {
                                        voice: 0,
                                        sms: 0,
                                        mms: 0,
                                        internet: 0
                                    }
                                    let count_month = 0
                                    for(let date = obj.date.start;date < obj.date.end ; date = moment(date).add(1,'M')){
                                        let curmonth = moment(date).format('M-YYYY')
                                        let sum_voice_providers = 0
                                        let sum_sms_providers = 0
                                        let sum_mms_providers = 0
                                        let sum_internet_providers = 0
                                        if(forminfo.distinguish === 1){
                                            // จำแนกผบ และ ถ่วงน้ำหนัก
                                            if(forminfo.weighting == 1){
                                                    console.log('data_in_unit.voice[p][count_month] * data_in_unit.amount_voice[p][count_month]',p,count_month,'--',data_in_unit.voice[p][count_month],data_in_unit.amount_voice[p][count_month])

                                                sum_voice = data_in_unit.voice[p][count_month] * data_in_unit.amount_voice[p][count_month] 
                                                sum_sms = data_in_unit.sms[p][count_month] * data_in_unit.amount_sms[p][count_month] 
                                                sum_mms = data_in_unit.mms[p][count_month] * data_in_unit.amount_mms[p][count_month] 
                                                sum_internet = data_in_unit.internet[p][count_month] * data_in_unit.amount_internet[p][count_month] 
                                                
                                                data_result.voice = sum_voice/voice_amount_in_month[count_month] 
                                                data_result.sms = sum_sms/sms_amount_in_month[count_month] 
                                                data_result.mms = sum_mms/mms_amount_in_month[count_month] 
                                                data_result.internet = sum_internet/internet_amount_in_month[count_month] 
                                            }else{
                                                data_result.voice = data_in_unit.voice[p][count_month] 
                                                data_result.sms = data_in_unit.sms[p][count_month] 
                                                data_result.mms = data_in_unit.mms[p][count_month] 
                                                data_result.internet = data_in_unit.internet[p][count_month] 
                                            }
                                        }else{
                                            if(forminfo.weighting == 1){
                                                sum_voice_providers += data_in_unit.voice[p][count_month] * data_in_unit.amount_voice[p][count_month]
                                                sum_sms_providers += data_in_unit.sms[p][count_month] * data_in_unit.amount_sms[p][count_month]
                                                sum_mms_providers += data_in_unit.mms[p][count_month] * data_in_unit.amount_mms[p][count_month]
                                                sum_internet_providers += data_in_unit.internet[p][count_month] * data_in_unit.amount_internet[p][count_month]

                                                data_result.voice = sum_voice_providers
                                                data_result.sms = sum_sms_providers
                                                data_result.mms = sum_mms_providers
                                                data_result.internet = sum_internet_providers
                                            }else{
                                                sum_voice_providers += data_in_unit.voice[p][count_month]
                                                sum_sms_providers += data_in_unit.sms[p][count_month]
                                                sum_mms_providers += data_in_unit.mms[p][count_month]
                                                sum_internet_providers += data_in_unit.internet[p][count_month]

                                                data_result.voice = sum_voice_providers
                                                data_result.sms = sum_sms_providers
                                                data_result.mms = sum_mms_providers
                                                data_result.internet = sum_internet_providers
                                            }
                                            console.log('sum_voice_providers',sum_voice_providers)
                                        }

                                        //         if(forminfo.weighting == 1){
                                        //             //ถ่วงนน
                                        //             console.log('data_in_unit.voice[p][count_month] * data_in_unit.amount[p][count_month]',p,count_month,'--',data_in_unit.voice[p][count_month],data_in_unit.amount[p][count_month])
                                        //             sum_voice = data_in_unit.voice[p][count_month] * data_in_unit.amount[p][count_month]
                                        //             sum_sms = data_in_unit.sms[p][count_month] * data_in_unit.amount[p][count_month]
                                        //             sum_mms = data_in_unit.mms[p][count_month] * data_in_unit.amount[p][count_month]
                                        //             sum_internet = data_in_unit.internet[p][count_month] * data_in_unit.amount[p][count_month]
                                        //             sum_amount = data_amount_in_month[count_month]
        
                                        //         }else{
                                        //             //ไม่ถ่วง
                                        //             sum_voice = data_in_unit.voice[p][count_month]
                                        //             sum_sms = data_in_unit.sms[p][count_month]
                                        //             sum_mms = data_in_unit.mms[p][count_month]
                                        //             sum_internet = data_in_unit.internet[p][count_month]
                                        //         }
                                        // if(forminfo.weighting == 1){
                                        //     // console.log('ถ่วงง',sum_voice)
                                        //     console.log('sum_voice/sum_amount',sum_voice,'/',sum_amount)
                                        //     data_result.voice = sum_voice/sum_amount
                                        //     data_result.sms = sum_sms/sum_amount
                                        //     data_result.mms = sum_mms/sum_amount
                                        //     data_result.internet = sum_internet/sum_amount
                                        // }else{
                                        //     //ไม่ถ่วง
                                        //     // console.log('ไม่ถ่วงง',sum_voice)
                                        //     console.log('sum_voice/data_in_unit.amount.length',sum_voice,data_in_unit.amount.length)
                                        //     data_result.voice = sum_voice/data_in_unit.amount.length
                                        //     data_result.sms = sum_sms/data_in_unit.amount.length
                                        //     data_result.mms= sum_mms/data_in_unit.amount.length
                                        //     data_result.internet = sum_internet/data_in_unit.amount.length
                                        // }
                                        // console.log('data_result.voice',data_result.voice,'=',sum_voice,sum_amount)
                                        console.log('---end month ',curmonth)
                                        console.log('avg -> data_result.voice',data_result.voice)
                                        isNaN(data_result.voice) ? avg_in_voice[p].push(0) : avg_in_voice[p].push(data_result.voice)
                                        isNaN(data_result.sms) ? avg_in_sms[p].push(0) : avg_in_sms[p].push(data_result.sms)
                                        isNaN(data_result.mms) ? avg_in_mms[p].push(0) : avg_in_mms[p].push(data_result.mms)
                                        isNaN(data_result.internet) ? avg_in_internet[p].push(0) : avg_in_internet[p].push(data_result.internet)

                                        sum_voice = 0
                                        sum_sms = 0
                                        sum_mms = 0
                                        sum_internet = 0
                                        // sum_amount = 0
                                        data_result = {
                                            voice: 0,
                                            sms: 0,
                                            mms: 0,
                                            internet: 0
                                        }
                                        count_month += 1
                                        state.serviceTable = []
                                    }
                                    
                                    //กรองข้อมูลที่ไม่ใช่ 0 จะเป็นโชว์แค่เดือนที่มีข้อมูล
                                    filter_avg_voice[p] = avg_in_voice[p]
                                    filter_avg_sms[p] = avg_in_sms[p]
                                    filter_avg_mms[p] = avg_in_mms[p]
                                    filter_avg_internet[p] = avg_in_internet[p]
                                    filter_avg_voice[p] = filter_avg_voice[p].filter(item => item !== 0)
                                    filter_avg_sms[p] = filter_avg_sms[p].filter(item => item !== 0)
                                    filter_avg_mms[p] = filter_avg_mms[p].filter(item => item !== 0)
                                    filter_avg_internet[p] = filter_avg_internet[p].filter(item => item !== 0)  

                                    console.log('count_item',avg_in_voice)
                                    console.log('filter_avg_voice',filter_avg_voice)
                                    // array of average each provider
                                    avg_voice.push(avg_in_voice[p].reduce((prev, cur) => prev + cur ,0) / filter_avg_voice[p].length)
                                    avg_sms.push(avg_in_sms[p].reduce((prev, cur) => prev + cur ,0) / filter_avg_sms[p].length)
                                    avg_mms.push(avg_in_mms[p].reduce((prev, cur) => prev + cur ,0) / filter_avg_mms[p].length)
                                    avg_internet.push(avg_in_internet[p].reduce((prev, cur) => prev + cur ,0) / filter_avg_internet[p].length)
                                    console.log('avg_voice',avg_voice)

                                    //get all value to find max
                                    every_data.voice.push(...avg_in_voice[p]) 
                                    every_data.sms.push(...avg_in_sms[p]) 
                                    every_data.mms.push(...avg_in_mms[p]) 
                                    every_data.internet.push(...avg_in_internet[p]) 
                                
                                    //array order by voice,sms,mms,int of month 

                                    // this array value is every month of v,s,m,i 
                                    // result_in_unit[p].push(avg_in_voice[p])
                                    // result_in_unit[p].push(avg_in_sms[p])
                                    // result_in_unit[p].push(avg_in_mms[p])
                                    // result_in_unit[p].push(avg_in_internet[p])

                                    //ข้อมูลเฉลี่ยทั้งปี แต่ละผู้ให้บริการ เรียงตามลำดับ
                                    result_in_unit[p].push(avg_voice[p])
                                    result_in_unit[p].push(avg_sms[p])
                                    result_in_unit[p].push(avg_mms[p])
                                    result_in_unit[p].push(avg_internet[p])
        
                                    
                                    // console.log('avg_in_voice',avg_in_voice)
                                    if(forminfo.distinguish === 1){
                                        //chart
                                        state.charts.voice.series.push({
                                            name: provider_in_chart[p],
                                            data: avg_in_voice[p],
                                            color: provider_color_chart[p]
                                        })
                                        state.charts.sms.series.push({
                                            name: provider_in_chart[p],
                                            data: avg_in_sms[p],
                                            color: provider_color_chart[p]
                                        })
                                        state.charts.mms.series.push({
                                            name: provider_in_chart[p],
                                            data: avg_in_mms[p],
                                            color: provider_color_chart[p]
                                        })
                                        state.charts.internet.series.push({
                                            name: provider_in_chart[p],
                                            data: avg_in_internet[p],
                                            color: provider_color_chart[p]
                                        })
                                        state.charts.unit.series.push({
                                            name : provider_in_chart[p],
                                            data : result_in_unit[p],
                                            color: provider_color_chart[p]
                                        })
                                        state.charts.unit.xAxis.categories = ["Voice (บาท/นาที)","SMS (บาท/ข้อความ)","MMS (บาท/ข้อความ)","Internet (บาท/MB)"]
                                    
                                        if(forminfo.forecast){
                                            console.log('forecast')
                                            avg_in_voice[p].push(avg_voice[p])
                                            avg_in_sms[p].push(avg_sms[p])
                                            avg_in_mms[p].push(avg_mms[p])
                                            avg_in_internet[p].push(avg_internet[p])
                                            month_TH.push('Forecast')
                                        }

                                        console.log('result_in_unit',result_in_unit)
                                        //get dataTable 
                                        let dataTAble = {}
                                        if(avg_in_voice) state.serviceTable.push("Voice (บาท/นาที)")
                                        if(avg_in_sms) state.serviceTable.push("SMS (บาท/ข้อความ)")
                                        if(avg_in_mms) state.serviceTable.push("MMS (บาท/ข้อความ)")
                                        if(avg_in_internet) state.serviceTable.push("Internet (บาท/MB)")
                                        dataTAble["data"] = result_in_unit[p]
                                        dataTAble["providers_name"] = provider_in_chart[p]
                                        dataTAble["providers_color"] = provider_color_chart[p]
                                        state.dataTable.push(dataTAble)
                                    }
                                    

                                }
                                console.log('avg_in_voice',avg_in_voice)

                                //avg of each provider in same month to one array
                                let avg_voice_months = avg_in_voice.reduce((preindex, curindex) => curindex.map((val, i) => (((preindex[i] || 0) + val)), []) )
                                let avg_sms_months = avg_in_sms.reduce((preindex, curindex) => curindex.map((val, i) => (((preindex[i] || 0) + val)), []) )
                                let avg_mms_months = avg_in_mms.reduce((preindex, curindex) => curindex.map((val, i) => (((preindex[i] || 0) + val)), []) )
                                let avg_internet_months = avg_in_internet.reduce((preindex, curindex) => curindex.map((val, i) => (((preindex[i] || 0) + val)), []) )
                                let avg_voice_of_month = avg_voice_months.map(item => item/provider_list.length)
                                let avg_sms_of_month = avg_sms_months.map(item => item/provider_list.length)
                                let avg_mms_of_month = avg_mms_months.map(item => item/provider_list.length)
                                let avg_internet_of_month = avg_internet_months.map(item => item/provider_list.length)
                                console.log('avg_voice_months',avg_voice_months)
                                //ไม่จำแนกผู้ให้บริการ ค่าเฉลี่ยของผบในแต่ละเดือน
                                if(forminfo.distinguish === 2){
                                    let sum_voice_providers = avg_in_voice.reduce((preindex, curindex) => curindex.map((val, i) => (((preindex[i] || 0) + val)), []) )
                                    let sum_sms_providers = avg_in_sms.reduce((preindex, curindex) => curindex.map((val, i) => (((preindex[i] || 0) + val)), []) )
                                    let sum_mms_providers = avg_in_mms.reduce((preindex, curindex) => curindex.map((val, i) => (((preindex[i] || 0) + val)), []) )
                                    let sum_internet_providers = avg_in_internet.reduce((preindex, curindex) => curindex.map((val, i) => (((preindex[i] || 0) + val)), []) )
                                    let voice_result = []
                                    let sms_result = []
                                    let mms_result = []
                                    let internet_result = []
                                    console.log('sx',sum_voice_providers)
                                    console.log('vm',voice_amount_in_month)
                                    for(let date = obj.date.start;date < obj.date.end ; date = moment(date).add(1,'M')){
                                        let curmonth = parseInt(moment(date).format('M')) - 1
                                        console.log('c',curmonth)
                                        if(forminfo.weighting == 1){  
                                            let voice = parseFloat((sum_voice_providers[curmonth]/voice_amount_in_month[curmonth]).toFixed(3))
                                            let sms = parseFloat((sum_sms_providers[curmonth]/sms_amount_in_month[curmonth]).toFixed(3))
                                            let mms = parseFloat((sum_mms_providers[curmonth]/mms_amount_in_month[curmonth]).toFixed(3))
                                            let internet = parseFloat((sum_internet_providers[curmonth]/internet_amount_in_month[curmonth]).toFixed(3))
                                            !isNaN(voice) ? voice : voice = 0
                                            !isNaN(sms) ? sms : sms = 0
                                            !isNaN(mms) ? mms : mms = 0
                                            !isNaN(internet) ? internet : internet = 0
                                            voice_result.push(voice) 
                                            sms_result.push(sms) 
                                            mms_result.push(mms) 
                                            internet_result.push(internet) 
                                        }else{
                                            voice_result.push(parseFloat((sum_voice_providers[curmonth]/provider_id_list.length).toFixed(3))) 
                                            sms_result.push(parseFloat((sum_sms_providers[curmonth]/provider_id_list.length).toFixed(3))) 
                                            mms_result.push(parseFloat((sum_mms_providers[curmonth]/provider_id_list.length).toFixed(3))) 
                                            internet_result.push(parseFloat((sum_internet_providers[curmonth]/provider_id_list.length).toFixed(3)))
                                        }
                                    }
                                    console.log('voice_result',voice_result)
                                    console.log('sum_voice_providers',sum_voice_providers)
                                    //chart
                                    state.charts.voice.series.push({
                                        name: "Voice (บาท/นาที)",
                                        data: voice_result,
                                        color: 'rgb(124, 181, 236)'
                                    })
                                    state.charts.sms.series.push({
                                        name: "SMS (บาท/ข้อความ)",
                                        data: sms_result,
                                        color: 'rgb(67, 67, 72)'
                                    })
                                    state.charts.mms.series.push({
                                        name: "MMS (บาท/ข้อความ)",
                                        data: mms_result,
                                        color: 'rgb(144, 237, 125)'
                                    })
                                    state.charts.internet.series.push({
                                        name: "Internet (บาท/MB)",
                                        data: internet_result,
                                        color: 'rgb(247, 163, 92)'
                                    })

                                    //all data every month in arr to one avg show in unit chart
                                    var all_avg_voice = voice_result.reduce((prev,cur) => prev + cur ,0) / filter_avg_voice[0].length
                                    var all_avg_sms = sms_result.reduce((prev,cur) => prev + cur ,0) / filter_avg_sms[0].length
                                    var all_avg_mms = mms_result.reduce((prev,cur) => prev + cur ,0) / filter_avg_mms[0].length
                                    var all_avg_internet = internet_result.reduce((prev,cur) => prev + cur ,0) / filter_avg_internet[0].length
                                    console.log('all_avg_voice',all_avg_voice)
                                    state.charts.unit.series = [
                                        {
                                            name : "Voice (บาท/นาที)",
                                            data : [all_avg_voice],
                                            color: 'rgb(124, 181, 236)'
                                        },
                                        {
                                            name : "SMS (บาท/ข้อความ)",
                                            data : [all_avg_sms],
                                            color: 'rgb(67, 67, 72)'
                                        },
                                        {
                                            name : "MMS (บาท/ข้อความ)",
                                            data : [all_avg_mms],
                                            color: 'rgb(144, 237, 125)'
                                        },
                                        {
                                            name : "Internet (บาท/MB)",
                                            data : [all_avg_internet],
                                            color: 'rgb(247, 163, 92)'
                                        },
                                    ]

                                    if(forminfo.forecast){
                                        console.log('forecast')
                                            voice_result.push(all_avg_voice)
                                            sms_result.push(all_avg_sms)
                                            mms_result.push(all_avg_mms)
                                            internet_result.push(all_avg_internet)
                                            month_TH.push('Forecast')
                                    }

                                    //get dataTable
                                    state.serviceTable= ["Voice (บาท/นาที)","SMS (บาท/ข้อความ)","MMS (บาท/ข้อความ)","Internet (บาท/MB)"]
                                    let dataTable = {}
                                        dataTable["data"] = [all_avg_voice,all_avg_sms,all_avg_mms,all_avg_internet]
                                        dataTable["providers_name"] = `ผู้ให้บริการทั้งหมดในปี ${yearTH}`
                                        dataTable["providers_color"] = ''
                                    state.dataTable.push(dataTable)

                                    maxvoice = voice_result.reduce((prev, cur) => (prev > cur) ? prev : cur)
                                    maxsms = sms_result.reduce((prev, cur) => (prev > cur) ? prev : cur)
                                    maxmms = mms_result.reduce((prev, cur) => (prev > cur) ? prev : cur)
                                    maxinternet = internet_result.reduce((prev, cur) => (prev > cur) ? prev : cur)
                                }
                            
                            // state.charts.unit.xAxis.categories = ""
                            state.charts.voice.xAxis.categories = month_TH
                            state.charts.sms.xAxis.categories = month_TH
                            state.charts.mms.xAxis.categories = month_TH
                            state.charts.internet.xAxis.categories = month_TH
                            
                            
                            if(forminfo.distinguish === 1){

                                console.log('e',every_data.voice)
                                if(forminfo.barAvg == '1'){
                                    state.charts.voice.series.push({
                                        name: 'Average',
                                        data: avg_voice_of_month,
                                        color: '#42f9ff'
                                    })
                                    state.charts.sms.series.push({
                                        name: 'Average',
                                        data: avg_sms_of_month,
                                        color: '#42f9ff'
                                    })
                                    state.charts.mms.series.push({
                                        name: 'Average',
                                        data: avg_mms_of_month,
                                        color: '#42f9ff'
                                    })
                                    state.charts.internet.series.push({
                                        name: 'Average',
                                        data: avg_internet_of_month,
                                        color: '#42f9ff'
                                    })
                                }
                                maxvoice = every_data.voice.reduce((prev, cur) => (prev > cur) ? prev : cur)
                                maxsms = every_data.sms.reduce((prev, cur) => (prev > cur) ? prev : cur)
                                maxmms = every_data.mms.reduce((prev, cur) => (prev > cur) ? prev : cur)
                                maxinternet = every_data.internet.reduce((prev, cur) => (prev > cur) ? prev : cur)
                            }
        }
    //แสดงเพดานกำกับ
    if(forminfo.graphLine == true){
        let graphLine = obj.serviceRate
        let year = moment(forminfo.type_data.month).format('YYYY')
        let start = moment('01-01-'+ year, 'DD-MM-YYYY')
        let end = moment(start).add(1,'Y')
            end = moment(end).subtract(1,'d')
        let voice_service_rate = 0
        let sms_service_rate = 0
        let mms_service_rate = 0
        let internet_service_rate = 0
        let service_name = ""
        for(let i = 0 ; i < graphLine.length ; i++){
            if((moment(graphLine[i].end_date).format('DD-MM-YYYY') >= moment(end).format('DD-MM-YYYY')) && (moment(graphLine[i].start_date).format('DD-MM-YYYY') <= moment(start).format('DD-MM-YYYY'))){
                voice_service_rate = graphLine[i].voice_service_rate
                sms_service_rate  = graphLine[i].sms_service_rate
                mms_service_rate  = graphLine[i].mms_service_rate
                internet_service_rate  = graphLine[i].internet_service_rate
                service_name = graphLine[i].service_name
            }
        }
        console.log('max',maxvoice,'voice_service_rate',voice_service_rate)
        state.charts.voice.yAxis = [{
            min: 0,
            title: {
                text: 'อัตราค่าบริการเฉลี่ย'
            },
            plotLines: [{
                value: voice_service_rate,
                color: 'red',
                dashStyle: 'line',
                width: 2,
                zIndex: 5,
                label: {
                    text: `${service_name} ${voice_service_rate}`
                }
            },{
                value: maxvoice,
                color: 'red',
                dashStyle: 'shortdash',
                width: 2,
                label: {
                    text: ``
                }
            }]
        }]
        state.charts.sms.yAxis = [{
            min: 0,
            title: {
                text: 'อัตราค่าบริการเฉลี่ย'
            },
            plotLines: [{
                value: sms_service_rate,
                color: 'red',
                dashStyle: 'line',
                width: 2,
                zIndex: 5,
                label: {
                    text: `${service_name} ${sms_service_rate}`
                }
            },{
                value: maxsms,
                color: 'red',
                dashStyle: 'shortdash',
                width: 2,
                label: {
                    text: ``
                }
            }]
        }]
        state.charts.mms.yAxis =[{
            min: 0,
            title: {
                text: 'อัตราค่าบริการเฉลี่ย'
            },
            plotLines: [{
                value: mms_service_rate,
                color: 'red',
                dashStyle: 'line',
                width: 2,
                zIndex: 5,
                label: {
                    text: `${service_name} ${mms_service_rate}`
                }
            },{
                value: maxmms,
                color: 'red',
                dashStyle: 'shortdash',
                width: 2,
                label: {
                    text: ``
                }
            }]
            
        }]
        state.charts.internet.yAxis =[{
            min: 0,
            title: {
                text: 'อัตราค่าบริการเฉลี่ย'
            },
            plotLines: [{
                value: internet_service_rate,
                color: 'red',
                dashStyle: 'line',
                width: 2,
                zIndex: 5,
                label: {
                    text: `${service_name} ${internet_service_rate}`
                }
            },{
                value: maxinternet,
                color: 'red',
                dashStyle: 'shortdash',
                width: 2,
                label: {
                    text: ``
                }
            }]
        }]
    }else {
        state.charts.voice.yAxis = [{
            min: 0,
            title: {
                text: 'อัตราค่าบริการเฉลี่ย'
            },
            plotLines: []
        }]
        state.charts.sms.yAxis = [{
            min: 0,
            title: {
                text: 'อัตราค่าบริการเฉลี่ย'
            },
            plotLines: []
        }]
        state.charts.mms.yAxis = [{
            min: 0,
            title: {
                text: 'อัตราค่าบริการเฉลี่ย'
            },
            plotLines: []
        }]
        state.charts.internet.yAxis = [{
            min: 0,
            title: {
                text: 'อัตราค่าบริการเฉลี่ย'
            },
            plotLines: []
        }]
    }
        
  },
  BETWEEN_YEAR(state,obj){
      console.log('b yearr')

    let yearfrom = moment(obj.date.start).format('YYYY')
    let yearfromTH = moment(obj.date.start).add(543,'y').format('YYYY')
    let yearto = moment(obj.date.end).format('YYYY')
    let yeartoTH = moment(obj.date.end).add(543,'y').format('YYYY')

    let graphLine_text = obj.forminfo.graphLine ? " และเปรียบเทียบกับอัตราอ้างอิงบนคลื่นความถี่ 2.1 GHz" : ""
    let distinguish_text = obj.forminfo.distinguish == 1 ? "จำแนกตาม" : "ของ"
    state.charts.unit.title.text = "ภาพรวมอัตราค่าบริการเฉลี่ยของบริการ ประเภทเสียง บริการ SMS/MMS และ บริการ Internet ของผู้ให้บริการ โทรศัพท์เคลื่อนที่ระหว่างปี พ.ศ. "+yearfromTH+" ถึงปี พ.ศ. "+yeartoTH
    state.charts.voice.title.text = "อัตราค่าบริการเฉลี่ยของบริการประเภทเสียง "+distinguish_text+"ผู้ให้บริการโทรศัพท์เคลื่อนที่ระหว่างปี พ.ศ. "+yearfromTH+" ถึงปี พ.ศ. "+yeartoTH+graphLine_text
    state.charts.sms.title.text = "อัตราค่าบริการเฉลี่ยของบริการ SMS "+distinguish_text+"ผู้ให้บริการโทรศัพท์เคลื่อนที่ระหว่างปี พ.ศ. "+yearfromTH+" ถึงปี พ.ศ. "+yeartoTH+graphLine_text
    state.charts.mms.title.text = "อัตราค่าบริการเฉลี่ยของบริการ MMS "+distinguish_text+"ผู้ให้บริการโทรศัพท์เคลื่อนที่ระหว่างปี พ.ศ. "+yearfromTH+" ถึงปี พ.ศ. "+yeartoTH+graphLine_text
    state.charts.internet.title.text = "อัตราค่าบริการเฉลี่ยของบริการ Internet "+distinguish_text+"ผู้ให้บริการโทรศัพท์เคลื่อนที่ระหว่างปี พ.ศ. "+yearfromTH+" ถึงปี พ.ศ. "+yeartoTH+graphLine_text
    
    state.charts.unit.series = []
    state.charts.voice.series = []
    state.charts.sms.series = []
    state.charts.mms.series = []
    state.charts.internet.series = []

    state.charts.unit.xAxis.categories = []
    state.charts.voice.xAxis.categories = []
    state.charts.sms.xAxis.categories = []
    state.charts.mms.xAxis.categories = []
    state.charts.internet.xAxis.categories = []

    let forminfo = obj.forminfo
    // let item_list = ''
    let p_list = []
    let provider_id_list = []
    let provider_in_chart = []
    let provider_color_chart = []
    let provider_list = obj.forminfo.list
    for(let p = 0 ; p < provider_list.length ; p ++){
        let provider_name = obj.forminfo.compare_type == 'group' ? provider_list[p].group_name_th : provider_list[p].brand_name
        let provider_color = obj.forminfo.compare_type == 'group' ? provider_list[p].group_color_code : provider_list[p].provider_color
        let provider_id = obj.forminfo.compare_type == 'group' ? JSON.parse(provider_list[p].group_company_list) : [provider_list[p].id]
        provider_id_list.push(provider_id)
        // provider_name_list.push(provider_name)
        // provider_color_list.push(provider_color)

        // item_list += `${item_group},`
        p_list.push(provider_id)
        provider_in_chart.push(provider_name)
        provider_color_chart.push(provider_color)
    }
    // console.log('p_list',p_list)
    // console.log('provider_in_chart',provider_in_chart)
    // console.log('provider_color_chart',provider_color_chart)

    let maxvoice = 0
        let maxsms = 0
        let maxmms = 0
        let maxinternet = 0

        let datafix = obj.fixdata
            let newdata_fix = {
                voice_m: 0,
                voice: 0,
                sms: 0,
                mms: 0,
                internet: 0,
                freq: [],
                name: ''
            }
            
            let FIX_provider_voice = []
            let FIX_provider_sms = []
            let FIX_provider_mms = []
            let FIX_provider_internet = []
            let avg_in_voice = []
            let avg_in_sms = []
            let avg_in_mms = []
            let avg_in_internet = []
            
            for(let p = 0 ; p < p_list.length ; p ++){
                let FIX_voice_array = []
                let FIX_sms_array = []
                let FIX_mms_array = []
                let FIX_internet_array = []
                FIX_provider_voice[p] = []
                FIX_provider_sms[p] = []
                FIX_provider_mms[p] = []
                FIX_provider_internet[p] = []
                avg_in_voice[p] = []
                avg_in_sms[p] = []
                avg_in_mms[p] = []
                avg_in_internet[p] = []
                let month_number = 0
                let fix_amount = {
                    voice: 0,
                    sms: 0,
                    mms: 0,
                    internet: 0
                }
                var year_th = []
                for(let date = obj.date.start;date < obj.date.end ; date = moment(date).add(1,'M')){
                    let yearDate = moment(date).add(543,'y').format('YYYY')
                    let count_month = moment(date).format('MM')
                    let year_data = 'ปี '+yearDate
                    let curmonth = moment(date).format('M-YYYY')
                    console.log('curmonth',curmonth,p_list[p])
                    let fixa = obj.fixdata.filter(item => item.monthly == curmonth && item.provider_id == p_list[p])
                    // console.log('fixa',fixa)
                    if(fixa.length != 0){
                        for(let n=0;n<fixa.length;n++){
                            if(fixa[n].service_type == 'Voice'){
                                newdata_fix.voice += fixa[n].price_avg
                                fix_amount.voice += 1
                            }else if(fixa[n].service_type == 'SMS'){
                                newdata_fix.sms += fixa[n].price_avg
                                fix_amount.sms += 1
                            }else if(fixa[n].service_type == 'MMS'){
                                newdata_fix.mms += fixa[n].price_avg
                                fix_amount.mms += 1
                            }else if(fixa[n].service_type == 'Internet'){
                                newdata_fix.internet += fixa[n].price_avg
                                fix_amount.internet += 1
                            }
                                // month_number += 1
                        }
                        
                    }else{
                        newdata_fix.voice = 0
                        newdata_fix.sms = 0
                        newdata_fix.mms = 0
                        newdata_fix.internet = 0
                    }
                        console.log('fix',newdata_fix.internet,fix_amount.internet)
                        console.log('month_number here',month_number,count_month,yearDate)
                        //check the last month of year then find avg
                        if(count_month == 12){
                            newdata_fix.voice != 0 ? FIX_voice_array.push(newdata_fix.voice/fix_amount.voice) : FIX_voice_array.push(0)
                            newdata_fix.sms != 0 ? FIX_sms_array.push(newdata_fix.sms/fix_amount.sms) : FIX_sms_array.push(0)
                            newdata_fix.mms != 0 ? FIX_mms_array.push(newdata_fix.mms/fix_amount.mms) : FIX_mms_array.push(0)
                            newdata_fix.internet != 0 ? FIX_internet_array.push(newdata_fix.internet/fix_amount.internet) : FIX_internet_array.push(0)
                            //reset value after quarter
                            newdata_fix.voice = 0
                            newdata_fix.sms = 0
                            newdata_fix.mms = 0
                            newdata_fix.internet = 0
                            month_number = 0
                            year_th.push(year_data)
                            fix_amount = {
                                voice: 0,
                                sms: 0,
                                mms: 0,
                                internet: 0
                            }
                        }
                        
                    
                }
                FIX_provider_voice[p] = FIX_voice_array
                FIX_provider_sms[p] = FIX_sms_array
                FIX_provider_mms[p] = FIX_mms_array
                FIX_provider_internet[p] = FIX_internet_array
                avg_in_voice[p].push(...FIX_voice_array)
                avg_in_sms[p].push(...FIX_sms_array)
                avg_in_mms[p].push(...FIX_mms_array)
                avg_in_internet[p].push(...FIX_internet_array)
            }
            let FIX_result_voices = FIX_provider_voice.filter(item => item != 0)
            let FIX_result_sms = FIX_provider_sms.filter(item => item != 0)
            let FIX_result_mms = FIX_provider_mms.filter(item => item != 0)
            let FIX_result_internet = FIX_provider_internet.filter(item => item != 0)
            let FIX_result_voice_new = FIX_provider_voice

    if(yearfrom >= 2013 && yearto < 2018){
        console.log('use fix daa')
        // let getprovider_group = groupBy(datafix, item => item.provider_name)
        //แยก ผบ
        if(forminfo.distinguish === 1){
            // console.log('FIX_provider_color',FIX_provider_color_chart)
            state.charts.unit.xAxis.categories = ["Voice (บาท/นาที)","SMS (บาท/ข้อความ)","MMS (บาท/ข้อความ)","Internet (บาท/MB)"]
            state.charts.voice.xAxis.categories = year_th
            state.charts.sms.xAxis.categories = year_th
            state.charts.mms.xAxis.categories = year_th
            state.charts.internet.xAxis.categories = year_th

            // console.log('provider_voice',provider_voice)
            console.log('FIX_result_voices',FIX_result_voices)
            // let result_v_q = 
            let result_in_unit = []
            state.dataTable = []
            let every_data = {
                voice: [],
                sms: [],
                mms: [],
                internet: []
            }
            let dataTabe_result = []
            for(let p = 0 ; p < FIX_result_voices.length ; p ++){
                let unit_data = []
                result_in_unit[p] = []
                state.serviceTable = []
                dataTabe_result[p] = []
                state.charts.voice.series.push({
                    name: provider_in_chart[p],
                    data: FIX_result_voices[p],
                    color: provider_color_chart[p]
                })
                state.charts.sms.series.push({
                    name: provider_in_chart[p],
                    data: FIX_result_sms[p],
                    color: provider_color_chart[p]
                })
                state.charts.mms.series.push({
                    name: provider_in_chart[p],
                    data: FIX_result_mms[p],
                    color: provider_color_chart[p]
                })
                state.charts.internet.series.push({
                    name: provider_in_chart[p],
                    data: FIX_result_internet[p],
                    color: provider_color_chart[p]
                })

                //get AVG
                let voice_in_unit = FIX_result_voices[p].reduce((acc, item) => acc+item)
                let sms_in_unit = FIX_result_sms[p].reduce((acc, item) => acc+item)
                let mms_in_unit = FIX_result_mms[p].reduce((acc, item) => acc+item)
                let internet_in_unit = FIX_result_internet[p].reduce((acc, item) => acc+item)
                FIX_result_voices[p] = FIX_result_voices[p].filter(item => item !== 0)
                FIX_result_sms[p] = FIX_result_sms[p].filter(item => item !== 0)
                FIX_result_mms[p] = FIX_result_mms[p].filter(item => item !== 0)
                FIX_result_internet[p] = FIX_result_internet[p].filter(item => item !== 0)
                console.log('FIX_result_voices[p] ',FIX_result_voices[p] )
                voice_in_unit /= FIX_result_voices[p].length
                sms_in_unit /= FIX_result_sms[p].length
                mms_in_unit /= FIX_result_mms[p].length
                internet_in_unit /= FIX_result_internet[p].length
                unit_data.push(parseFloat(voice_in_unit.toFixed(3)))
                unit_data.push(parseFloat(sms_in_unit.toFixed(3)))
                unit_data.push(parseFloat(mms_in_unit.toFixed(3)))
                unit_data.push(parseFloat(internet_in_unit.toFixed(3)))
                result_in_unit[p] = unit_data
                state.charts.unit.series.push({
                    name: provider_in_chart[p],
                    data: result_in_unit[p],
                    color: provider_color_chart[p]
                })

                
                //dataTable
                dataTabe_result[p].push(FIX_result_voices[p])
                dataTabe_result[p].push(FIX_result_sms[p])
                dataTabe_result[p].push(FIX_result_mms[p])
                dataTabe_result[p].push(FIX_result_internet[p])
                console.log('ds',dataTabe_result)
                let datarow = ["Voice (บาท/นาที)","SMS (บาท/ข้อความ)","MMS (บาท/ข้อความ)","Internet (บาท/MB)"]
                state.serviceTable = []
                for(let y=0;y<year_th.length;y++){
                    state.serviceTable.push(year_th[y])
                }
                for(let dt=0;dt<4;dt++){
                let res = {
                    data: [],
                    providers_name: [],
                    providers_color: []
                }
                    // res.providers_name = provider_in_chart[p]
                    res.providers_name = datarow[dt]
                    res.providers_color = provider_color_chart[p]
                    res.data = dataTabe_result[p][dt]
                    state.dataTable.push(res)
                }
                console.log(state.dataTable)

                //get all value to find max
                every_data.voice.push(...FIX_result_voices[p]) 
                every_data.sms.push(...FIX_result_sms[p]) 
                every_data.mms.push(...FIX_result_mms[p]) 
                every_data.internet.push(...FIX_result_internet[p]) 
                console.log('every_data',every_data)

                
            }
            
            maxvoice = every_data.voice.reduce((prev, cur) => (prev > cur) ? prev : cur,0)
            maxsms = every_data.sms.reduce((prev, cur) => (prev > cur) ? prev : cur,0)
            maxmms = every_data.mms.reduce((prev, cur) => (prev > cur) ? prev : cur,0)
            maxinternet = every_data.internet.reduce((prev, cur) => (prev > cur) ? prev : cur,0)

            // console.log('state.dataTable',state.dataTable)
            // console.log('state.serviceTable',state.serviceTable)
            
            //show avg
            if(forminfo.barAvg == '1'){
            //avg in year
            console.log('FIX_result_voice_new',FIX_result_voice_new)
            let FIX_avg_voice_year = FIX_result_voices.reduce((preindex, curindex) => curindex.map((val, i) => (((preindex[i] || 0) + val)/FIX_result_voices.length), []) )
            let FIX_avg_sms_year = FIX_result_sms.reduce((preindex, curindex) => curindex.map((val, i) => (((preindex[i] || 0) + val)/FIX_result_sms.length), []) )
            let FIX_avg_mms_year = FIX_result_mms.reduce((preindex, curindex) => curindex.map((val, i) => (((preindex[i] || 0) + val)/FIX_result_mms.length), []) )
            let FIX_avg_internet_year = FIX_result_internet.reduce((preindex, curindex) => curindex.map((val, i) => (((preindex[i] || 0) + val)/FIX_result_internet.length), []) )
                state.charts.voice.series.push({
                    name: 'Average',
                    data: FIX_avg_voice_year,
                    color: '#42f9ff'
                })
                state.charts.sms.series.push({
                    name: 'Average',
                    data: FIX_avg_sms_year,
                    color: '#42f9ff'
                })
                state.charts.mms.series.push({
                    name: 'Average',
                    data: FIX_avg_mms_year,
                    color: '#42f9ff'
                })
                state.charts.internet.series.push({
                    name: 'Average',
                    data: FIX_avg_internet_year,
                    color: '#42f9ff'
                })
            }

        }
        //ไม่แยก ผบ
        else if(forminfo.distinguish === 2){
            //filter item in array not 0
            for(let i=0;i<FIX_result_voices.length;i++){
                FIX_result_voices[i] = FIX_result_voices[i].filter(item => item !== 0)
                FIX_result_sms[i] = FIX_result_sms[i].filter(item => item !== 0)
                FIX_result_mms[i] = FIX_result_mms[i].filter(item => item !== 0)
                FIX_result_internet[i] = FIX_result_internet[i].filter(item => item !== 0)
            }
            console.log('FIX_result_voices',FIX_result_voices)

            let FIX_avg_voice_year = FIX_result_voices.reduce((preindex, curindex) => curindex.map((val, i) => (((preindex[i] || 0) + val)/FIX_result_voices.length), []) )
            let FIX_avg_sms_year = FIX_result_sms.reduce((preindex, curindex) => curindex.map((val, i) => (((preindex[i] || 0) + val)/FIX_result_sms.length), []) )
            let FIX_avg_mms_year = FIX_result_mms.reduce((preindex, curindex) => curindex.map((val, i) => (((preindex[i] || 0) + val)/FIX_result_mms.length), []) )
            let FIX_avg_internet_year = FIX_result_internet.reduce((preindex, curindex) => curindex.map((val, i) => (((preindex[i] || 0) + val)/FIX_result_internet.length), []) )
            console.log('FIX_avg_voice_year',FIX_avg_voice_year)

            state.charts.voice.xAxis.categories = year_th
            state.charts.sms.xAxis.categories = year_th
            state.charts.mms.xAxis.categories = year_th
            state.charts.internet.xAxis.categories = year_th
            state.charts.voice.series.push({
                name: 'Voice (บาท/นาที)',
                data: FIX_avg_voice_year,
                color: "#7bb5eb"
            })
            state.charts.sms.series.push({
                name:  'SMS (บาท/ข้อความ)',
                data: FIX_avg_sms_year,
                color: "#434348"
            })
            state.charts.mms.series.push({
                name: 'MMS (บาท/ข้อความ)',
                data: FIX_avg_mms_year,
                color: "#90ed7d"
            })
            state.charts.internet.series.push({
                name: 'Internet (บาท/MB)',
                data: FIX_avg_internet_year,
                color: "#f7a35c"
            })

            let all_avg_voice = FIX_avg_voice_year.reduce((prev,cur) => prev + cur ,0) / FIX_avg_voice_year.length
            let all_avg_sms = FIX_avg_sms_year.reduce((prev,cur) => prev + cur ,0) / FIX_avg_sms_year.length
            let all_avg_mms = FIX_avg_mms_year.reduce((prev,cur) => prev + cur ,0) / FIX_avg_mms_year.length
            let all_avg_internet = FIX_avg_internet_year.reduce((prev,cur) => prev + cur ,0) / FIX_avg_internet_year.length
            state.charts.unit.series = [
                {
                    name : "Voice (บาท/นาที)",
                    data : [all_avg_voice],
                },
                {
                    name : "SMS (บาท/ข้อความ)",
                    data : [all_avg_sms],
                },
                {
                    name : "MMS (บาท/ข้อความ)",
                    data : [all_avg_mms],
                },
                {
                    name : "Internet (บาท/MB)",
                    data : [all_avg_internet],
                },
            ]
            maxvoice = FIX_avg_voice_year.reduce((prev, cur) => (prev > cur) ? prev : cur,0)
            maxsms = FIX_avg_sms_year.reduce((prev, cur) => (prev > cur) ? prev : cur,0)
            maxmms = FIX_avg_mms_year.reduce((prev, cur) => (prev > cur) ? prev : cur,0)
            maxinternet = FIX_avg_internet_year.reduce((prev, cur) => (prev > cur) ? prev : cur,0)

            //dataTable
            let dataTabe_result = []
            dataTabe_result.push(FIX_avg_voice_year)
            dataTabe_result.push(FIX_avg_sms_year)
            dataTabe_result.push(FIX_avg_mms_year)
            dataTabe_result.push(FIX_avg_internet_year)
            // console.log('ds',dataTabe_result)
            let datarow = ["Voice (บาท/นาที)","SMS (บาท/ข้อความ)","MMS (บาท/ข้อความ)","Internet (บาท/MB)"]
            state.dataTable = []
            state.serviceTable = []
            for(let y=0;y<year_th.length;y++){
                state.serviceTable.push(year_th[y])
            }
            for(let dt=0;dt<4;dt++){
            let res = {
                data: [],
                providers_name: [],
                providers_color: []
            }
                res.providers_name = datarow[dt]
                res.data = dataTabe_result[dt]
                state.dataTable.push(res)
            }
        }
        
    } 
    else if( yearfrom >= 2013 && yearto >= 2018){
        let main = {
            // prop_sevice: 0.8,
            amount: 0,
            voice_m: 0,
            voice_s: 0,
            sms: 0,
            mms: 0,
            internet: 0,
        }
        let ontop = {
            // prop_sevice: 0.2,
            amount: 0,
            voice_m: 0,
            voice_s: 0,
            sms: 0,
            mms: 0,
            internet: 0,
        }
        let total = {
            amount: 0,
            voice_m: 0,
            voice_s: 0,
            sms: 0,
            mms: 0,
            internet: 0,
        }
        let data_in_unit = {
            amount: [],
            voice: [],
            sms: [],
            mms: [],
            internet: []
        }
        //use normaldata
        if(state.ontop_proportion == 0) state.main_proportion == 100
                    // console.log('state.main_proportion',state.main_proportion,state.ontop_proportion)
                    let data_in_pro = []
                    for(let p =0;p<provider_id_list.length;p++){
                        data_in_pro[p] = []
                        data_in_unit.amount[p] = []
                        data_in_unit.voice[p] = []
                        data_in_unit.sms[p] = []
                        data_in_unit.mms[p] = []
                        data_in_unit.internet[p] = []
                        let count_mount = 0
                        var year_TH = []
                        for(let date = obj.date.start;date < obj.date.end ; date = moment(date).add(1,'y')){
                            
                            let yearDate = moment(date).add(543,'y').format('YYYY')
                            // let monthDate = year_th[moment(date).format('M')-1]
                            let curyear = moment(date).format('YYYY')
                            year_TH.push(`ปี ${yearDate}`)
                            
                            let rowdatas = obj.qrydata.filter(item => item.monthly == curyear && provider_id_list[p].includes(item.provider_id))
                            for(let datagroup=0; datagroup<provider_id_list[p].length; datagroup++){
                                let rowdata = rowdatas.filter(item =>  item.provider_id == provider_id_list[p][datagroup])
                                console.log('curyear',curyear,'rowdata',rowdata)
                                for(let r=0;r<rowdata.length;r++){
                                    if(rowdata.length !== 0){
                                        // console.log('curyear',curyear,'row',rowdata[r])
                                        if(rowdata[r].promotion_type === 'main'){
                                            main.amount += rowdata[r].amount
                                            main.voice_m += rowdata[r].vpm_avg
                                            main.voice_s += rowdata[r].vps_avg
                                            main.sms += rowdata[r].sms_avg
                                            main.mms += rowdata[r].mms_avg
                                            main.internet += rowdata[r].internet_avg
                                        }else{
                                            ontop.amount += rowdata[r].amount
                                            ontop.voice_m += rowdata[r].vpm_avg
                                            ontop.voice_s += rowdata[r].vps_avg
                                            ontop.sms += rowdata[r].sms_avg
                                            ontop.mms += rowdata[r].mms_avg
                                            ontop.internet += rowdata[r].internet_avg
                                        }
                                    }
                                    
                                }
                                console.log('main.voice_m/main.amount',main.voice_m,main.amount,state.main_proportion/100)
                                    //สูตรอัตราค่าบริการเฉล่ียสาหรับบริการหนึ่งของผู้ ให้บริการ j
                                    total.voice_m = parseFloat((((main.voice_m/main.amount)*(state.main_proportion/100)) + ((ontop.voice_m/ontop.amount) *(state.ontop_proportion/100))).toFixed(3))
                                    total.sms = parseFloat((((main.sms/main.amount)*(state.main_proportion/100)) + ((ontop.sms/ontop.amount) *(state.ontop_proportion/100))).toFixed(3))
                                    total.mms = parseFloat((((main.mms/main.amount)*(state.main_proportion/100)) + ((ontop.mms/ontop.amount) *(state.ontop_proportion/100))).toFixed(3))
                                    total.internet = parseFloat((((main.internet/main.amount)*(state.main_proportion/100)) + ((ontop.internet/ontop.amount) *(state.ontop_proportion/100))).toFixed(3))
                                    total.amount = main.amount + ontop.amount
                                    if(total.amount !== 0){
                                        data_in_unit.amount[p].push(total.amount)
                                        data_in_unit.voice[p].push(total.voice_m)
                                        data_in_unit.sms[p].push(total.sms)
                                        data_in_unit.mms[p].push(total.mms)
                                        data_in_unit.internet[p].push(total.internet)
                                        data_in_pro[p].push({
                                            avg_voice: total.voice_m,
                                            avg_sms: total.sms,
                                            avg_mms: total.mms,
                                            avg_internet: total.internet
                                        })
                                    }
                                console.log('m + ontop.amount',main.amount,ontop.amount,main.voice_s)
                                total = {
                                    amount: 0,
                                    voice_m: 0,
                                    voice_s: 0,
                                    sms: 0,
                                    mms: 0,
                                    internet: 0,
                                }
                                main = {
                                    amount: 0,
                                    voice_m: 0,
                                    voice_s: 0,
                                    sms: 0,
                                    mms: 0,
                                    internet: 0,
                                }
                                ontop = {
                                    amount: 0,
                                    voice_m: 0,
                                    voice_s: 0,
                                    sms: 0,
                                    mms: 0,
                                    internet: 0,
                                }
                                
                            }
                        // console.log('---end provider_id_list--',provider_id_list[p])
                        count_mount += 1
                        console.log('----end year----',curyear)

                        }
                    }
                    console.log('data_in_unit',data_in_unit)
                    
                    //amount data main + ontop of providers in same month 
                    let data_amount_in_month = data_in_unit.amount.reduce((preindex, curindex) => curindex.map((val, i) => (((preindex[i] || 0) + val)), []) )
                    console.log('data_amount_in_month',data_amount_in_month)

                    //เก็บค่าของแต่ละผู้ให้บริการในอารเรย์โดยเรียงลำดับตาม ผบ
                    // let avg_in_voice = []
                    // let avg_in_sms = []
                    // let avg_in_mms = []
                    // let avg_in_internet = []
                    let avg_voice = []
                    let avg_sms = []
                    let avg_mms = []
                    let avg_internet = []
                    let result_in_unit = []
                    let every_data = {
                        voice: [],
                        sms: [],
                        mms: [],
                        internet: []
                    }
                    state.dataTable = []
                    let dataTabe_result = []
                        for(let p =0;p<provider_id_list.length;p++){
                            // console.log('this loop')
                            // avg_in_voice[p] = []
                            // avg_in_sms[p] = []
                            // avg_in_mms[p] = []
                            // avg_in_internet[p] = []
                            result_in_unit[p] = []
                            dataTabe_result[p] = []
                            let sum_voice = 0
                            let sum_sms = 0
                            let sum_mms = 0
                            let sum_internet = 0
                            let sum_amount = 0
                            let data_result = {
                                voice: 0,
                                sms: 0,
                                mms: 0,
                                internet: 0
                            }
                            let count_month = 0
                            for(let date = obj.date.start;date < obj.date.end ; date = moment(date).add(1,'y')){
                                let curyear = moment(date).format('YYYY')
                                        if(forminfo.weighting == 1){
                                            //ถ่วงนน
                                            console.log('data_in_unit.voice[p][count_month] * data_in_unit.amount[p][count_month]',p,count_month,'--',data_in_unit.voice[p][count_month],data_in_unit.amount[p][count_month])
                                            sum_voice = data_in_unit.voice[p][count_month] * data_in_unit.amount[p][count_month]
                                            sum_sms = data_in_unit.sms[p][count_month] * data_in_unit.amount[p][count_month]
                                            sum_mms = data_in_unit.mms[p][count_month] * data_in_unit.amount[p][count_month]
                                            sum_internet = data_in_unit.internet[p][count_month] * data_in_unit.amount[p][count_month]
                                            sum_amount = data_amount_in_month[count_month]

                                        }else{
                                            //ไม่ถ่วง
                                            sum_voice = data_in_unit.voice[p][count_month]
                                            sum_sms = data_in_unit.sms[p][count_month]
                                            sum_mms = data_in_unit.mms[p][count_month]
                                            sum_internet = data_in_unit.internet[p][count_month]
                                        }
                                if(forminfo.weighting == 1){
                                    // console.log('ถ่วงง',sum_voice)
                                    console.log('sum_voice/sum_amount',sum_voice,'/',sum_amount)
                                    data_result.voice = sum_voice/sum_amount
                                    data_result.sms = sum_sms/sum_amount
                                    data_result.mms = sum_mms/sum_amount
                                    data_result.internet = sum_internet/sum_amount
                                }else{
                                    //ไม่ถ่วง
                                    // console.log('ไม่ถ่วงง',sum_voice)
                                    console.log('sum_voice/data_in_unit.amount.length',sum_voice,data_in_unit.amount.length)
                                    data_result.voice = sum_voice/data_in_unit.amount.length
                                    data_result.sms = sum_sms/data_in_unit.amount.length
                                    data_result.mms= sum_mms/data_in_unit.amount.length
                                    data_result.internet = sum_internet/data_in_unit.amount.length
                                }
                                // console.log('data_result.voice',data_result.voice,'=',sum_voice,sum_amount)
                                console.log('---end year ',curyear,'p',provider_in_chart[p])
                                console.log('avg -> data_result.voice',data_result.voice)
                                isNaN(data_result.voice) ? avg_in_voice[p].push(0) : avg_in_voice[p].push(data_result.voice)
                                isNaN(data_result.sms) ? avg_in_sms[p].push(0) : avg_in_sms[p].push(data_result.sms)
                                isNaN(data_result.mms) ? avg_in_mms[p].push(0) : avg_in_mms[p].push(data_result.mms)
                                isNaN(data_result.internet) ? avg_in_internet[p].push(0) : avg_in_internet[p].push(data_result.internet)

                                sum_voice = 0
                                sum_sms = 0
                                sum_mms = 0
                                sum_internet = 0
                                // sum_amount = 0
                                data_result = {
                                    voice: 0,
                                    sms: 0,
                                    mms: 0,
                                    internet: 0
                                }
                                count_month += 1
                                state.serviceTable = []
                            }

                            console.log('avg_in_voice',avg_in_voice)
                            //กรองข้อมูลที่ไม่ใช่ 0 จะเป็นโชว์แค่เดือนที่มีข้อมูล
                            avg_in_voice[p] = avg_in_voice[p].filter(item => item !== 0)
                            avg_in_sms[p] = avg_in_sms[p].filter(item => item !== 0)
                            avg_in_mms[p] = avg_in_mms[p].filter(item => item !== 0)
                            avg_in_internet[p] = avg_in_internet[p].filter(item => item !== 0)
                            // array of average each provider
                            avg_voice.push(avg_in_voice[p].reduce((prev, cur) => prev + cur ,0) / avg_in_voice[p].length)
                            avg_sms.push(avg_in_sms[p].reduce((prev, cur) => prev + cur ,0) / avg_in_sms[p].length)
                            avg_mms.push(avg_in_mms[p].reduce((prev, cur) => prev + cur ,0) / avg_in_mms[p].length)
                            avg_internet.push(avg_in_internet[p].reduce((prev, cur) => prev + cur ,0) / avg_in_internet[p].length)
                            console.log('avg_voice',avg_voice)

                            //get all value to find max
                            every_data.voice.push(...avg_in_voice[p]) 
                            every_data.sms.push(...avg_in_sms[p]) 
                            every_data.mms.push(...avg_in_mms[p]) 
                            every_data.internet.push(...avg_in_internet[p]) 

                            //array order by voice,sms,mms,int of month 
                            
                            // this array value is every month of v,s,m,i 
                            // result_in_unit[p].push(avg_in_voice[p])
                            // result_in_unit[p].push(avg_in_sms[p])
                            // result_in_unit[p].push(avg_in_mms[p])
                            // result_in_unit[p].push(avg_in_internet[p])

                            //ข้อมูลเฉลี่ยทั้งปี แต่ละผู้ให้บริการ เรียงตามลำดับ
                            result_in_unit[p].push(avg_voice[p])
                            result_in_unit[p].push(avg_sms[p])
                            result_in_unit[p].push(avg_mms[p])
                            result_in_unit[p].push(avg_internet[p])

                            
                            // console.log('avg_in_voice',avg_in_voice)
                            if(forminfo.distinguish === 1){
                                
                                //chart
                                state.charts.voice.series.push({
                                    name: provider_in_chart[p],
                                    data: avg_in_voice[p],
                                    color: provider_color_chart[p]
                                })
                                state.charts.sms.series.push({
                                    name: provider_in_chart[p],
                                    data: avg_in_sms[p],
                                    color: provider_color_chart[p]
                                })
                                state.charts.mms.series.push({
                                    name: provider_in_chart[p],
                                    data: avg_in_mms[p],
                                    color: provider_color_chart[p]
                                })
                                state.charts.internet.series.push({
                                    name: provider_in_chart[p],
                                    data: avg_in_internet[p],
                                    color: provider_color_chart[p]
                                })
                                state.charts.unit.series.push({
                                    name : provider_in_chart[p],
                                    data : result_in_unit[p],
                                    color: provider_color_chart[p]
                                })
                                state.charts.unit.xAxis.categories = ["Voice (บาท/นาที)","SMS (บาท/ข้อความ)","MMS (บาท/ข้อความ)","Internet (บาท/MB)"]
                            
                                if(forminfo.forecast){
                                    console.log('forecast')
                                    avg_in_voice[p].push(avg_voice[p])
                                    avg_in_sms[p].push(avg_sms[p])
                                    avg_in_mms[p].push(avg_mms[p])
                                    avg_in_internet[p].push(avg_internet[p])
                                }

                                console.log('result_in_unit',result_in_unit)
                                
                                //dataTable
                                dataTabe_result[p].push(avg_in_voice[p])
                                dataTabe_result[p].push(avg_in_sms[p])
                                dataTabe_result[p].push(avg_in_mms[p])
                                dataTabe_result[p].push(avg_in_internet[p])
                                console.log('ds',dataTabe_result)
                                let datarow = ["Voice (บาท/นาที)","SMS (บาท/ข้อความ)","MMS (บาท/ข้อความ)","Internet (บาท/MB)"]
                                state.serviceTable = []
                                for(let y=0;y<year_TH.length;y++){
                                    state.serviceTable.push(year_TH[y])
                                }
                                for(let dt=0;dt<4;dt++){
                                let res = {
                                    data: [],
                                    providers_name: [],
                                    providers_color: []
                                }
                                    // res.providers_name = provider_in_chart[p]
                                    res.providers_name = datarow[dt]
                                    res.providers_color = provider_color_chart[p]
                                    res.data = dataTabe_result[p][dt]
                                    state.dataTable.push(res)
                                }
                                console.log(state.dataTable)

                                //max value of array
                                maxvoice = every_data.voice.reduce((prev, cur) => (prev > cur) ? prev : cur,0)
                                maxsms = every_data.sms.reduce((prev, cur) => (prev > cur) ? prev : cur,0)
                                maxmms = every_data.mms.reduce((prev, cur) => (prev > cur) ? prev : cur,0)
                                maxinternet = every_data.internet.reduce((prev, cur) => (prev > cur) ? prev : cur,0)
                            }

                        }
                        // console.log('avg_in_voice',avg_in_voice)
                        // console.log('avg_in_sms',avg_in_sms)

                        //avg of each provider in same month to one array
                        let avg_voice_months = avg_in_voice.reduce((preindex, curindex) => curindex.map((val, i) => (((preindex[i] || 0) + val)/avg_in_voice.length), []) )
                        let avg_sms_months = avg_in_sms.reduce((preindex, curindex) => curindex.map((val, i) => (((preindex[i] || 0) + val)/avg_in_sms.length), []) )
                        let avg_mms_months = avg_in_mms.reduce((preindex, curindex) => curindex.map((val, i) => (((preindex[i] || 0) + val)/avg_in_mms.length), []) )
                        let avg_internet_months = avg_in_internet.reduce((preindex, curindex) => curindex.map((val, i) => (((preindex[i] || 0) + val)/avg_in_internet.length), []) )
                        console.log('avg_voice_months',avg_voice_months)
                        //ไม่จำแนกผู้ให้บริการ ค่าเฉลี่ยของผบในแต่ละเดือน
                        if(forminfo.distinguish === 2){
                            
                            //chart
                            state.charts.voice.series.push({
                                name: "Voice (บาท/นาที)",
                                data: avg_voice_months,
                                color: ''
                            })
                            state.charts.sms.series.push({
                                name: "SMS (บาท/ข้อความ)",
                                data: avg_sms_months,
                                color: ''
                            })
                            state.charts.mms.series.push({
                                name: "MMS (บาท/ข้อความ)",
                                data: avg_mms_months,
                                color: ''
                            })
                            state.charts.internet.series.push({
                                name: "Internet (บาท/MB)",
                                data: avg_internet_months,
                                color: ''
                            })

                            //all data every month in arr to one avg show in unit chart
                            var all_avg_voice = avg_voice.reduce((prev,cur) => prev + cur ,0) / avg_voice.length
                            var all_avg_sms = avg_sms.reduce((prev,cur) => prev + cur ,0) / avg_sms.length
                            var all_avg_mms = avg_mms.reduce((prev,cur) => prev + cur ,0) / avg_mms.length
                            var all_avg_internet = avg_internet.reduce((prev,cur) => prev + cur ,0) / avg_internet.length
                            state.charts.unit.series = [
                                {
                                    name : "Voice (บาท/นาที)",
                                    data : [all_avg_voice],
                                },
                                {
                                    name : "SMS (บาท/ข้อความ)",
                                    data : [all_avg_sms],
                                },
                                {
                                    name : "MMS (บาท/ข้อความ)",
                                    data : [all_avg_mms],
                                },
                                {
                                    name : "Internet (บาท/MB)",
                                    data : [all_avg_internet],
                                },
                            ]

                            //dataTable
                            let dataTabe_result = []
                            dataTabe_result.push(avg_voice_months)
                            dataTabe_result.push(avg_sms_months)
                            dataTabe_result.push(avg_mms_months)
                            dataTabe_result.push(avg_internet_months)
                            // console.log('ds',dataTabe_result)
                            let datarow = ["Voice (บาท/นาที)","SMS (บาท/ข้อความ)","MMS (บาท/ข้อความ)","Internet (บาท/MB)"]
                            state.dataTable = []
                            state.serviceTable = []
                            for(let m=0;m<year_TH.length;m++){
                                state.serviceTable.push(year_TH[m])
                            }
                            for(let dt=0;dt<4;dt++){
                            let res = {
                                data: [],
                                providers_name: [],
                                providers_color: []
                            }
                                res.providers_name = datarow[dt]
                                res.data = dataTabe_result[dt]
                                state.dataTable.push(res)
                            }

                                //max value of array
                                maxvoice = avg_voice_months.reduce((prev, cur) => (prev > cur) ? prev : cur,0)
                                maxsms = avg_sms_months.reduce((prev, cur) => (prev > cur) ? prev : cur,0)
                                maxmms = avg_mms_months.reduce((prev, cur) => (prev > cur) ? prev : cur,0)
                                maxinternet = avg_internet_months.reduce((prev, cur) => (prev > cur) ? prev : cur,0)
                        }
                    
                    if(forminfo.forecast){
                        console.log('forecast')
                        if(forminfo.distinguish === 2){
                            avg_voice_months.push(all_avg_voice)
                            avg_sms_months.push(all_avg_sms)
                            avg_mms_months.push(all_avg_mms)
                            avg_internet_months.push(all_avg_internet)
                        }
                        year_TH.push('Forecast')
                    }
                    // state.charts.unit.xAxis.categories = ""
                    let ALL_YEAR = year_th.concat(year_TH)
                    let FILTER_ALL_YEAR = [ ...new Set(ALL_YEAR) ];
                    state.charts.voice.xAxis.categories = FILTER_ALL_YEAR
                    state.charts.sms.xAxis.categories = FILTER_ALL_YEAR
                    state.charts.mms.xAxis.categories = FILTER_ALL_YEAR
                    state.charts.internet.xAxis.categories = FILTER_ALL_YEAR
                    
                    if(forminfo.barAvg == '1'){
                        state.charts.voice.series.push({
                            name: 'Average',
                            data: avg_voice_months,
                            color: '#42f9ff'
                        })
                        state.charts.sms.series.push({
                            name: 'Average',
                            data: avg_sms_months,
                            color: '#42f9ff'
                        })
                        state.charts.mms.series.push({
                            name: 'Average',
                            data: avg_mms_months,
                            color: '#42f9ff'
                        })
                        state.charts.internet.series.push({
                            name: 'Average',
                            data: avg_internet_months,
                            color: '#42f9ff'
                        })
                    }
                // }
    }
    //แสดงเพดานกำกับ
    if(forminfo.graphLine == true){
        let graphLine = obj.serviceRate
        let year = moment(forminfo.type_data.month).format('YYYY')
        let start = moment('01-01-'+ year, 'DD-MM-YYYY')
        let end = moment(start).add(1,'Y')
            end = moment(end).subtract(1,'d')
        let voice_service_rate = 0
        let sms_service_rate = 0
        let mms_service_rate = 0
        let internet_service_rate = 0
        let service_name = ""
        for(let i = 0 ; i < graphLine.length ; i++){
            if((moment(graphLine[i].end_date).format('DD-MM-YYYY') >= moment(end).format('DD-MM-YYYY')) && (moment(graphLine[i].start_date).format('DD-MM-YYYY') <= moment(start).format('DD-MM-YYYY'))){
                voice_service_rate = graphLine[i].voice_service_rate
                sms_service_rate  = graphLine[i].sms_service_rate
                mms_service_rate  = graphLine[i].mms_service_rate
                internet_service_rate  = graphLine[i].internet_service_rate
                service_name = graphLine[i].service_name
            }
        }
        console.log('max',maxvoice,'voice_service_rate',voice_service_rate)
        state.charts.voice.yAxis = [{
            min: 0,
            title: {
                text: 'อัตราค่าบริการเฉลี่ย'
            },
            plotLines: [{
                value: voice_service_rate,
                color: 'red',
                dashStyle: 'line',
                width: 2,
                label: {
                    text: `${service_name} ${voice_service_rate}`
                }
            },{
                value: maxvoice,
                color: 'red',
                dashStyle: 'shortdash',
                width: 2,
                label: {
                    text: ``
                }
            }]
        }]
        state.charts.sms.yAxis = [{
            min: 0,
            title: {
                text: 'อัตราค่าบริการเฉลี่ย'
            },
            plotLines: [{
                value: sms_service_rate,
                color: 'red',
                dashStyle: 'line',
                width: 2,
                label: {
                    text: `${service_name} ${sms_service_rate}`
                }
            },{
                value: maxsms,
                color: 'red',
                dashStyle: 'shortdash',
                width: 2,
                label: {
                    text: ``
                }
            }]
        }]
        state.charts.mms.yAxis =[{
            min: 0,
            title: {
                text: 'อัตราค่าบริการเฉลี่ย'
            },
            plotLines: [{
                value: mms_service_rate,
                color: 'red',
                dashStyle: 'line',
                width: 2,
                label: {
                    text: `${service_name} ${mms_service_rate}`
                }
            },{
                value: maxmms,
                color: 'red',
                dashStyle: 'shortdash',
                width: 2,
                label: {
                    text: ``
                }
            }]
            
        }]
        state.charts.internet.yAxis =[{
            min: 0,
            title: {
                text: 'อัตราค่าบริการเฉลี่ย'
            },
            plotLines: [{
                value: internet_service_rate,
                color: 'red',
                dashStyle: 'line',
                width: 2,
                label: {
                    text: `${service_name} ${internet_service_rate}`
                }
            },{
                value: maxinternet,
                color: 'red',
                dashStyle: 'shortdash',
                width: 2,
                label: {
                    text: ``
                }
            }]
        }]
    }else {
        state.charts.voice.yAxis = [{
            min: 0,
            title: {
                text: 'อัตราค่าบริการเฉลี่ย'
            },
            plotLines: []
        }]
        state.charts.sms.yAxis = [{
            min: 0,
            title: {
                text: 'อัตราค่าบริการเฉลี่ย'
            },
            plotLines: []
        }]
        state.charts.mms.yAxis = [{
            min: 0,
            title: {
                text: 'อัตราค่าบริการเฉลี่ย'
            },
            plotLines: []
        }]
        state.charts.internet.yAxis = [{
            min: 0,
            title: {
                text: 'อัตราค่าบริการเฉลี่ย'
            },
            plotLines: []
        }]
    }
  },
  QUARTER(state,obj){
    let year = moment(obj.date.start).format('YYYY')
    let yearTH = moment(obj.date.start).add(543,"Y").format('YYYY')
    let quarter = (moment(obj.date.start).format('MM')-1)/3+1

    let graphLine_text = obj.forminfo.graphLine ? " และเปรียบเทียบกับอัตราอ้างอิงบนคลื่นความถี่ 2.1 GHz" : ""
    let distinguish_text = obj.forminfo.distinguish == 1 ? "จำแนกตาม" : "ของ"
    state.charts.unit.title.text = "ภาพรวมอัตราค่าบริการเฉลี่ยของบริการ ประเภทเสียง บริการ SMS/MMS และ บริการ Internet ของผู้ให้บริการ โทรศัพท์เคลื่อนที่ ณ ไตรมาสที่ "+quarter+" ปี พ.ศ. "+yearTH
    state.charts.voice.title.text = "อัตราค่าบริการเฉลี่ยของบริการประเภทเสียง "+distinguish_text+"ผู้ให้บริการโทรศัพท์เคลื่อนที่ ณ ไตรมาสที่ "+quarter+" ปี พ.ศ. "+yearTH+graphLine_text
    state.charts.sms.title.text = "อัตราค่าบริการเฉลี่ยของบริการ SMS "+distinguish_text+"ผู้ให้บริการโทรศัพท์เคลื่อนที่ ณ ไตรมาสที่ "+quarter+" ปี พ.ศ. "+yearTH+graphLine_text
    state.charts.mms.title.text = "อัตราค่าบริการเฉลี่ยของบริการ MMS "+distinguish_text+"ผู้ให้บริการโทรศัพท์เคลื่อนที่ ณ ไตรมาสที่ "+quarter+" ปี พ.ศ. "+yearTH+graphLine_text
    state.charts.internet.title.text = "อัตราค่าบริการเฉลี่ยของบริการ Internet "+distinguish_text+"ผู้ให้บริการโทรศัพท์เคลื่อนที่ ณ ไตรมาสที่ "+quarter+" ปี พ.ศ. "+yearTH+graphLine_text

    state.charts.unit.series = []
    state.charts.voice.series = []
    state.charts.sms.series = []
    state.charts.mms.series = []
    state.charts.internet.series = []

    state.charts.unit.xAxis.categories = [""]
    state.charts.voice.xAxis.categories = [""]
    state.charts.sms.xAxis.categories = [""]
    state.charts.mms.xAxis.categories = [""]
    state.charts.internet.xAxis.categories = [""]

    let forminfo = obj.forminfo
    // let item_list = ''
    let p_list = []
    let provider_id_list = []
    let provider_in_chart = []
    let provider_color_chart = []
    let provider_list = obj.forminfo.list
    for(let p = 0 ; p < provider_list.length ; p ++){
        let provider_name = obj.forminfo.compare_type == 'group' ? provider_list[p].group_name_th : provider_list[p].brand_name
        let provider_color = obj.forminfo.compare_type == 'group' ? provider_list[p].group_color_code : provider_list[p].provider_color
        let provider_id = obj.forminfo.compare_type == 'group' ? JSON.parse(provider_list[p].group_company_list) : [provider_list[p].id]
        provider_id_list.push(provider_id)
        // provider_name_list.push(provider_name)
        // provider_color_list.push(provider_color)

        // item_list += `${item_group},`
        p_list.push(...provider_id)
        provider_in_chart.push(provider_name)
        provider_color_chart.push(provider_color)
    }
    // console.log('p_list',p_list)
    // console.log('provider_in_chart',provider_in_chart)
    // console.log('provider_color_chart',provider_color_chart)
    let maxvoice = 0
    let maxsms = 0
    let maxmms = 0
    let maxinternet = 0
    if(year >= 2013 && year <= 2017){
        let datafix = obj.fixdata
        let newdata_fix = {
            voice_m: 0,
            voice: 0,
            sms: 0,
            mms: 0,
            internet: 0,
            freq: [],
            name: ''
        }
        
        let provider_voice = []
        let provider_sms = []
        let provider_mms = []
        let provider_internet = []
        let every_data = {
            voice: [],
            sms: [],
            mms: [],
            internet: []
        }
        for(let p = 0 ; p < p_list.length ; p ++){
            let voice_array = []
            let sms_array = []
            let mms_array = []
            let internet_array = []
            provider_voice[p] = []
            provider_sms[p] = []
            provider_mms[p] = []
            provider_internet[p] = []
            let fix_amount = {
                voice: 0,
                sms: 0,
                mms: 0,
                internet: 0
            }
            for(let date = obj.date.start;date < obj.date.end ; date = moment(date).add(1,'M')){
                let curmonth = moment(date).format('M-YYYY')
                newdata_fix.voice = 0
                newdata_fix.sms = 0
                newdata_fix.mms = 0
                newdata_fix.internet = 0

                let fixa = datafix.filter(item => item.monthly == curmonth && item.provider_id == p_list[p])
                // console.log('fixa',fixa)
                if(fixa.length != 0){
                    for(let n=0;n<fixa.length;n++){
                        if(fixa[n].service_type == 'Voice'){
                            newdata_fix.voice += fixa[n].price_avg
                            fix_amount.voice += 1
                        }else if(fixa[n].service_type == 'SMS'){
                            newdata_fix.sms += fixa[n].price_avg
                            fix_amount.sms += 1
                        }else if(fixa[n].service_type == 'MMS'){
                            newdata_fix.mms += fixa[n].price_avg
                            fix_amount.mms += 1
                        }else if(fixa[n].service_type == 'Internet'){
                            newdata_fix.internet += fixa[n].price_avg
                            fix_amount.internet += 1
                        }
                    }

                    voice_array.push(newdata_fix.voice/fix_amount.voice)
                    sms_array.push(newdata_fix.sms/fix_amount.sms)
                    mms_array.push(newdata_fix.mms/fix_amount.mms)
                    internet_array.push(newdata_fix.internet/fix_amount.internet)

                    fix_amount = {
                        voice: 0,
                        sms: 0,
                        mms: 0,
                        internet: 0
                    }
                }
            }
            provider_voice[p] = voice_array
            provider_sms[p] = sms_array
            provider_mms[p] = mms_array
            provider_internet[p] = internet_array
            every_data.voice.push(...provider_voice[p]) 
            every_data.sms.push(...provider_sms[p]) 
            every_data.mms.push(...provider_mms[p]) 
            every_data.internet.push(...provider_internet[p]) 
        }
        // console.log('provider_color',provider_color_chart)
        state.charts.unit.xAxis.categories = ["Voice (บาท/นาที)","SMS (บาท/ข้อความ)","MMS (บาท/ข้อความ)","Internet (บาท/MB)"]
        state.charts.voice.xAxis.categories = month_th
        state.charts.sms.xAxis.categories = month_th
        state.charts.mms.xAxis.categories = month_th
        state.charts.internet.xAxis.categories = month_th
        let result_voices = provider_voice.filter(item => item != 0)
        let result_sms = provider_sms.filter(item => item != 0)
        let result_mms = provider_mms.filter(item => item != 0)
        let result_internet = provider_internet.filter(item => item != 0)

        console.log('provider_voice',provider_voice)
        console.log('result_voices',result_voices)
        if(forminfo.distinguish === 1){

                let result_in_unit = []
                state.dataTable = []
                for(let p = 0 ; p < result_voices.length ; p ++){
                    let unit_data = []
                    result_in_unit[p] = []
                    state.serviceTable = []
                    let obj = {}
                    state.charts.voice.series.push({
                        name: provider_in_chart[p],
                        data: result_voices[p],
                        color: provider_color_chart[p]
                    })
                    state.charts.sms.series.push({
                        name: provider_in_chart[p],
                        data: result_sms[p],
                        color: provider_color_chart[p]
                    })
                    state.charts.mms.series.push({
                        name: provider_in_chart[p],
                        data: result_mms[p],
                        color: provider_color_chart[p]
                    })
                    state.charts.internet.series.push({
                        name: provider_in_chart[p],
                        data: result_internet[p],
                        color: provider_color_chart[p]
                    })

                    //get AVG
                    let voice_in_unit = result_voices[p].reduce((acc, item) => acc+item)
                    let sms_in_unit = result_sms[p].reduce((acc, item) => acc+item)
                    let mms_in_unit = result_mms[p].reduce((acc, item) => acc+item)
                    let internet_in_unit = result_internet[p].reduce((acc, item) => acc+item)
                    voice_in_unit /= result_voices[p].length
                    sms_in_unit /= result_sms[p].length
                    mms_in_unit /= result_mms[p].length
                    internet_in_unit /= result_internet[p].length
                    unit_data.push(parseFloat(voice_in_unit.toFixed(2)))
                    unit_data.push(parseFloat(sms_in_unit.toFixed(2)))
                    unit_data.push(parseFloat(mms_in_unit.toFixed(2)))
                    unit_data.push(parseFloat(internet_in_unit.toFixed(2)))
                    result_in_unit[p] = unit_data
                    state.charts.unit.series.push({
                        name: provider_in_chart[p],
                        data: result_in_unit[p],
                        color: provider_color_chart[p]
                    })

                    //get dataTable 
                    if(voice_in_unit) state.serviceTable.push("Voice (บาท/นาที)")
                    if(sms_in_unit) state.serviceTable.push("SMS (บาท/ข้อความ)")
                    if(mms_in_unit) state.serviceTable.push("MMS (บาท/ข้อความ)")
                    if(internet_in_unit) state.serviceTable.push("Internet (บาท/MB)")
                    obj["data"] = result_in_unit[p]
                    obj["providers_name"] = provider_in_chart[p]
                    obj["providers_color"] = provider_color_chart[p]
                    state.dataTable.push(obj)
                }
                
                maxvoice = every_data.voice.reduce((prev, cur) => (prev > cur) ? prev : cur)
                maxsms = every_data.sms.reduce((prev, cur) => (prev > cur) ? prev : cur)
                maxmms = every_data.mms.reduce((prev, cur) => (prev > cur) ? prev : cur)
                maxinternet = every_data.internet.reduce((prev, cur) => (prev > cur) ? prev : cur)
                console.log('every_data.voice',every_data.voice)
                // console.log('state.serviceTable',state.serviceTable)
                
                //show avg
                if(forminfo.barAvg == '1'){
                    let result_voice_avg = result_voices.reduce((prev, cur) => cur.map((val, i) => (prev[i] || 0) + val/result_voices.length), []);
                    let result_sms_avg = result_sms.reduce((prev, cur) => cur.map((val, i) => (prev[i] || 0) + val/result_sms.length), []);
                    let result_mms_avg = result_mms.reduce((prev, cur) => cur.map((val, i) => (prev[i] || 0) + val/result_mms.length), []);
                    let result_internet_avg = result_internet.reduce((prev, cur) => cur.map((val, i) => (prev[i] || 0) + val/result_internet.length), []);
                    state.charts.voice.series.push({
                        name: 'Average',
                        data: result_voice_avg,
                        color: '#42f9ff'
                    })
                    state.charts.sms.series.push({
                        name: 'Average',
                        data: result_sms_avg,
                        color: '#42f9ff'
                    })
                    state.charts.mms.series.push({
                        name: 'Average',
                        data: result_mms_avg,
                        color: '#42f9ff'
                    })
                    state.charts.internet.series.push({
                        name: 'Average',
                        data: result_internet_avg,
                        color: '#42f9ff'
                    })
                }

        }
        //ไม่แยก ผบ
        else{
            //filter item in array not 0
            for(let i=0;i<result_voices.length;i++){
                result_voices[i] = result_voices[i].filter(item => item !== 0)
                result_sms[i] = result_sms[i].filter(item => item !== 0)
                result_mms[i] = result_mms[i].filter(item => item !== 0)
                result_internet[i] = result_internet[i].filter(item => item !== 0)
            }
            console.log('result_voices',result_voices)

            let avg_voice_quarter = result_voices.reduce((preindex, curindex) => curindex.map((val, i) => (((preindex[i] || 0) + val)/result_voices.length), []) )
            let avg_sms_quarter = result_sms.reduce((preindex, curindex) => curindex.map((val, i) => (((preindex[i] || 0) + val)/result_sms.length), []) )
            let avg_mms_quarter = result_mms.reduce((preindex, curindex) => curindex.map((val, i) => (((preindex[i] || 0) + val)/result_mms.length), []) )
            let avg_internet_quarter = result_internet.reduce((preindex, curindex) => curindex.map((val, i) => (((preindex[i] || 0) + val)/result_internet.length), []) )
            console.log('avg_voice_quarter',avg_voice_quarter)
            state.charts.voice.series.push({
                name: 'Voice (บาท/นาที)',
                data: avg_voice_quarter,
                color: "#7bb5eb"
            })
            state.charts.sms.series.push({
                name:  'SMS (บาท/ข้อความ)',
                data: avg_sms_quarter,
                color: "#434348"
            })
            state.charts.mms.series.push({
                name: 'MMS (บาท/ข้อความ)',
                data: avg_mms_quarter,
                color: "#90ed7d"
            })
            state.charts.internet.series.push({
                name: 'Internet (บาท/MB)',
                data: avg_internet_quarter,
                color: "#f7a35c"
            })

            let all_voice = parseFloat((avg_voice_quarter.reduce((prev,cur) => prev+cur,0) / avg_voice_quarter.length).toFixed(2))
            let all_sms = parseFloat((avg_sms_quarter.reduce((prev,cur) => prev+cur,0) / avg_sms_quarter.length).toFixed(2))
            let all_mms = parseFloat((avg_mms_quarter.reduce((prev,cur) => prev+cur,0) / avg_mms_quarter.length).toFixed(2))
            let all_internet = parseFloat((avg_internet_quarter.reduce((prev,cur) => prev+cur,0) / avg_internet_quarter.length).toFixed(2))
            state.charts.unit.series = [
                {
                    name : 'Voice (บาท/นาที)',
                    data : [all_voice],
                    color: "#7bb5eb"
                },
                {
                    name : 'SMS (บาท/ข้อความ)',
                    data : [all_sms],
                    color: "#434348"
                },
                {
                    name : 'MMS (บาท/ข้อความ)',
                    data : [all_mms],
                    color: "#90ed7d"
                },
                {
                    name : 'Internet (บาท/MB)',
                    data : [all_internet],
                    color: "#f7a35c"
                },
            ]

            //dataTable
            state.dataTable = []
            state.serviceTable= ["Voice (บาท/นาที)","SMS (บาท/ข้อความ)","MMS (บาท/ข้อความ)","Internet (บาท/MB)"]
            let res = {}
                res["data"] = [all_voice,all_sms,all_mms,all_internet]
                res["providers_name"] = `ผู้ให้บริการทั้งหมด ปี ${parseInt(year)+543}`
                res["providers_color"] = ''
            state.dataTable.push(res)

            //max value of array
            maxvoice = avg_voice_quarter.reduce((prev, cur) => (prev > cur) ? prev : cur,0)
            maxsms = avg_sms_quarter.reduce((prev, cur) => (prev > cur) ? prev : cur,0)
            maxmms = avg_mms_quarter.reduce((prev, cur) => (prev > cur) ? prev : cur,0)
            maxinternet = avg_internet_quarter.reduce((prev, cur) => (prev > cur) ? prev : cur,0)

        }
    }else if( year >= 2018){
                let main = {
                    prop_sevice: 0.8,
                    amount: 0,
                    voice_m: 0,
                    voice_s: 0,
                    sms: 0,
                    mms: 0,
                    internet: 0,
                }
                let ontop = {
                    prop_sevice: 0.2,
                    amount: 0,
                    voice_m: 0,
                    voice_s: 0,
                    sms: 0,
                    mms: 0,
                    internet: 0,
                }
                let total = {
                    amount: 0,
                    voice_m: 0,
                    voice_s: 0,
                    sms: 0,
                    mms: 0,
                    internet: 0,
                }
                let data_in_unit = {
                    amount: [],
                    voice: [],
                    sms: [],
                    mms: [],
                    internet: []
                }
                //use normaldata
                if(state.ontop_proportion == 0) state.main_proportion == 100
                            // console.log('state.main_proportion',state.main_proportion,state.ontop_proportion)
                            let data_in_pro = []
                            for(let p =0;p<provider_id_list.length;p++){
                                data_in_pro[p] = []
                                data_in_unit.amount[p] = []
                                data_in_unit.voice[p] = []
                                data_in_unit.sms[p] = []
                                data_in_unit.mms[p] = []
                                data_in_unit.internet[p] = []
                                let count_mount = 0
                                var month_TH = []

                                for(let date = obj.date.start;date < obj.date.end ; date = moment(date).add(1,'M')){
                                    
                                    let yearDate = moment(date).add(543,'y').format('YYYY')
                                    let monthDate = month_th[moment(date).format('M')-1]
                                    let curmonth = moment(date).format('M-YYYY')
                                    month_TH.push(monthDate)
                                    
                                    let rowdatas = obj.qrydata.filter(item => item.monthly == curmonth && provider_id_list[p].includes(item.provider_id))
                                    for(let datagroup=0; datagroup<provider_id_list[p].length; datagroup++){
                                        let rowdata = rowdatas.filter(item =>  item.provider_id == provider_id_list[p][datagroup])
                                        console.log('curmonth',curmonth,'rowdata',rowdata)
                                        for(let r=0;r<rowdata.length;r++){
                                            if(rowdata.length !== 0){
                                                // console.log('curmonth',curmonth,'row',rowdata[r])
                                                if(rowdata[r].promotion_type === 'main'){
                                                    main.amount += rowdata[r].amount
                                                    main.voice_m += rowdata[r].vpm_avg
                                                    main.voice_s += rowdata[r].vpm_avg
                                                    main.sms += rowdata[r].sms_avg
                                                    main.mms += rowdata[r].mms_avg
                                                    main.internet += rowdata[r].internet_avg
                                                }else{
                                                    ontop.amount += rowdata[r].amount
                                                    ontop.voice_m += rowdata[r].vpm_avg
                                                    ontop.voice_s += rowdata[r].vpm_avg
                                                    ontop.sms += rowdata[r].sms_avg
                                                    ontop.mms += rowdata[r].mms_avg
                                                    ontop.internet += rowdata[r].internet_avg
                                                }
                                            }
                                            
                                        }
                                            total.voice_m = parseFloat((((main.voice_m/main.amount)*(state.main_proportion/100)) + ((ontop.voice_m/ontop.amount) *(state.ontop_proportion/100))).toFixed(3))
                                            total.sms = parseFloat((((main.sms/main.amount)*(state.main_proportion/100)) + ((ontop.sms/ontop.amount) *(state.ontop_proportion/100))).toFixed(3))
                                            total.mms = parseFloat((((main.mms/main.amount)*(state.main_proportion/100)) + ((ontop.mms/ontop.amount) *(state.ontop_proportion/100))).toFixed(3))
                                            total.internet = parseFloat((((main.internet/main.amount)*(state.main_proportion/100)) + ((ontop.internet/ontop.amount) *(state.ontop_proportion/100))).toFixed(3))
                                            total.amount = main.amount + ontop.amount
                                            if(total.amount !== 0){
                                                data_in_unit.amount[p].push(total.amount)
                                                data_in_unit.voice[p].push(total.voice_m)
                                                data_in_unit.sms[p].push(total.sms)
                                                data_in_unit.mms[p].push(total.mms)
                                                data_in_unit.internet[p].push(total.internet)
                                                data_in_pro[p].push({
                                                    avg_voice: total.voice_m,
                                                    avg_sms: total.sms,
                                                    avg_mms: total.mms,
                                                    avg_internet: total.internet
                                                })
                                            }
                                        // console.log('total.amount',total.amount)
                                        total = {
                                            amount: 0,
                                            voice_m: 0,
                                            voice_s: 0,
                                            sms: 0,
                                            mms: 0,
                                            internet: 0,
                                        }
                                        main = {
                                            amount: 0,
                                            voice_m: 0,
                                            voice_s: 0,
                                            sms: 0,
                                            mms: 0,
                                            internet: 0,
                                        }
                                        ontop = {
                                            amount: 0,
                                            voice_m: 0,
                                            voice_s: 0,
                                            sms: 0,
                                            mms: 0,
                                            internet: 0,
                                        }
                                        
                                    }
                                // console.log('---end provider_id_list--',provider_id_list[p])
                                count_mount += 1
                                }
                                // console.log('----endmonth----')
                            }
                            console.log('data_in_unit',data_in_unit)
                            
                            //amount data main + ontop of providers in same month 
                            let data_amount_in_month = data_in_unit.amount.reduce((preindex, curindex) => curindex.map((val, i) => (((preindex[i] || 0) + val)), []) )
                            console.log('data_amount_in_month',data_amount_in_month)

                            //เก็บค่าของแต่ละผู้ให้บริการในอารเรย์โดยเรียงลำดับตาม ผบ
                            let avg_in_voice = []
                            let avg_in_sms = []
                            let avg_in_mms = []
                            let avg_in_internet = []
                            let avg_voice = []
                            let avg_sms = []
                            let avg_mms = []
                            let avg_internet = []
                            let result_in_unit = []
                            let every_data = {
                                voice: [],
                                sms: [],
                                mms: [],
                                internet: []
                            }
                            state.dataTable = []
                                for(let p =0;p<provider_id_list.length;p++){
                                    // console.log('this loop')
                                    avg_in_voice[p] = []
                                    avg_in_sms[p] = []
                                    avg_in_mms[p] = []
                                    avg_in_internet[p] = []
                                    result_in_unit[p] = []
                                    
                                    let sum_voice = 0
                                    let sum_sms = 0
                                    let sum_mms = 0
                                    let sum_internet = 0
                                    let sum_amount = 0
                                    let data_result = {
                                        voice: 0,
                                        sms: 0,
                                        mms: 0,
                                        internet: 0
                                    }
                                    let count_month = 0
                                    for(let date = obj.date.start;date < obj.date.end ; date = moment(date).add(1,'M')){
                                        let curmonth = moment(date).format('M-YYYY')
                                                if(forminfo.weighting == 1){
                                                    //ถ่วงนน
                                                    console.log('data_in_unit.voice[p][count_month] * data_in_unit.amount[p][count_month]',p,count_month,'--',data_in_unit.voice[p][count_month],data_in_unit.amount[p][count_month])
                                                    sum_voice = data_in_unit.voice[p][count_month] * data_in_unit.amount[p][count_month]
                                                    sum_sms = data_in_unit.sms[p][count_month] * data_in_unit.amount[p][count_month]
                                                    sum_mms = data_in_unit.mms[p][count_month] * data_in_unit.amount[p][count_month]
                                                    sum_internet = data_in_unit.internet[p][count_month] * data_in_unit.amount[p][count_month]
                                                    sum_amount = data_amount_in_month[count_month]
        
                                                }else{
                                                    //ไม่ถ่วง
                                                    sum_voice = data_in_unit.voice[p][count_month]
                                                    sum_sms = data_in_unit.sms[p][count_month]
                                                    sum_mms = data_in_unit.mms[p][count_month]
                                                    sum_internet = data_in_unit.internet[p][count_month]
                                                }
                                        if(forminfo.weighting == 1){
                                            // console.log('ถ่วงง',sum_voice)
                                            console.log('sum_voice/sum_amount',sum_voice,'/',sum_amount)
                                            data_result.voice = sum_voice/sum_amount
                                            data_result.sms = sum_sms/sum_amount
                                            data_result.mms = sum_mms/sum_amount
                                            data_result.internet = sum_internet/sum_amount
                                        }else{
                                            //ไม่ถ่วง
                                            // console.log('ไม่ถ่วงง',sum_voice)
                                            console.log('sum_voice/data_in_unit.amount.length',sum_voice,data_in_unit.amount.length)
                                            data_result.voice = sum_voice/data_in_unit.amount.length
                                            data_result.sms = sum_sms/data_in_unit.amount.length
                                            data_result.mms= sum_mms/data_in_unit.amount.length
                                            data_result.internet = sum_internet/data_in_unit.amount.length
                                        }
                                        // console.log('data_result.voice',data_result.voice,'=',sum_voice,sum_amount)
                                        console.log('---end month ',curmonth)
                                        console.log('avg -> data_result.voice',data_result.voice)
                                        isNaN(data_result.voice) ? avg_in_voice[p].push(0) : avg_in_voice[p].push(data_result.voice)
                                        isNaN(data_result.sms) ? avg_in_sms[p].push(0) : avg_in_sms[p].push(data_result.sms)
                                        isNaN(data_result.mms) ? avg_in_mms[p].push(0) : avg_in_mms[p].push(data_result.mms)
                                        isNaN(data_result.internet) ? avg_in_internet[p].push(0) : avg_in_internet[p].push(data_result.internet)
                                        // avg_in_voice[p].push(data_result.voice)
                                        // avg_in_sms[p].push(data_result.sms)
                                        // avg_in_mms[p].push(data_result.mms)
                                        // avg_in_internet[p].push(data_result.internet)

                                        

                                        sum_voice = 0
                                        sum_sms = 0
                                        sum_mms = 0
                                        sum_internet = 0
                                        // sum_amount = 0
                                        data_result = {
                                            voice: 0,
                                            sms: 0,
                                            mms: 0,
                                            internet: 0
                                        }
                                        count_month += 1
                                        state.serviceTable = []
                                    }
                                    
                                    //กรองข้อมูลที่ไม่ใช่ 0 จะเป็นโชว์แค่เดือนที่มีข้อมูล
                                    avg_in_voice[p] = avg_in_voice[p].filter(item => item !== 0)
                                    console.log('not zero',avg_in_voice)
                                    // array of average each provider
                                    avg_voice.push(avg_in_voice[p].reduce((prev, cur) => prev + cur ,0) / avg_in_voice[p].length)
                                    avg_sms.push(avg_in_sms[p].reduce((prev, cur) => prev + cur ,0) / avg_in_sms[p].length)
                                    avg_mms.push(avg_in_mms[p].reduce((prev, cur) => prev + cur ,0) / avg_in_mms[p].length)
                                    avg_internet.push(avg_in_internet[p].reduce((prev, cur) => prev + cur ,0) / avg_in_internet[p].length)
                                    console.log('avg_voice',avg_voice)

                                    //get all value to find max
                                    every_data.voice.push(...avg_in_voice[p]) 
                                    every_data.sms.push(...avg_in_sms[p]) 
                                    every_data.mms.push(...avg_in_mms[p]) 
                                    every_data.internet.push(...avg_in_internet[p]) 

                                    //array order by voice,sms,mms,int of month 
                                    
                                    // this array value is every month of v,s,m,i 
                                    // result_in_unit[p].push(avg_in_voice[p])
                                    // result_in_unit[p].push(avg_in_sms[p])
                                    // result_in_unit[p].push(avg_in_mms[p])
                                    // result_in_unit[p].push(avg_in_internet[p])

                                    //ข้อมูลเฉลี่ยทั้งปี แต่ละผู้ให้บริการ เรียงตามลำดับ
                                    result_in_unit[p].push(avg_voice[p])
                                    result_in_unit[p].push(avg_sms[p])
                                    result_in_unit[p].push(avg_mms[p])
                                    result_in_unit[p].push(avg_internet[p])
        
                                    
                                    // console.log('avg_in_voice',avg_in_voice)
                                    if(forminfo.distinguish === 1){
                                        //chart
                                        state.charts.voice.series.push({
                                            name: provider_in_chart[p],
                                            data: avg_in_voice[p],
                                            color: provider_color_chart[p]
                                        })
                                        state.charts.sms.series.push({
                                            name: provider_in_chart[p],
                                            data: avg_in_sms[p],
                                            color: provider_color_chart[p]
                                        })
                                        state.charts.mms.series.push({
                                            name: provider_in_chart[p],
                                            data: avg_in_mms[p],
                                            color: provider_color_chart[p]
                                        })
                                        state.charts.internet.series.push({
                                            name: provider_in_chart[p],
                                            data: avg_in_internet[p],
                                            color: provider_color_chart[p]
                                        })
                                        state.charts.unit.series.push({
                                            name : provider_in_chart[p],
                                            data : result_in_unit[p],
                                            color: provider_color_chart[p]
                                        })
                                        state.charts.unit.xAxis.categories = ["Voice (บาท/นาที)","SMS (บาท/ข้อความ)","MMS (บาท/ข้อความ)","Internet (บาท/MB)"]
                                    
                                        console.log('result_in_unit',result_in_unit)

                                        if(forminfo.forecast){
                                            console.log('forecast')
                                            avg_in_voice[p].push(avg_voice[p])
                                            avg_in_sms[p].push(avg_sms[p])
                                            avg_in_mms[p].push(avg_mms[p])
                                            avg_in_internet[p].push(avg_internet[p])
                                        }

                                        //get dataTable 
                                        let dataTAble = {}
                                        if(avg_in_voice) state.serviceTable.push("Voice (บาท/นาที)")
                                        if(avg_in_sms) state.serviceTable.push("SMS (บาท/ข้อความ)")
                                        if(avg_in_mms) state.serviceTable.push("MMS (บาท/ข้อความ)")
                                        if(avg_in_internet) state.serviceTable.push("Internet (บาท/MB)")
                                        dataTAble["data"] = result_in_unit[p]
                                        dataTAble["providers_name"] = provider_in_chart[p]
                                        dataTAble["providers_color"] = provider_color_chart[p]
                                        state.dataTable.push(dataTAble)

                                        //max value of array
                                        maxvoice = every_data.voice.reduce((prev, cur) => (prev > cur) ? prev : cur,0)
                                        maxsms = every_data.sms.reduce((prev, cur) => (prev > cur) ? prev : cur,0)
                                        maxmms = every_data.mms.reduce((prev, cur) => (prev > cur) ? prev : cur,0)
                                        maxinternet = every_data.internet.reduce((prev, cur) => (prev > cur) ? prev : cur,0)
                                    }
        
                                }
                                console.log('avg_in_voice',avg_in_voice)

                                //avg of each provider in same month to one array
                                let avg_voice_months = avg_in_voice.reduce((preindex, curindex) => curindex.map((val, i) => (((preindex[i] || 0) + val)/avg_in_voice.length), []) )
                                let avg_sms_months = avg_in_sms.reduce((preindex, curindex) => curindex.map((val, i) => (((preindex[i] || 0) + val)/avg_in_sms.length), []) )
                                let avg_mms_months = avg_in_mms.reduce((preindex, curindex) => curindex.map((val, i) => (((preindex[i] || 0) + val)/avg_in_mms.length), []) )
                                let avg_internet_months = avg_in_internet.reduce((preindex, curindex) => curindex.map((val, i) => (((preindex[i] || 0) + val)/avg_in_internet.length), []) )
                                console.log('avg_voice_months',avg_voice_months)
                                //ไม่จำแนกผู้ให้บริการ ค่าเฉลี่ยของผบในแต่ละเดือน
                                if(forminfo.distinguish === 2){
                                    
                                    //chart
                                    state.charts.voice.series.push({
                                        name: "Voice (บาท/นาที)",
                                        data: avg_voice_months,
                                        color: ''
                                    })
                                    state.charts.sms.series.push({
                                        name: "SMS (บาท/ข้อความ)",
                                        data: avg_sms_months,
                                        color: ''
                                    })
                                    state.charts.mms.series.push({
                                        name: "MMS (บาท/ข้อความ)",
                                        data: avg_mms_months,
                                        color: ''
                                    })
                                    state.charts.internet.series.push({
                                        name: "Internet (บาท/MB)",
                                        data: avg_internet_months,
                                        color: ''
                                    })

                                    //all data every month in arr to one avg show in unit chart
                                    var all_avg_voice = avg_voice.reduce((prev,cur) => prev + cur ,0) / avg_voice.length
                                    var all_avg_sms = avg_sms.reduce((prev,cur) => prev + cur ,0) / avg_sms.length
                                    var all_avg_mms = avg_mms.reduce((prev,cur) => prev + cur ,0) / avg_mms.length
                                    var all_avg_internet = avg_internet.reduce((prev,cur) => prev + cur ,0) / avg_internet.length
                                    state.charts.unit.series = [
                                        {
                                            name : "Voice (บาท/นาที)",
                                            data : [all_avg_voice],
                                        },
                                        {
                                            name : "SMS (บาท/ข้อความ)",
                                            data : [all_avg_sms],
                                        },
                                        {
                                            name : "MMS (บาท/ข้อความ)",
                                            data : [all_avg_mms],
                                        },
                                        {
                                            name : "Internet (บาท/MB)",
                                            data : [all_avg_internet],
                                        },
                                    ]

                                    //dataTable
                                        state.dataTable = []
                                        state.serviceTable= ["Voice (บาท/นาที)","SMS (บาท/ข้อความ)","MMS (บาท/ข้อความ)","Internet (บาท/MB)"]
                                        let res = {}
                                            res["data"] = [all_avg_voice,all_avg_sms,all_avg_mms,all_avg_internet]
                                            res["providers_name"] = `ผู้ให้บริการทั้งหมด`
                                            res["providers_color"] = ''
                                        state.dataTable.push(res)
                                        // console.log(state.dataTable)

                                        //max value of array
                                        maxvoice = avg_voice_months.reduce((prev, cur) => (prev > cur) ? prev : cur,0)
                                        maxsms = avg_sms_months.reduce((prev, cur) => (prev > cur) ? prev : cur,0)
                                        maxmms = avg_mms_months.reduce((prev, cur) => (prev > cur) ? prev : cur,0)
                                        maxinternet = avg_internet_months.reduce((prev, cur) => (prev > cur) ? prev : cur,0)
                                }
                            
                            if(forminfo.forecast){
                                console.log('forecast')
                                if(forminfo.distinguish === 2){
                                    avg_voice_months.push(all_avg_voice)
                                    avg_sms_months.push(all_avg_sms)
                                    avg_mms_months.push(all_avg_mms)
                                    avg_internet_months.push(all_avg_internet)
                                }
                                month_TH.push('Forecast')
                            }

                            // state.charts.unit.xAxis.categories = ""
                            state.charts.voice.xAxis.categories = month_TH
                            state.charts.sms.xAxis.categories = month_TH
                            state.charts.mms.xAxis.categories = month_TH
                            state.charts.internet.xAxis.categories = month_TH
                            
                            

                            if(forminfo.barAvg == '1'){
                                state.charts.voice.series.push({
                                    name: 'Average',
                                    data: avg_voice_months,
                                    color: '#42f9ff'
                                })
                                state.charts.sms.series.push({
                                    name: 'Average',
                                    data: avg_sms_months,
                                    color: '#42f9ff'
                                })
                                state.charts.mms.series.push({
                                    name: 'Average',
                                    data: avg_mms_months,
                                    color: '#42f9ff'
                                })
                                state.charts.internet.series.push({
                                    name: 'Average',
                                    data: avg_internet_months,
                                    color: '#42f9ff'
                                })
                            }
                        // }
    }

    //แสดงเพดานกำกับ
    if(forminfo.graphLine == true){
    let graphLine = obj.serviceRate
    let year = moment(forminfo.type_data.month).format('YYYY')
    let start = moment('01-01-'+ year, 'DD-MM-YYYY')
    let end = moment(start).add(1,'Y')
        end = moment(end).subtract(1,'d')
    let voice_service_rate = 0
    let sms_service_rate = 0
    let mms_service_rate = 0
    let internet_service_rate = 0
    let service_name = ""
    for(let i = 0 ; i < graphLine.length ; i++){
        if((moment(graphLine[i].end_date).format('DD-MM-YYYY') >= moment(end).format('DD-MM-YYYY')) && (moment(graphLine[i].start_date).format('DD-MM-YYYY') <= moment(start).format('DD-MM-YYYY'))){
            voice_service_rate = graphLine[i].voice_service_rate
            sms_service_rate  = graphLine[i].sms_service_rate
            mms_service_rate  = graphLine[i].mms_service_rate
            internet_service_rate  = graphLine[i].internet_service_rate
            service_name = graphLine[i].service_name
        }
    }
    console.log('max',maxvoice,'voice_service_rate',voice_service_rate)
    state.charts.voice.yAxis = [{
        min: 0,
        title: {
            text: 'อัตราค่าบริการเฉลี่ย'
        },
        plotLines: [{
            value: voice_service_rate,
            color: 'red',
            dashStyle: 'line',
            width: 2,
            label: {
                text: `${service_name} ${voice_service_rate}`
            }
        },{
            value: maxvoice,
            color: 'red',
            dashStyle: 'shortdash',
            width: 2,
            label: {
                text: ``
            }
        }]
    }]
    state.charts.sms.yAxis = [{
        min: 0,
        title: {
            text: 'อัตราค่าบริการเฉลี่ย'
        },
        plotLines: [{
            value: sms_service_rate,
            color: 'red',
            dashStyle: 'line',
            width: 2,
            label: {
                text: `${service_name} ${sms_service_rate}`
            }
        },{
            value: maxsms,
            color: 'red',
            dashStyle: 'shortdash',
            width: 2,
            label: {
                text: ``
            }
        }]
    }]
    state.charts.mms.yAxis =[{
        min: 0,
        title: {
            text: 'อัตราค่าบริการเฉลี่ย'
        },
        plotLines: [{
            value: mms_service_rate,
            color: 'red',
            dashStyle: 'line',
            width: 2,
            label: {
                text: `${service_name} ${mms_service_rate}`
            }
        },{
            value: maxmms,
            color: 'red',
            dashStyle: 'shortdash',
            width: 2,
            label: {
                text: ``
            }
        }]
        
    }]
    state.charts.internet.yAxis =[{
        min: 0,
        title: {
            text: 'อัตราค่าบริการเฉลี่ย'
        },
        plotLines: [{
            value: internet_service_rate,
            color: 'red',
            dashStyle: 'line',
            width: 2,
            label: {
                text: `${service_name} ${internet_service_rate}`
            }
        },{
            value: maxinternet,
            color: 'red',
            dashStyle: 'shortdash',
            width: 2,
            label: {
                text: ``
            }
        }]
    }]
    }else {
        state.charts.voice.yAxis = [{
            min: 0,
            title: {
                text: 'อัตราค่าบริการเฉลี่ย'
            },
            plotLines: []
        }]
        state.charts.sms.yAxis = [{
            min: 0,
            title: {
                text: 'อัตราค่าบริการเฉลี่ย'
            },
            plotLines: []
        }]
        state.charts.mms.yAxis = [{
            min: 0,
            title: {
                text: 'อัตราค่าบริการเฉลี่ย'
            },
            plotLines: []
        }]
        state.charts.internet.yAxis = [{
            min: 0,
            title: {
                text: 'อัตราค่าบริการเฉลี่ย'
            },
            plotLines: []
        }]
    }

  },
  BETWEEN_QUARTER(state,obj){
    let quarter_yearfrom = moment(obj.forminfo.type_data.quarter_year_from).format("YYYY")
    let quarter_yearto = moment(obj.forminfo.type_data.quarter_year).format("YYYY")
    let quater_from = obj.forminfo.type_data.quarterfrom
    let quater_to = obj.forminfo.type_data.quarterto
    let title_start = "ณ ไตรมาสที่ "+quater_from+" ปี พ.ศ. "+(parseInt(quarter_yearfrom)+543)
    let title_end = " ถึงไตรมาสที่ "+quater_to+" ปี พ.ศ. "+(parseInt(quarter_yearto)+543)

    let graphLine_text = obj.forminfo.graphLine ? " และเปรียบเทียบกับอัตราอ้างอิงบนคลื่นความถี่ 2.1 GHz" : ""
    let distinguish_text = obj.forminfo.distinguish == 1 ? "จำแนกตาม" : "ของ"
    state.charts.unit.title.text = "ภาพรวมอัตราค่าบริการเฉลี่ยของบริการ ประเภทเสียง บริการ SMS/MMS และ บริการ Internet ของผู้ให้บริการ โทรศัพท์เคลื่อนที่ "+title_start+title_end
    state.charts.voice.title.text = "อัตราค่าบริการเฉลี่ยของบริการประเภทเสียง "+distinguish_text+"ผู้ให้บริการโทรศัพท์เคลื่อนที่ "+title_start+title_end+graphLine_text
    state.charts.sms.title.text = "อัตราค่าบริการเฉลี่ยของบริการ SMS "+distinguish_text+"ผู้ให้บริการโทรศัพท์เคลื่อนที่ "+title_start+title_end+graphLine_text
    state.charts.mms.title.text = "อัตราค่าบริการเฉลี่ยของบริการ MMS "+distinguish_text+"ผู้ให้บริการโทรศัพท์เคลื่อนที่ "+title_start+title_end+graphLine_text
    state.charts.internet.title.text = "อัตราค่าบริการเฉลี่ยของบริการ Internet "+distinguish_text+"ผู้ให้บริการโทรศัพท์เคลื่อนที่ "+title_start+title_end+graphLine_text
    
    state.charts.unit.series = []
    state.charts.voice.series = []
    state.charts.sms.series = []
    state.charts.mms.series = []
    state.charts.internet.series = []

    state.charts.unit.xAxis.categories = [""]
    state.charts.voice.xAxis.categories = [""]
    state.charts.sms.xAxis.categories = [""]
    state.charts.mms.xAxis.categories = [""]
    state.charts.internet.xAxis.categories = [""]

    let forminfo = obj.forminfo
    // let item_list = ''
    let p_list = []
    let provider_id_list = []
    let provider_in_chart = []
    let provider_color_chart = []
    let provider_list = obj.forminfo.list
    for(let p = 0 ; p < provider_list.length ; p ++){
        let provider_name = obj.forminfo.compare_type == 'group' ? provider_list[p].group_name_th : provider_list[p].brand_name
        let provider_color = obj.forminfo.compare_type == 'group' ? provider_list[p].group_color_code : provider_list[p].provider_color
        let provider_id = obj.forminfo.compare_type == 'group' ? JSON.parse(provider_list[p].group_company_list) : [provider_list[p].id]
        provider_id_list.push(provider_id)
        // provider_name_list.push(provider_name)
        // provider_color_list.push(provider_color)

        // item_list += `${item_group},`
        p_list.push(provider_id)
        provider_in_chart.push(provider_name)
        provider_color_chart.push(provider_color)
    }
    // console.log('p_list',p_list)
    // console.log('provider_in_chart',provider_in_chart)
    // console.log('provider_color_chart',provider_color_chart)
    let maxvoice = 0
    let maxsms = 0
    let maxmms = 0
    let maxinternet = 0
    let datafix = obj.fixdata
    let newdata_fix = {
        voice_m: 0,
        voice: 0,
        sms: 0,
        mms: 0,
        internet: 0,
        freq: [],
        name: ''
    }
   
    let FIX_provider_voice = []
    let FIX_provider_sms = []
    let FIX_provider_mms = []
    let FIX_provider_internet = []
    let avg_in_voice = []
    let avg_in_sms = []
    let avg_in_mms = []
    let avg_in_internet = []

    if(obj.fixdata){
        for(let p = 0 ; p < p_list.length ; p ++){
            let voice_array = []
            let sms_array = []
            let mms_array = []
            let internet_array = []
            FIX_provider_voice[p] = []
            FIX_provider_sms[p] = []
            FIX_provider_mms[p] = []
            FIX_provider_internet[p] = []
            avg_in_voice[p] = []
            avg_in_sms[p] = []
            avg_in_mms[p] = []
            avg_in_internet[p] = []
            let count_quarter = 1
            let fix_amount = {
                voice: 0,
                sms: 0,
                mms: 0,
                internet: 0
            }
            var quarter_th = []
            for(let date = obj.date.start;date < obj.date.end ; date = moment(date).add(1,'M')){
                let yearDate = moment(date).add(543,'y').format('YYYY')
                let quarterDate = (moment(date).format('MM'))/3
                let quarter_year_data = quarterDate+'Q'+yearDate
                let curmonth = moment(date).format('M-YYYY')

                let fixa = datafix.filter(item => item.monthly == curmonth && item.provider_id == p_list[p])
                if(fixa.length != 0){
                    for(let n=0;n<fixa.length;n++){
                        if(fixa[n].service_type == 'Voice'){
                            newdata_fix.voice += fixa[n].price_avg
                            fix_amount.voice += 1
                        }else if(fixa[n].service_type == 'SMS'){
                            newdata_fix.sms += fixa[n].price_avg
                            fix_amount.sms += 1
                        }else if(fixa[n].service_type == 'MMS'){
                            newdata_fix.mms += fixa[n].price_avg
                            fix_amount.mms += 1
                        }else if(fixa[n].service_type == 'Internet'){
                            newdata_fix.internet += fixa[n].price_avg
                            fix_amount.internet += 1
                        }
                        
                    }

                    // console.log('count_quarter here',count_quarter)
                    //sum a quarter 
                    if(count_quarter % 3 === 0 ){
                        voice_array.push(newdata_fix.voice/fix_amount.voice)
                        sms_array.push(newdata_fix.sms/fix_amount.sms)
                        mms_array.push(newdata_fix.mms/fix_amount.mms)
                        internet_array.push(newdata_fix.internet/fix_amount.internet)
                        //reset value after quarter
                        newdata_fix.voice = 0
                        newdata_fix.sms = 0
                        newdata_fix.mms = 0
                        newdata_fix.internet = 0
                        fix_amount = {
                            voice: 0,
                            sms: 0,
                            mms: 0,
                            internet: 0
                        }
                        quarter_th.push(quarter_year_data)

                    }
                    count_quarter += 1
                }
            }
            FIX_provider_voice[p] = voice_array
            FIX_provider_sms[p] = sms_array
            FIX_provider_mms[p] = mms_array
            FIX_provider_internet[p] = internet_array
            avg_in_voice[p].push(...voice_array)
            avg_in_sms[p].push(...sms_array)
            avg_in_mms[p].push(...mms_array)
            avg_in_internet[p].push(...internet_array)
        }
        console.log('quarter_th',quarter_th)
        var FIX_result_voices = FIX_provider_voice.filter(item => item != 0)
        var FIX_result_sms = FIX_provider_sms.filter(item => item != 0)
        var FIX_result_mms = FIX_provider_mms.filter(item => item != 0)
        var FIX_result_internet = FIX_provider_internet.filter(item => item != 0)
        
        state.charts.voice.xAxis.categories = quarter_th
        state.charts.sms.xAxis.categories = quarter_th
        state.charts.mms.xAxis.categories = quarter_th
        state.charts.internet.xAxis.categories = quarter_th
        console.log('FIXresult_voices',FIX_result_voices)
        console.log('avg_in_voice from fix',avg_in_voice)
    }
    if(quarter_yearfrom >= 2013 && quarter_yearto <= 2017){
        // console.log('use fix data')
        //แยก ผบ
        if(forminfo.distinguish === 1){
            state.charts.unit.xAxis.categories = ["Voice (บาท/นาที)","SMS (บาท/ข้อความ)","MMS (บาท/ข้อความ)","Internet (บาท/MB)"]
            let every_data = {
                voice: [],
                sms: [],
                mms: [],
                internet: []
            }
            let result_in_unit = []
            let dataTabe_result = []
            state.dataTable = []
            for(let p = 0 ; p < FIX_result_voices.length ; p ++){
                let unit_data = []
                result_in_unit[p] = []
                dataTabe_result[p] = []
                state.serviceTable = []
                state.charts.voice.series.push({
                    name: provider_in_chart[p],
                    data: FIX_result_voices[p],
                    color: provider_color_chart[p]
                })
                state.charts.sms.series.push({
                    name: provider_in_chart[p],
                    data: FIX_result_sms[p],
                    color: provider_color_chart[p]
                })
                state.charts.mms.series.push({
                    name: provider_in_chart[p],
                    data: FIX_result_mms[p],
                    color: provider_color_chart[p]
                })
                state.charts.internet.series.push({
                    name: provider_in_chart[p],
                    data: FIX_result_internet[p],
                    color: provider_color_chart[p]
                })

                //get AVG
                let voice_in_unit = FIX_result_voices[p].reduce((acc, item) => acc+item)
                let sms_in_unit = FIX_result_sms[p].reduce((acc, item) => acc+item)
                let mms_in_unit = FIX_result_mms[p].reduce((acc, item) => acc+item)
                let internet_in_unit = FIX_result_internet[p].reduce((acc, item) => acc+item)
                voice_in_unit /= FIX_result_voices[p].length
                sms_in_unit /= FIX_result_sms[p].length
                mms_in_unit /= FIX_result_mms[p].length
                internet_in_unit /= FIX_result_internet[p].length
                unit_data.push(parseFloat(voice_in_unit.toFixed(2)))
                unit_data.push(parseFloat(sms_in_unit.toFixed(2)))
                unit_data.push(parseFloat(mms_in_unit.toFixed(2)))
                unit_data.push(parseFloat(internet_in_unit.toFixed(2)))
                result_in_unit[p] = unit_data
                state.charts.unit.series.push({
                    name: provider_in_chart[p],
                    data: result_in_unit[p],
                    color: provider_color_chart[p]
                })

                //dataTable
                dataTabe_result[p].push(FIX_result_voices[p])
                dataTabe_result[p].push(FIX_result_sms[p])
                dataTabe_result[p].push(FIX_result_mms[p])
                dataTabe_result[p].push(FIX_result_internet[p])
                console.log('ds',dataTabe_result)
                let datarow = ["Voice (บาท/นาที)","SMS (บาท/ข้อความ)","MMS (บาท/ข้อความ)","Internet (บาท/MB)"]
                state.serviceTable = []
                for(let q=0;q<quarter_th.length;q++){
                    state.serviceTable.push(quarter_th[q])
                }
                for(let dt=0;dt<4;dt++){
                let res = {
                    data: [],
                    providers_name: [],
                    providers_color: []
                }
                    // res.providers_name = provider_in_chart[p]
                    res.providers_name = datarow[dt]
                    res.providers_color = provider_color_chart[p]
                    res.data = dataTabe_result[p][dt]
                    state.dataTable.push(res)
                }

                //get all value to find max
                every_data.voice.push(...FIX_result_voices[p]) 
                every_data.sms.push(...FIX_result_sms[p]) 
                every_data.mms.push(...FIX_result_mms[p]) 
                every_data.internet.push(...FIX_result_internet[p]) 
            }

            maxvoice = every_data.voice.reduce((prev, cur) => (prev > cur) ? prev : cur,0)
            maxsms = every_data.sms.reduce((prev, cur) => (prev > cur) ? prev : cur,0)
            maxmms = every_data.mms.reduce((prev, cur) => (prev > cur) ? prev : cur,0)
            maxinternet = every_data.internet.reduce((prev, cur) => (prev > cur) ? prev : cur,0)

            //show avg
            if(forminfo.barAvg == '1'){
                let result_voice_avg = FIX_result_voices.reduce((prev, cur) => cur.map((val, i) => (prev[i] || 0) + val/FIX_result_voices.length), []);
                let result_sms_avg = FIX_result_sms.reduce((prev, cur) => cur.map((val, i) => (prev[i] || 0) + val/FIX_result_sms.length), []);
                let result_mms_avg = FIX_result_mms.reduce((prev, cur) => cur.map((val, i) => (prev[i] || 0) + val/FIX_result_mms.length), []);
                let result_internet_avg = FIX_result_internet.reduce((prev, cur) => cur.map((val, i) => (prev[i] || 0) + val/FIX_result_internet.length), []);
                state.charts.voice.series.push({
                    name: 'Average',
                    data: result_voice_avg,
                    color: '#42f9ff'
                })
                state.charts.sms.series.push({
                    name: 'Average',
                    data: result_sms_avg,
                    color: '#42f9ff'
                })
                state.charts.mms.series.push({
                    name: 'Average',
                    data: result_mms_avg,
                    color: '#42f9ff'
                })
                state.charts.internet.series.push({
                    name: 'Average',
                    data: result_internet_avg,
                    color: '#42f9ff'
                })
            }

        }
        else{
            //filter item in array not 0
            for(let i=0;i<FIX_result_voices.length;i++){
                FIX_result_voices[i] = FIX_result_voices[i].filter(item => item !== 0)
                FIX_result_sms[i] = FIX_result_sms[i].filter(item => item !== 0)
                FIX_result_mms[i] = FIX_result_mms[i].filter(item => item !== 0)
                FIX_result_internet[i] = FIX_result_internet[i].filter(item => item !== 0)
            }
            console.log('FIX_result_voices',FIX_result_voices)

            let FIX_avg_voice_quarter = FIX_result_voices.reduce((preindex, curindex) => curindex.map((val, i) => (((preindex[i] || 0) + val)/FIX_result_voices.length), []) )
            let FIX_avg_sms_quarter = FIX_result_sms.reduce((preindex, curindex) => curindex.map((val, i) => (((preindex[i] || 0) + val)/FIX_result_sms.length), []) )
            let FIX_avg_mms_quarter = FIX_result_mms.reduce((preindex, curindex) => curindex.map((val, i) => (((preindex[i] || 0) + val)/FIX_result_mms.length), []) )
            let FIX_avg_internet_quarter = FIX_result_internet.reduce((preindex, curindex) => curindex.map((val, i) => (((preindex[i] || 0) + val)/FIX_result_internet.length), []) )
            console.log('FIX_avg_voice_quarter',FIX_avg_voice_quarter)
            state.charts.voice.series.push({
                name: 'Voice (บาท/นาที)',
                data: FIX_avg_voice_quarter,
                color: "#7bb5eb"
            })
            state.charts.sms.series.push({
                name:  'SMS (บาท/ข้อความ)',
                data: FIX_avg_sms_quarter,
                color: "#434348"
            })
            state.charts.mms.series.push({
                name: 'MMS (บาท/ข้อความ)',
                data: FIX_avg_mms_quarter,
                color: "#90ed7d"
            })
            state.charts.internet.series.push({
                name: 'Internet (บาท/MB)',
                data: FIX_avg_internet_quarter,
                color: "#f7a35c"
            })

            let all_voice = parseFloat((FIX_avg_voice_quarter.reduce((prev,cur) => prev+cur,0) / FIX_avg_voice_quarter.length).toFixed(3))
            let all_sms = parseFloat((FIX_avg_sms_quarter.reduce((prev,cur) => prev+cur,0) / FIX_avg_sms_quarter.length).toFixed(3))
            let all_mms = parseFloat((FIX_avg_mms_quarter.reduce((prev,cur) => prev+cur,0) / FIX_avg_mms_quarter.length).toFixed(3))
            let all_internet = parseFloat((FIX_avg_internet_quarter.reduce((prev,cur) => prev+cur,0) / FIX_avg_internet_quarter.length).toFixed(3))
            state.charts.unit.series = [
                {
                    name : 'Voice (บาท/นาที)',
                    data : [all_voice],
                    color: "#7bb5eb"
                },
                {
                    name : 'SMS (บาท/ข้อความ)',
                    data : [all_sms],
                    color: "#434348"
                },
                {
                    name : 'MMS (บาท/ข้อความ)',
                    data : [all_mms],
                    color: "#90ed7d"
                },
                {
                    name : 'Internet (บาท/MB)',
                    data : [all_internet],
                    color: "#f7a35c"
                },
            ]

            //dataTable
            let dataTabe_result = []
            dataTabe_result.push(FIX_avg_voice_quarter)
            dataTabe_result.push(FIX_avg_sms_quarter)
            dataTabe_result.push(FIX_avg_mms_quarter)
            dataTabe_result.push(FIX_avg_internet_quarter)
            // console.log('ds',dataTabe_result)
            let datarow = ["Voice (บาท/นาที)","SMS (บาท/ข้อความ)","MMS (บาท/ข้อความ)","Internet (บาท/MB)"]
            state.dataTable = []
            state.serviceTable = []
            for(let q=0;q<quarter_th.length;q++){
                state.serviceTable.push(quarter_th[q])
            }
            for(let dt=0;dt<4;dt++){
            let res = {
                data: [],
                providers_name: [],
                providers_color: []
            }
                res.providers_name = datarow[dt]
                res.data = dataTabe_result[dt]
                state.dataTable.push(res)
            }

            maxvoice = FIX_avg_voice_quarter.reduce((prev, cur) => (prev > cur) ? prev : cur,0)
            maxsms = FIX_avg_sms_quarter.reduce((prev, cur) => (prev > cur) ? prev : cur,0)
            maxmms = FIX_avg_mms_quarter.reduce((prev, cur) => (prev > cur) ? prev : cur,0)
            maxinternet = FIX_avg_internet_quarter.reduce((prev, cur) => (prev > cur) ? prev : cur,0)
        }
    }else if( quarter_yearfrom >= 2013 && quarter_yearto >= 2018){
        
        let data_in_unit = {
            amount: [],
            voice: [],
            sms: [],
            mms: [],
            internet: []
        }
        //use normaldata
            if(state.ontop_proportion == 0) state.main_proportion == 100
            // console.log('state.main_proportion',state.main_proportion,state.ontop_proportion)
            let data_in_pro = []
            let count_quarter = 0
            let count_item = 0

            for(let p =0;p<provider_id_list.length;p++){
                data_in_pro[p] = []
                data_in_unit.amount[p] = []
                data_in_unit.voice[p] = []
                data_in_unit.sms[p] = []
                data_in_unit.mms[p] = []
                data_in_unit.internet[p] = []
                let main = {
                    // prop_sevice: 0.8,
                    amount: 0,
                    voice_m: 0,
                    voice_s: 0,
                    sms: 0,
                    mms: 0,
                    internet: 0,
                }
                let ontop = {
                    // prop_sevice: 0.2,
                    amount: 0,
                    voice_m: 0,
                    voice_s: 0,
                    sms: 0,
                    mms: 0,
                    internet: 0,
                }
                let total = {
                    amount: 0,
                    voice: 0,
                    voice_m: 0,
                    voice_s: 0,
                    sms: 0,
                    mms: 0,
                    internet: 0,
                }
                var month_TH = []
                for(let date = obj.date.start;date < obj.date.end ; date = moment(date).add(1,'M')){
                    
                    let yearDate = moment(date).add(543,'y').format('YYYY')
                    // let monthDate = month_th[moment(date).format('M')-1]
                    let curyear = moment(date).format('M-YYYY')
                    let year = moment(date).format('YYYY')
                    count_quarter = parseInt(moment(date).format('M'))
                    let rowdatas = obj.qrydata.filter(item => item.monthly == curyear && provider_id_list[p].includes(item.provider_id))
                    // console.log('rowdatas',rowdatas)
                    if(year > '2017'){
                        for(let datagroup=0; datagroup<provider_id_list[p].length; datagroup++){
                            let rowdata = rowdatas.filter(item =>  item.provider_id == provider_id_list[p][datagroup])
                            
                                console.log('curyear',curyear,'rowdata',rowdata)

                                for(let r=0;r<rowdata.length;r++){
                                        // console.log('curyear',curyear,'row',rowdata[r])
                                        
                                        if(rowdata[r].promotion_type === 'main'){
                                            main.amount += rowdata[r].amount
                                            main.voice_m += rowdata[r].vpm_avg
                                            main.voice_s += rowdata[r].vps_avg
                                            main.sms += rowdata[r].sms_avg
                                            main.mms += rowdata[r].mms_avg
                                            main.internet += rowdata[r].internet_avg
                                        }else{
                                            ontop.amount += rowdata[r].amount
                                            ontop.voice_m += rowdata[r].vpm_avg
                                            ontop.voice_s += rowdata[r].vps_avg
                                            ontop.sms += rowdata[r].sms_avg
                                            ontop.mms += rowdata[r].mms_avg
                                            ontop.internet += rowdata[r].internet_avg
                                        }
                                }
                        }
                        console.log('count_quarter',count_quarter)

                        if(count_quarter % 3 == 0){
                            month_TH.push(`${count_quarter/3}Q${yearDate} `)

                            main.voice_m = main.voice_m + main.voice_s
                            ontop.voice_m = ontop.voice_m + ontop.voice_s
                            //สูตรอัตราค่าบริการเฉล่ียสาหรับบริการหนึ่งของผู้ ให้บริการ j
                                total.voice_m = parseFloat((((main.voice_m/main.amount)*(state.main_proportion/100)) + ((ontop.voice_m/ontop.amount) *(state.ontop_proportion/100))).toFixed(3))
                                total.sms = parseFloat((((main.sms/main.amount)*(state.main_proportion/100)) + ((ontop.sms/ontop.amount) *(state.ontop_proportion/100))).toFixed(3))
                                total.mms = parseFloat((((main.mms/main.amount)*(state.main_proportion/100)) + ((ontop.mms/ontop.amount) *(state.ontop_proportion/100))).toFixed(3))
                                total.internet = parseFloat((((main.internet/main.amount)*(state.main_proportion/100)) + ((ontop.internet/ontop.amount) *(state.ontop_proportion/100))).toFixed(3))
                                total.amount = main.amount + ontop.amount
                                // if(total.amount !== 0){
                                    data_in_unit.amount[p].push(total.amount)
                                    data_in_unit.voice[p].push(total.voice_m)
                                    data_in_unit.sms[p].push(total.sms)
                                    data_in_unit.mms[p].push(total.mms)
                                    data_in_unit.internet[p].push(total.internet)
                                    data_in_pro[p].push({
                                        avg_voice: total.voice_m,
                                        avg_sms: total.sms,
                                        avg_mms: total.mms,
                                        avg_internet: total.internet
                                    })
                                // }
                            console.log('p,count_quarter--main',provider_in_chart[p],count_quarter,main)
                            console.log('p,count_quarter--ontop',provider_in_chart[p],count_quarter,ontop)
                            main = {
                                    amount: 0,
                                    voice_m: 0,
                                    voice_s: 0,
                                    sms: 0,
                                    mms: 0,
                                    internet: 0,
                                }
                            ontop = {
                                amount: 0,
                                voice_m: 0,
                                voice_s: 0,
                                sms: 0,
                                mms: 0,
                                internet: 0,
                            
                            }
                            total = {
                                amount: 0,
                                voice_m: 0,
                                voice_s: 0,
                                sms: 0,
                                mms: 0,
                            }
                            count_item += 1
                        }

                    console.log('----end year----',curyear)
                    }else{
                        data_in_unit.voice[p] = []
                    }

                }
                
            }
            console.log('data_in_unit',data_in_unit)

            //amount data main + ontop of providers in same month 
            let data_amount_in_month = data_in_unit.amount.reduce((preindex, curindex) => curindex.map((val, i) => (((preindex[i] || 0) + val)), []) )
            console.log('data_amount_in_month',data_amount_in_month)

            let avg_voice = []
            let avg_sms = []
            let avg_mms = []
            let avg_internet = []
            let result_in_unit = []
            let every_data = {
                voice: [],
                sms: [],
                mms: [],
                internet: []
            }
            let filter_avg_voice = []
            let filter_avg_sms = []
            let filter_avg_mms = []
            let filter_avg_internet = []
            let dataTabe_result = []
            let ALL_QUARTER_TH = quarter_th.concat(month_TH)

            state.dataTable = []
                for(let p =0;p<provider_id_list.length;p++){
                    result_in_unit[p] = []
                    filter_avg_voice[p] = []
                    filter_avg_sms[p] = []
                    filter_avg_mms[p] = []
                    filter_avg_internet[p] = []
                    dataTabe_result[p] = []
                    let sum_voice = 0
                    let sum_sms = 0
                    let sum_mms = 0
                    let sum_internet = 0
                    let sum_amount = 0
                    let data_result = {
                        voice: 0,
                        sms: 0,
                        mms: 0,
                        internet: 0
                    }
                    for(let count_quarter = 0;count_quarter<data_in_unit.amount[p].length;count_quarter++){
                                if(forminfo.weighting == 1){
                                    //ถ่วงนน
                                    console.log('data_in_unit.voice[p][count_month] * data_in_unit.amount[p][count_month]',p,count_quarter,'--',data_in_unit.voice[p][count_quarter],data_in_unit.amount[p][count_quarter])
                                    sum_voice = data_in_unit.voice[p][count_quarter] * data_in_unit.amount[p][count_quarter]
                                    sum_sms = data_in_unit.sms[p][count_quarter] * data_in_unit.amount[p][count_quarter]
                                    sum_mms = data_in_unit.mms[p][count_quarter] * data_in_unit.amount[p][count_quarter]
                                    sum_internet = data_in_unit.internet[p][count_quarter] * data_in_unit.amount[p][count_quarter]
                                    sum_amount = data_amount_in_month[count_quarter]

                                }else{
                                    //ไม่ถ่วง
                                    sum_voice = data_in_unit.voice[p][count_quarter]
                                    sum_sms = data_in_unit.sms[p][count_quarter]
                                    sum_mms = data_in_unit.mms[p][count_quarter]
                                    sum_internet = data_in_unit.internet[p][count_quarter]
                                    console.log('tsum_voice',sum_voice)
                                }
                        if(forminfo.weighting == 1){
                            // console.log('ถ่วงง',sum_voice)
                            console.log('sum_voice/sum_amount',sum_voice,'/',sum_amount)
                            data_result.voice = sum_voice/sum_amount
                            data_result.sms = sum_sms/sum_amount
                            data_result.mms = sum_mms/sum_amount
                            data_result.internet = sum_internet/sum_amount
                        }else{
                            //ไม่ถ่วง
                            // console.log('ไม่ถ่วงง',sum_voice)
                            console.log('sum_voice/data_in_unit.amount.length',sum_voice,data_in_unit.amount.length)
                            data_result.voice = sum_voice/data_in_unit.amount.length
                            data_result.sms = sum_sms/data_in_unit.amount.length
                            data_result.mms= sum_mms/data_in_unit.amount.length
                            data_result.internet = sum_internet/data_in_unit.amount.length
                        }
                        // console.log('data_result.voice',data_result.voice,'=',sum_voice,sum_amount)
                        console.log('---end year ',count_quarter,'p',provider_in_chart[p])
                        console.log('avg -> data_result.voice',data_result.voice)
                        isNaN(data_result.voice) ? avg_in_voice[p].push(0) : avg_in_voice[p].push(data_result.voice)
                        isNaN(data_result.sms) ? avg_in_sms[p].push(0) : avg_in_sms[p].push(data_result.sms)
                        isNaN(data_result.mms) ? avg_in_mms[p].push(0) : avg_in_mms[p].push(data_result.mms)
                        isNaN(data_result.internet) ? avg_in_internet[p].push(0) : avg_in_internet[p].push(data_result.internet)
                        
                        sum_voice = 0
                        sum_sms = 0
                        sum_mms = 0
                        sum_internet = 0
                        // sum_amount = 0
                        data_result = {
                            voice: 0,
                            sms: 0,
                            mms: 0,
                            internet: 0
                        }
                        // count_quarter += 1
                        state.serviceTable = []
                    }

                    console.log('avg_in_voice',avg_in_voice)
                    //กรองข้อมูลที่ไม่ใช่ 0 จะเป็นโชว์แค่เดือนที่มีข้อมูล
                    filter_avg_voice[p] = avg_in_voice[p]
                    filter_avg_sms[p] = avg_in_sms[p]
                    filter_avg_mms[p] = avg_in_mms[p]
                    filter_avg_internet[p] = avg_in_internet[p]
                    filter_avg_voice[p] = filter_avg_voice[p].filter(item => item !== 0)
                    filter_avg_sms[p] = filter_avg_sms[p].filter(item => item !== 0)
                    filter_avg_mms[p] = filter_avg_mms[p].filter(item => item !== 0)
                    filter_avg_internet[p] = filter_avg_internet[p].filter(item => item !== 0)
                    console.log('filter_avg',filter_avg_voice[p])
                    // let ll = filter_avg_voice[p].length
                    console.log('count_item',count_item)
                    // array of average each provider
                    avg_voice.push(avg_in_voice[p].reduce((prev, cur) => prev + cur ,0) / filter_avg_voice[p].length)
                    avg_sms.push(avg_in_sms[p].reduce((prev, cur) => prev + cur ,0) / filter_avg_sms[p].length)
                    avg_mms.push(avg_in_mms[p].reduce((prev, cur) => prev + cur ,0) / filter_avg_mms[p].length)
                    avg_internet.push(avg_in_internet[p].reduce((prev, cur) => prev + cur ,0) / filter_avg_internet[p].length)
                    console.log('avg_voice',avg_voice)

                    //get all value to find max
                    every_data.voice.push(...avg_in_voice[p]) 
                    every_data.sms.push(...avg_in_sms[p]) 
                    every_data.mms.push(...avg_in_mms[p]) 
                    every_data.internet.push(...avg_in_internet[p]) 

                    //ข้อมูลเฉลี่ยทั้งปี แต่ละผู้ให้บริการ เรียงตามลำดับ
                    result_in_unit[p].push(avg_voice[p])
                    result_in_unit[p].push(avg_sms[p])
                    result_in_unit[p].push(avg_mms[p])
                    result_in_unit[p].push(avg_internet[p])

                    // console.log('avg_in_voice',avg_in_voice)
                    if(forminfo.distinguish === 1){
                        
                        //chart
                        state.charts.voice.series.push({
                            name: provider_in_chart[p],
                            data: avg_in_voice[p],
                            color: provider_color_chart[p]
                        })
                        state.charts.sms.series.push({
                            name: provider_in_chart[p],
                            data: avg_in_sms[p],
                            color: provider_color_chart[p]
                        })
                        state.charts.mms.series.push({
                            name: provider_in_chart[p],
                            data: avg_in_mms[p],
                            color: provider_color_chart[p]
                        })
                        state.charts.internet.series.push({
                            name: provider_in_chart[p],
                            data: avg_in_internet[p],
                            color: provider_color_chart[p]
                        })
                        state.charts.unit.series.push({
                            name : provider_in_chart[p],
                            data : result_in_unit[p],
                            color: provider_color_chart[p]
                        })
                        state.charts.unit.xAxis.categories = ["Voice (บาท/นาที)","SMS (บาท/ข้อความ)","MMS (บาท/ข้อความ)","Internet (บาท/MB)"]
                    
                        if(forminfo.forecast){
                            console.log('forecast')
                            avg_in_voice[p].push(avg_voice[p])
                            avg_in_sms[p].push(avg_sms[p])
                            avg_in_mms[p].push(avg_mms[p])
                            avg_in_internet[p].push(avg_internet[p])
                        }

                        console.log('result_in_unit',result_in_unit)
                        
                        //dataTable
                        dataTabe_result[p].push(avg_in_voice[p])
                        dataTabe_result[p].push(avg_in_sms[p])
                        dataTabe_result[p].push(avg_in_mms[p])
                        dataTabe_result[p].push(avg_in_internet[p])
                        console.log('ds',dataTabe_result)
                        let datarow = ["Voice (บาท/นาที)","SMS (บาท/ข้อความ)","MMS (บาท/ข้อความ)","Internet (บาท/MB)"]
                        state.serviceTable = []
                        for(let y=0;y<ALL_QUARTER_TH.length;y++){
                            state.serviceTable.push(ALL_QUARTER_TH[y])
                        }
                        for(let dt=0;dt<4;dt++){
                        let res = {
                            data: [],
                            providers_name: [],
                            providers_color: []
                        }
                            // res.providers_name = provider_in_chart[p]
                            res.providers_name = datarow[dt]
                            res.providers_color = provider_color_chart[p]
                            res.data = dataTabe_result[p][dt]
                            state.dataTable.push(res)
                        }
                        console.log(state.dataTable)

                        //max value of array
                        maxvoice = every_data.voice.reduce((prev, cur) => (prev > cur) ? prev : cur,0)
                        maxsms = every_data.sms.reduce((prev, cur) => (prev > cur) ? prev : cur,0)
                        maxmms = every_data.mms.reduce((prev, cur) => (prev > cur) ? prev : cur,0)
                        maxinternet = every_data.internet.reduce((prev, cur) => (prev > cur) ? prev : cur,0)
                    }

                }
                console.log('avg_in_voice',avg_in_voice)

                //avg of each provider in same month to one array
                let avg_voice_months = avg_in_voice.reduce((preindex, curindex) => curindex.map((val, i) => (((preindex[i] || 0) + val)/avg_in_voice.length), []) )
                let avg_sms_months = avg_in_sms.reduce((preindex, curindex) => curindex.map((val, i) => (((preindex[i] || 0) + val)/avg_in_sms.length), []) )
                let avg_mms_months = avg_in_mms.reduce((preindex, curindex) => curindex.map((val, i) => (((preindex[i] || 0) + val)/avg_in_mms.length), []) )
                let avg_internet_months = avg_in_internet.reduce((preindex, curindex) => curindex.map((val, i) => (((preindex[i] || 0) + val)/avg_in_internet.length), []) )
                console.log('avg_voice_months',avg_voice_months)
                //ไม่จำแนกผู้ให้บริการ ค่าเฉลี่ยของผบในแต่ละเดือน
                if(forminfo.distinguish === 2){
                    
                    //chart
                    state.charts.voice.series.push({
                        name: "Voice (บาท/นาที)",
                        data: avg_voice_months,
                        color: ''
                    })
                    state.charts.sms.series.push({
                        name: "SMS (บาท/ข้อความ)",
                        data: avg_sms_months,
                        color: ''
                    })
                    state.charts.mms.series.push({
                        name: "MMS (บาท/ข้อความ)",
                        data: avg_mms_months,
                        color: ''
                    })
                    state.charts.internet.series.push({
                        name: "Internet (บาท/MB)",
                        data: avg_internet_months,
                        color: ''
                    })

                    //all data every month in arr to one avg show in unit chart
                    var all_avg_voice = avg_voice.reduce((prev,cur) => prev + cur ,0) / avg_voice.length
                    var all_avg_sms = avg_sms.reduce((prev,cur) => prev + cur ,0) / avg_sms.length
                    var all_avg_mms = avg_mms.reduce((prev,cur) => prev + cur ,0) / avg_mms.length
                    var all_avg_internet = avg_internet.reduce((prev,cur) => prev + cur ,0) / avg_internet.length
                    state.charts.unit.series = [
                        {
                            name : "Voice (บาท/นาที)",
                            data : [all_avg_voice],
                        },
                        {
                            name : "SMS (บาท/ข้อความ)",
                            data : [all_avg_sms],
                        },
                        {
                            name : "MMS (บาท/ข้อความ)",
                            data : [all_avg_mms],
                        },
                        {
                            name : "Internet (บาท/MB)",
                            data : [all_avg_internet],
                        },
                    ]

                        //dataTable
                        let dataTabe_result = []
                        dataTabe_result.push(avg_voice_months)
                        dataTabe_result.push(avg_sms_months)
                        dataTabe_result.push(avg_mms_months)
                        dataTabe_result.push(avg_internet_months)
                        // console.log('ds',dataTabe_result)
                        let datarow = ["Voice (บาท/นาที)","SMS (บาท/ข้อความ)","MMS (บาท/ข้อความ)","Internet (บาท/MB)"]
                        state.dataTable = []
                        state.serviceTable = []
                        for(let m=0;m<ALL_QUARTER_TH.length;m++){
                            state.serviceTable.push(ALL_QUARTER_TH[m])
                        }
                        for(let dt=0;dt<4;dt++){
                        let res = {
                            data: [],
                            providers_name: [],
                            providers_color: []
                        }
                            res.providers_name = datarow[dt]
                            res.data = dataTabe_result[dt]
                            state.dataTable.push(res)
                        }

                        //max value of array
                        maxvoice = avg_voice_months.reduce((prev, cur) => (prev > cur) ? prev : cur,0)
                        maxsms = avg_sms_months.reduce((prev, cur) => (prev > cur) ? prev : cur,0)
                        maxmms = avg_mms_months.reduce((prev, cur) => (prev > cur) ? prev : cur,0)
                        maxinternet = avg_internet_months.reduce((prev, cur) => (prev > cur) ? prev : cur,0)
                }

            if(forminfo.forecast){
                console.log('forecast')
                if(forminfo.distinguish === 2){
                    avg_voice_months.push(all_avg_voice)
                    avg_sms_months.push(all_avg_sms)
                    avg_mms_months.push(all_avg_mms)
                    avg_internet_months.push(all_avg_internet)
                }
                month_TH.push('Forecast')
            }
            if(forminfo.barAvg == '1'){
                state.charts.voice.series.push({
                    name: 'Average',
                    data: avg_voice_months,
                    color: '#42f9ff'
                })
                state.charts.sms.series.push({
                    name: 'Average',
                    data: avg_sms_months,
                    color: '#42f9ff'
                })
                state.charts.mms.series.push({
                    name: 'Average',
                    data: avg_mms_months,
                    color: '#42f9ff'
                })
                state.charts.internet.series.push({
                    name: 'Average',
                    data: avg_internet_months,
                    color: '#42f9ff'
                })
            }
            console.log('m',ALL_QUARTER_TH)
            // state.charts.unit.xAxis.categories = ""
            state.charts.voice.xAxis.categories = ALL_QUARTER_TH
            state.charts.sms.xAxis.categories = ALL_QUARTER_TH
            state.charts.mms.xAxis.categories = ALL_QUARTER_TH
            state.charts.internet.xAxis.categories = ALL_QUARTER_TH
                    
    }

    //แสดงเพดานกำกับ
    if(forminfo.graphLine == true){
        let graphLine = obj.serviceRate
        let year = moment(forminfo.type_data.month).format('YYYY')
        let start = moment('01-01-'+ year, 'DD-MM-YYYY')
        let end = moment(start).add(1,'Y')
            end = moment(end).subtract(1,'d')
        let voice_service_rate = 0
        let sms_service_rate = 0
        let mms_service_rate = 0
        let internet_service_rate = 0
        let service_name = ""
        for(let i = 0 ; i < graphLine.length ; i++){
            if((moment(graphLine[i].end_date).format('DD-MM-YYYY') >= moment(end).format('DD-MM-YYYY')) && (moment(graphLine[i].start_date).format('DD-MM-YYYY') <= moment(start).format('DD-MM-YYYY'))){
                voice_service_rate = graphLine[i].voice_service_rate
                sms_service_rate  = graphLine[i].sms_service_rate
                mms_service_rate  = graphLine[i].mms_service_rate
                internet_service_rate  = graphLine[i].internet_service_rate
                service_name = graphLine[i].service_name
            }
        }
        console.log('max',maxvoice,'voice_service_rate',voice_service_rate)
        state.charts.voice.yAxis = [{
            min: 0,
            title: {
                text: 'อัตราค่าบริการเฉลี่ย'
            },
            plotLines: [{
                value: voice_service_rate,
                color: 'red',
                dashStyle: 'line',
                width: 2,
                label: {
                    text: `${service_name} ${voice_service_rate}`
                }
            },{
                value: maxvoice,
                color: 'red',
                dashStyle: 'shortdash',
                width: 2,
                label: {
                    text: ``
                }
            }]
        }]
        state.charts.sms.yAxis = [{
            min: 0,
            title: {
                text: 'อัตราค่าบริการเฉลี่ย'
            },
            plotLines: [{
                value: sms_service_rate,
                color: 'red',
                dashStyle: 'line',
                width: 2,
                label: {
                    text: `${service_name} ${sms_service_rate}`
                }
            },{
                value: maxsms,
                color: 'red',
                dashStyle: 'shortdash',
                width: 2,
                label: {
                    text: ``
                }
            }]
        }]
        state.charts.mms.yAxis =[{
            min: 0,
            title: {
                text: 'อัตราค่าบริการเฉลี่ย'
            },
            plotLines: [{
                value: mms_service_rate,
                color: 'red',
                dashStyle: 'line',
                width: 2,
                label: {
                    text: `${service_name} ${mms_service_rate}`
                }
            },{
                value: maxmms,
                color: 'red',
                dashStyle: 'shortdash',
                width: 2,
                label: {
                    text: ``
                }
            }]
            
        }]
        state.charts.internet.yAxis =[{
            min: 0,
            title: {
                text: 'อัตราค่าบริการเฉลี่ย'
            },
            plotLines: [{
                value: internet_service_rate,
                color: 'red',
                dashStyle: 'line',
                width: 2,
                label: {
                    text: `${service_name} ${internet_service_rate}`
                }
            },{
                value: maxinternet,
                color: 'red',
                dashStyle: 'shortdash',
                width: 2,
                label: {
                    text: ``
                }
            }]
        }]
    }else {
        state.charts.voice.yAxis = [{
            min: 0,
            title: {
                text: 'อัตราค่าบริการเฉลี่ย'
            },
            plotLines: []
        }]
        state.charts.sms.yAxis = [{
            min: 0,
            title: {
                text: 'อัตราค่าบริการเฉลี่ย'
            },
            plotLines: []
        }]
        state.charts.mms.yAxis = [{
            min: 0,
            title: {
                text: 'อัตราค่าบริการเฉลี่ย'
            },
            plotLines: []
        }]
        state.charts.internet.yAxis = [{
            min: 0,
            title: {
                text: 'อัตราค่าบริการเฉลี่ย'
            },
            plotLines: []
        }]
    }
    
  },
  DATA_NOT_FOUND(state,status){
      state.showDataNotFound = status
  },
  SET_NOT_CLASSIFY_CHART(state,obj){
      state.charts = {}
      state.charts.unit = {
        chart: {
            type: 'column'
        },
        title: {
            text: obj.title
        },
        subtitle: {
            text: ''
        },
        xAxis: {
            categories: obj.categories,
            crosshair: true
        },
        yAxis: {
            min: 0,
            title: {
                text: obj.yAxis
            }
        },
        tooltip: {
            headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
            pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
                '<td style="padding:0"><b>{point.y:.2f} บาท</b></td></tr>',
            footerFormat: '</table>',
            shared: true,
            useHTML: true
        },
        plotOptions: {
            column: {
                borderWidth: 0,
                dataLabels: {
                    enabled: true
                }
            }
        },
        series: obj.series,
        credits: {
            enabled: false
        }
      }
  }
};

export const Report = {
    namespaced: true,
    state,
    actions,
    mutations
};